function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// kapigen version 0.1.12
// tslint:disable
import { google } from "./generated/google";
import { PrivatedModerationStatusWireFormat3 as KaggleSdkAbusePrivatedModerationStatusWireFormat3 } from "./generated/abuse";
import { CategoryWireFormat3 as KaggleSdkCommonCategoryWireFormat3, CroppedImageUploadWireFormat3 as KaggleSdkCommonCroppedImageUploadWireFormat3, ImageWireFormat3 as KaggleSdkCommonImageWireFormat3, PageMessageWireFormat3 as KaggleSdkCommonPageMessageWireFormat3, SimpleUserDtoWireFormat3 as KaggleSdkCommonSimpleUserDtoWireFormat3, VoteButtonWireFormat3 as KaggleSdkCommonVoteButtonWireFormat3, VoteTypeWireFormat3 as KaggleSdkCommonVoteTypeWireFormat3 } from "./generated/common";
import { EnvironmentRenderTypeWireFormat3 as KaggleSdkCompetitionsEnvironmentRenderTypeWireFormat3, EpisodeTypeWireFormat3 as KaggleSdkCompetitionsEpisodeTypeWireFormat3, HostSegmentWireFormat3 as KaggleSdkCompetitionsHostSegmentWireFormat3 } from "./generated/competitions";
import { DatabundleOwnerInfoWireFormat3 as KaggleSdkDatasetsDatabundlesDatabundleOwnerInfoWireFormat3, DatabundleVerificationInfoWireFormat3 as KaggleSdkDatasetsDatabundlesDatabundleVerificationInfoWireFormat3, DatabundleVersionWireFormat3 as KaggleSdkDatasetsDatabundlesDatabundleVersionWireFormat3, DatabundleWireFormat3 as KaggleSdkDatasetsDatabundlesDatabundleWireFormat3, DataSourceWireFormat3 as KaggleSdkDatasetsDatabundlesDataSourceWireFormat3, DirectoryWireFormat3 as KaggleSdkDatasetsDatabundlesDirectoryWireFormat3, FileWireFormat3 as KaggleSdkDatasetsDatabundlesFileWireFormat3, GithubInfoWireFormat3 as KaggleSdkDatasetsDatabundlesGithubInfoWireFormat3, RemoteUrlInfoWireFormat3 as KaggleSdkDatasetsDatabundlesRemoteUrlInfoWireFormat3 } from "./generated/datasets/databundles";
import { NewTopicDtoWireFormat3 as KaggleSdkDiscussionsNewTopicDtoWireFormat3, TopicListDtoWireFormat3 as KaggleSdkDiscussionsTopicListDtoWireFormat3 } from "./generated/discussions";
import { LearnSeriesNavigationDataWireFormat3 as KaggleSdkEducationLearnSeriesNavigationDataWireFormat3 } from "./generated/education";
import { CollaboratorListWireFormat3 as KaggleSdkUsersCollaboratorListWireFormat3, CollaboratorTypeWireFormat3 as KaggleSdkUsersCollaboratorTypeWireFormat3, MedalWireFormat3 as KaggleSdkUsersMedalWireFormat3, UserAchievementTierWireFormat3 as KaggleSdkUsersUserAchievementTierWireFormat3, UserAvatarWireFormat3 as KaggleSdkUsersUserAvatarWireFormat3, UserPlanWireFormat3 as KaggleSdkUsersUserPlanWireFormat3, UserWireFormat3 as KaggleSdkUsersUserWireFormat3 } from "./generated/users";
import { createClient, // @ts-ignore: could be unused if no generated proto3 code.
jsonStringToDuration, CanonicalError, CanonicalErrorCode, createRequestClient, getAntiForgeryToken } from "./requestClientInternal";
export { createClient, CanonicalError, CanonicalErrorCode, createRequestClient, getAntiForgeryToken,  };
export var Kaggle;
(function(Kaggle1) {
    var Sdk1;
    (function(Sdk) {
        var Datasets1;
        (function(Datasets) {
            var DataViewer1;
            (function(DataViewer) {
                var Protos1;
                (function(Protos) {
                    var DateTimeFilter1;
                    (function(DateTimeFilter) {
                        var DateTimeOperator;
                        (function(DateTimeOperator) {
                            DateTimeOperator["EQUALS"] = "equals";
                            DateTimeOperator["LESS_THAN"] = "lessThan";
                            DateTimeOperator["GREATER_THAN"] = "greaterThan";
                            DateTimeOperator["LESS_EQUALS"] = "lessEquals";
                            DateTimeOperator["GREATER_EQUALS"] = "greaterEquals";
                        })(DateTimeOperator = DateTimeFilter.DateTimeOperator || (DateTimeFilter.DateTimeOperator = {}));
                        var DateTimeOperatorWireFormat3 = DateTimeFilter.DateTimeOperatorWireFormat3 = {
                            toJson: function toJson(enumVal) {
                                switch(enumVal){
                                    case DateTimeOperator.EQUALS:
                                    case 0:
                                    default:
                                        return "EQUALS";
                                    case DateTimeOperator.LESS_THAN:
                                    case 1:
                                        return "LESS_THAN";
                                    case DateTimeOperator.GREATER_THAN:
                                    case 2:
                                        return "GREATER_THAN";
                                    case DateTimeOperator.LESS_EQUALS:
                                    case 3:
                                        return "LESS_EQUALS";
                                    case DateTimeOperator.GREATER_EQUALS:
                                    case 4:
                                        return "GREATER_EQUALS";
                                }
                            }
                        };
                    })(DateTimeFilter1 = Protos.DateTimeFilter || (Protos.DateTimeFilter = {}));
                    var NumericFilter1;
                    (function(NumericFilter) {
                        var NumericOperator;
                        (function(NumericOperator) {
                            NumericOperator["EQUALS"] = "equals";
                            NumericOperator["LESS_THAN"] = "lessThan";
                            NumericOperator["GREATER_THAN"] = "greaterThan";
                            NumericOperator["LESS_EQUALS"] = "lessEquals";
                            NumericOperator["GREATER_EQUALS"] = "greaterEquals";
                        })(NumericOperator = NumericFilter.NumericOperator || (NumericFilter.NumericOperator = {}));
                        var NumericOperatorWireFormat3 = NumericFilter.NumericOperatorWireFormat3 = {
                            toJson: function toJson(enumVal) {
                                switch(enumVal){
                                    case NumericOperator.EQUALS:
                                    case 0:
                                    default:
                                        return "EQUALS";
                                    case NumericOperator.LESS_THAN:
                                    case 1:
                                        return "LESS_THAN";
                                    case NumericOperator.GREATER_THAN:
                                    case 2:
                                        return "GREATER_THAN";
                                    case NumericOperator.LESS_EQUALS:
                                    case 3:
                                        return "LESS_EQUALS";
                                    case NumericOperator.GREATER_EQUALS:
                                    case 4:
                                        return "GREATER_EQUALS";
                                }
                            }
                        };
                    })(NumericFilter1 = Protos.NumericFilter || (Protos.NumericFilter = {}));
                    var StringFilter1;
                    (function(StringFilter) {
                        var StringOperator;
                        (function(StringOperator) {
                            StringOperator["IN"] = "in";
                            StringOperator["EQUALS"] = "equals";
                            StringOperator["CONTAINS"] = "contains";
                        })(StringOperator = StringFilter.StringOperator || (StringFilter.StringOperator = {}));
                        var StringOperatorWireFormat3 = StringFilter.StringOperatorWireFormat3 = {
                            toJson: function toJson(enumVal) {
                                switch(enumVal){
                                    case StringOperator.IN:
                                    case 0:
                                    default:
                                        return "IN";
                                    case StringOperator.EQUALS:
                                    case 1:
                                        return "EQUALS";
                                    case StringOperator.CONTAINS:
                                    case 2:
                                        return "CONTAINS";
                                }
                            }
                        };
                    })(StringFilter1 = Protos.StringFilter || (Protos.StringFilter = {}));
                    var AndFilterWireFormat3 = Protos.AndFilterWireFormat3 = {
                        toJson: function toJson(message) {
                            var wireFormat = _objectSpread({}, message);
                            if (message === null || message === void 0 ? void 0 : message.filters) {
                                wireFormat.filters = message.filters.map(function(i) {
                                    return Kaggle.Sdk.Datasets.DataViewer.Protos.FilterWireFormat3.toJson(i);
                                });
                            }
                            return wireFormat;
                        }
                    };
                    var BooleanFilterWireFormat3 = Protos.BooleanFilterWireFormat3 = {
                        toJson: function toJson(message) {
                            return message;
                        }
                    };
                    var ColumnWireFormat3 = Protos.ColumnWireFormat3 = {
                        toJson: function toJson(message) {
                            return message;
                        }
                    };
                    var ColumnFilterWireFormat3 = Protos.ColumnFilterWireFormat3 = {
                        toJson: function toJson(message) {
                            var wireFormat = _objectSpread({}, message);
                            if (message === null || message === void 0 ? void 0 : message.column) {
                                wireFormat.column = Kaggle.Sdk.Datasets.DataViewer.Protos.ColumnWireFormat3.toJson(message.column);
                            }
                            if (message === null || message === void 0 ? void 0 : message.booleanFilter) {
                                wireFormat.booleanFilter = Kaggle.Sdk.Datasets.DataViewer.Protos.BooleanFilterWireFormat3.toJson(message.booleanFilter);
                            }
                            if (message === null || message === void 0 ? void 0 : message.numericFilter) {
                                wireFormat.numericFilter = Kaggle.Sdk.Datasets.DataViewer.Protos.NumericFilterWireFormat3.toJson(message.numericFilter);
                            }
                            if (message === null || message === void 0 ? void 0 : message.dateTimeFilter) {
                                wireFormat.dateTimeFilter = Kaggle.Sdk.Datasets.DataViewer.Protos.DateTimeFilterWireFormat3.toJson(message.dateTimeFilter);
                            }
                            if (message === null || message === void 0 ? void 0 : message.stringFilter) {
                                wireFormat.stringFilter = Kaggle.Sdk.Datasets.DataViewer.Protos.StringFilterWireFormat3.toJson(message.stringFilter);
                            }
                            return wireFormat;
                        }
                    };
                    var ConstantFilterWireFormat3 = Protos.ConstantFilterWireFormat3 = {
                        toJson: function toJson(message) {
                            return message;
                        }
                    };
                    var defaultDataRaw = {
                        data: "",
                        totalBytes: 0,
                        previewBytes: 0
                    };
                    var DataRawWireFormat3 = Protos.DataRawWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            var message = _objectSpread({}, defaultDataRaw, wireFormat);
                            if (wireFormat) {
                                message.type = Kaggle.Sdk.Datasets.DataViewer.Protos.DataRawTypeWireFormat3.fromJson(wireFormat.type);
                            }
                            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalBytes) {
                                message.totalBytes = parseInt(wireFormat.totalBytes);
                            }
                            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.previewBytes) {
                                message.previewBytes = parseInt(wireFormat.previewBytes);
                            }
                            return message;
                        }
                    };
                    var defaultDataRow = {
                        rowNumber: 0,
                        text: []
                    };
                    var DataRowWireFormat3 = Protos.DataRowWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            var message = _objectSpread({}, defaultDataRow, wireFormat);
                            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rowNumber) {
                                message.rowNumber = parseInt(wireFormat.rowNumber);
                            }
                            return message;
                        }
                    };
                    var defaultDataTable = {
                        totalRows: 0,
                        rowsReturned: 0,
                        rows: []
                    };
                    var DataTableWireFormat3 = Protos.DataTableWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            var message = _objectSpread({}, defaultDataTable, wireFormat);
                            if (wireFormat) {
                                message.type = Kaggle.Sdk.Datasets.DataViewer.Protos.DataTableTypeWireFormat3.fromJson(wireFormat.type);
                            }
                            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalRows) {
                                message.totalRows = parseInt(wireFormat.totalRows);
                            }
                            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rows) {
                                message.rows = wireFormat.rows.map(function(i) {
                                    return Kaggle.Sdk.Datasets.DataViewer.Protos.DataRowWireFormat3.fromJson(i);
                                });
                            }
                            return message;
                        }
                    };
                    var defaultDataUrl = {
                        url: ""
                    };
                    var DataUrlWireFormat3 = Protos.DataUrlWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            var message = _objectSpread({}, defaultDataUrl, wireFormat);
                            if (wireFormat) {
                                message.type = Kaggle.Sdk.Datasets.DataViewer.Protos.DataUrlTypeWireFormat3.fromJson(wireFormat.type);
                            }
                            return message;
                        }
                    };
                    var defaultDataView = {};
                    var DataViewWireFormat3 = Protos.DataViewWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            var message = _objectSpread({}, defaultDataView, wireFormat);
                            if (wireFormat) {
                                message.type = Kaggle.Sdk.Datasets.DataViewer.Protos.DataViewTypeWireFormat3.fromJson(wireFormat.type);
                            }
                            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataTable) {
                                message.dataTable = Kaggle.Sdk.Datasets.DataViewer.Protos.DataTableWireFormat3.fromJson(wireFormat.dataTable);
                            }
                            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataUrl) {
                                message.dataUrl = Kaggle.Sdk.Datasets.DataViewer.Protos.DataUrlWireFormat3.fromJson(wireFormat.dataUrl);
                            }
                            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataRaw) {
                                message.dataRaw = Kaggle.Sdk.Datasets.DataViewer.Protos.DataRawWireFormat3.fromJson(wireFormat.dataRaw);
                            }
                            return message;
                        }
                    };
                    var DateTimeFilterWireFormat3 = Protos.DateTimeFilterWireFormat3 = {
                        toJson: function toJson(message) {
                            var wireFormat = _objectSpread({}, message);
                            if (message === null || message === void 0 ? void 0 : message.operator) {
                                wireFormat.operator = Kaggle.Sdk.Datasets.DataViewer.Protos.DateTimeFilter.DateTimeOperatorWireFormat3.toJson(message.operator);
                            }
                            if (message === null || message === void 0 ? void 0 : message.operand) {
                                wireFormat.operand = message.operand.toISOString();
                            }
                            return wireFormat;
                        }
                    };
                    var FilterWireFormat3 = Protos.FilterWireFormat3 = {
                        toJson: function toJson(message) {
                            var wireFormat = _objectSpread({}, message);
                            if (message === null || message === void 0 ? void 0 : message.columnFilter) {
                                wireFormat.columnFilter = Kaggle.Sdk.Datasets.DataViewer.Protos.ColumnFilterWireFormat3.toJson(message.columnFilter);
                            }
                            if (message === null || message === void 0 ? void 0 : message.constantFilter) {
                                wireFormat.constantFilter = Kaggle.Sdk.Datasets.DataViewer.Protos.ConstantFilterWireFormat3.toJson(message.constantFilter);
                            }
                            if (message === null || message === void 0 ? void 0 : message.andFilter) {
                                wireFormat.andFilter = Kaggle.Sdk.Datasets.DataViewer.Protos.AndFilterWireFormat3.toJson(message.andFilter);
                            }
                            if (message === null || message === void 0 ? void 0 : message.orFilter) {
                                wireFormat.orFilter = Kaggle.Sdk.Datasets.DataViewer.Protos.OrFilterWireFormat3.toJson(message.orFilter);
                            }
                            if (message === null || message === void 0 ? void 0 : message.notFilter) {
                                wireFormat.notFilter = Kaggle.Sdk.Datasets.DataViewer.Protos.NotFilterWireFormat3.toJson(message.notFilter);
                            }
                            return wireFormat;
                        }
                    };
                    var defaultGetDataViewResponse = {};
                    var GetDataViewResponseWireFormat3 = Protos.GetDataViewResponseWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            var message = _objectSpread({}, defaultGetDataViewResponse, wireFormat);
                            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataView) {
                                message.dataView = Kaggle.Sdk.Datasets.DataViewer.Protos.DataViewWireFormat3.fromJson(wireFormat.dataView);
                            }
                            return message;
                        }
                    };
                    var NotFilterWireFormat3 = Protos.NotFilterWireFormat3 = {
                        toJson: function toJson(message) {
                            var wireFormat = _objectSpread({}, message);
                            if (message === null || message === void 0 ? void 0 : message.filter) {
                                wireFormat.filter = Kaggle.Sdk.Datasets.DataViewer.Protos.FilterWireFormat3.toJson(message.filter);
                            }
                            return wireFormat;
                        }
                    };
                    var NumericFilterWireFormat3 = Protos.NumericFilterWireFormat3 = {
                        toJson: function toJson(message) {
                            var wireFormat = _objectSpread({}, message);
                            if (message === null || message === void 0 ? void 0 : message.operator) {
                                wireFormat.operator = Kaggle.Sdk.Datasets.DataViewer.Protos.NumericFilter.NumericOperatorWireFormat3.toJson(message.operator);
                            }
                            if ((message === null || message === void 0 ? void 0 : message.operand) != undefined && (message === null || message === void 0 ? void 0 : message.operand) != 0) {
                                wireFormat.operand = Number.isFinite(message.operand) ? message.operand : Number(message.operand).toString();
                            }
                            return wireFormat;
                        }
                    };
                    var OrFilterWireFormat3 = Protos.OrFilterWireFormat3 = {
                        toJson: function toJson(message) {
                            var wireFormat = _objectSpread({}, message);
                            if (message === null || message === void 0 ? void 0 : message.filters) {
                                wireFormat.filters = message.filters.map(function(i) {
                                    return Kaggle.Sdk.Datasets.DataViewer.Protos.FilterWireFormat3.toJson(i);
                                });
                            }
                            return wireFormat;
                        }
                    };
                    var SortByWireFormat3 = Protos.SortByWireFormat3 = {
                        toJson: function toJson(message) {
                            var wireFormat = _objectSpread({}, message);
                            if (message === null || message === void 0 ? void 0 : message.column) {
                                wireFormat.column = Kaggle.Sdk.Datasets.DataViewer.Protos.ColumnWireFormat3.toJson(message.column);
                            }
                            if (message === null || message === void 0 ? void 0 : message.direction) {
                                wireFormat.direction = Kaggle.Sdk.Datasets.DataViewer.Protos.SortDirectionWireFormat3.toJson(message.direction);
                            }
                            return wireFormat;
                        }
                    };
                    var StringFilterWireFormat3 = Protos.StringFilterWireFormat3 = {
                        toJson: function toJson(message) {
                            var wireFormat = _objectSpread({}, message);
                            if (message === null || message === void 0 ? void 0 : message.operator) {
                                wireFormat.operator = Kaggle.Sdk.Datasets.DataViewer.Protos.StringFilter.StringOperatorWireFormat3.toJson(message.operator);
                            }
                            return wireFormat;
                        }
                    };
                    var TableQueryWireFormat3 = Protos.TableQueryWireFormat3 = {
                        toJson: function toJson(message) {
                            var wireFormat = _objectSpread({}, message);
                            if (message === null || message === void 0 ? void 0 : message.filter) {
                                wireFormat.filter = Kaggle.Sdk.Datasets.DataViewer.Protos.FilterWireFormat3.toJson(message.filter);
                            }
                            if (message === null || message === void 0 ? void 0 : message.selectedColumns) {
                                wireFormat.selectedColumns = message.selectedColumns.map(function(i) {
                                    return Kaggle.Sdk.Datasets.DataViewer.Protos.ColumnWireFormat3.toJson(i);
                                });
                            }
                            if (message === null || message === void 0 ? void 0 : message.sorts) {
                                wireFormat.sorts = message.sorts.map(function(i) {
                                    return Kaggle.Sdk.Datasets.DataViewer.Protos.SortByWireFormat3.toJson(i);
                                });
                            }
                            return wireFormat;
                        }
                    };
                    var DataRawType;
                    (function(DataRawType) {
                        DataRawType["MARKDOWN"] = "markdown";
                        DataRawType["JSON"] = "json";
                        DataRawType["TEXT"] = "text";
                    })(DataRawType = Protos.DataRawType || (Protos.DataRawType = {}));
                    var DataRawTypeWireFormat3 = Protos.DataRawTypeWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            switch(wireFormat){
                                case "MARKDOWN":
                                default:
                                    return DataRawType.MARKDOWN;
                                case "JSON":
                                    return DataRawType.JSON;
                                case "TEXT":
                                    return DataRawType.TEXT;
                            }
                        }
                    };
                    var DataTableType;
                    (function(DataTableType) {
                        DataTableType[// Table is a csv file in cloud storage.
                        "CSV"] = "csv";
                        DataTableType["BIGQUERY"] = "bigquery";
                        DataTableType["SQLITE"] = "sqlite";
                        DataTableType["EXCEL"] = "excel";
                    })(DataTableType = Protos.DataTableType || (Protos.DataTableType = {}));
                    var DataTableTypeWireFormat3 = Protos.DataTableTypeWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            switch(wireFormat){
                                case "CSV":
                                default:
                                    return DataTableType.CSV;
                                case "BIGQUERY":
                                    return DataTableType.BIGQUERY;
                                case "SQLITE":
                                    return DataTableType.SQLITE;
                                case "EXCEL":
                                    return DataTableType.EXCEL;
                            }
                        }
                    };
                    var DataUrlType;
                    (function(DataUrlType) {
                        DataUrlType["IMAGE"] = "image";
                        DataUrlType["PDF"] = "pdf";
                        DataUrlType["AUDIO"] = "audio";
                        DataUrlType["VIDEO"] = "video";
                    })(DataUrlType = Protos.DataUrlType || (Protos.DataUrlType = {}));
                    var DataUrlTypeWireFormat3 = Protos.DataUrlTypeWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            switch(wireFormat){
                                case "IMAGE":
                                default:
                                    return DataUrlType.IMAGE;
                                case "PDF":
                                    return DataUrlType.PDF;
                                case "AUDIO":
                                    return DataUrlType.AUDIO;
                                case "VIDEO":
                                    return DataUrlType.VIDEO;
                            }
                        }
                    };
                    var DataViewType;
                    (function(DataViewType) {
                        DataViewType["TABULAR"] = "tabular";
                        DataViewType["URL"] = "url";
                        DataViewType["RAW"] = "raw";
                    })(DataViewType = Protos.DataViewType || (Protos.DataViewType = {}));
                    var DataViewTypeWireFormat3 = Protos.DataViewTypeWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            switch(wireFormat){
                                case "TABULAR":
                                default:
                                    return DataViewType.TABULAR;
                                case "URL":
                                    return DataViewType.URL;
                                case "RAW":
                                    return DataViewType.RAW;
                            }
                        }
                    };
                    var SortDirection;
                    (function(SortDirection) {
                        SortDirection["ASC"] = "asc";
                        SortDirection["DESC"] = "desc";
                    })(SortDirection = Protos.SortDirection || (Protos.SortDirection = {}));
                    var SortDirectionWireFormat3 = Protos.SortDirectionWireFormat3 = {
                        toJson: function toJson(enumVal) {
                            switch(enumVal){
                                case SortDirection.ASC:
                                case 0:
                                default:
                                    return "ASC";
                                case SortDirection.DESC:
                                case 1:
                                    return "DESC";
                            }
                        }
                    };
                })(Protos1 = DataViewer.Protos || (DataViewer.Protos = {}));
            })(DataViewer1 = Datasets.DataViewer || (Datasets.DataViewer = {}));
            var Models1;
            (function(Models) {
                var DatasetFileType1;
                (function(DatasetFileType) {
                    var Enum;
                    (function(Enum) {
                        Enum["DATASET_FILE_TYPE_UNSPECIFIED"] = "datasetFileTypeUnspecified";
                        Enum["CSV"] = "csv";
                        Enum["JSON"] = "json";
                        Enum["SQLITE"] = "sqlite";
                        Enum["OTHER"] = "other";
                    })(Enum = DatasetFileType.Enum || (DatasetFileType.Enum = {}));
                    var EnumWireFormat3 = DatasetFileType.EnumWireFormat3 = {
                        fromJson: function fromJson(wireFormat) {
                            switch(wireFormat){
                                case "DATASET_FILE_TYPE_UNSPECIFIED":
                                default:
                                    return Enum.DATASET_FILE_TYPE_UNSPECIFIED;
                                case "CSV":
                                    return Enum.CSV;
                                case "JSON":
                                    return Enum.JSON;
                                case "SQLITE":
                                    return Enum.SQLITE;
                                case "OTHER":
                                    return Enum.OTHER;
                            }
                        }
                    };
                })(DatasetFileType1 = Models.DatasetFileType || (Models.DatasetFileType = {}));
                var DatasetFileTypeGroup1;
                (function(DatasetFileTypeGroup) {
                    var Enum;
                    (function(Enum) {
                        Enum["ALL"] = "all";
                        Enum["CSV"] = "csv";
                        Enum["SQLITE"] = "sqlite";
                        Enum["JSON"] = "json";
                        Enum["BIG_QUERY"] = "bigQuery";
                    })(Enum = DatasetFileTypeGroup.Enum || (DatasetFileTypeGroup.Enum = {}));
                    var EnumWireFormat3 = DatasetFileTypeGroup.EnumWireFormat3 = {
                        toJson: function toJson(enumVal) {
                            switch(enumVal){
                                case Enum.ALL:
                                case 0:
                                default:
                                    return "ALL";
                                case Enum.CSV:
                                case 1:
                                    return "CSV";
                                case Enum.SQLITE:
                                case 2:
                                    return "SQLITE";
                                case Enum.JSON:
                                case 3:
                                    return "JSON";
                                case Enum.BIG_QUERY:
                                case 4:
                                    return "BIG_QUERY";
                            }
                        }
                    };
                })(DatasetFileTypeGroup1 = Models.DatasetFileTypeGroup || (Models.DatasetFileTypeGroup = {}));
                var DatasetLicenseGroup1;
                (function(DatasetLicenseGroup) {
                    var Enum;
                    (function(Enum) {
                        Enum["ALL"] = "all";
                        Enum["CC"] = "cc";
                        Enum["GPL"] = "gpl";
                        Enum["ODB"] = "odb";
                        Enum["OTHER"] = "other";
                    })(Enum = DatasetLicenseGroup.Enum || (DatasetLicenseGroup.Enum = {}));
                    var EnumWireFormat3 = DatasetLicenseGroup.EnumWireFormat3 = {
                        toJson: function toJson(enumVal) {
                            switch(enumVal){
                                case Enum.ALL:
                                case 0:
                                default:
                                    return "ALL";
                                case Enum.CC:
                                case 1:
                                    return "CC";
                                case Enum.GPL:
                                case 2:
                                    return "GPL";
                                case Enum.ODB:
                                case 3:
                                    return "ODB";
                                case Enum.OTHER:
                                case 4:
                                    return "OTHER";
                            }
                        }
                    };
                })(DatasetLicenseGroup1 = Models.DatasetLicenseGroup || (Models.DatasetLicenseGroup = {}));
                var DatasetSelectionGroup1;
                (function(DatasetSelectionGroup) {
                    var Enum;
                    (function(Enum) {
                        Enum["PUBLIC"] = "public";
                        Enum["MY"] = "my";
                        Enum["USER"] = "user";
                        Enum["USER_SHARED_WITH_ME"] = "userSharedWithMe";
                        Enum["UPVOTED"] = "upvoted";
                        Enum["MY_PRIVATE"] = "myPrivate";
                        Enum["MY_PUBLIC"] = "myPublic";
                        Enum["ORGANIZATION"] = "organization";
                        Enum["BOOKMARKED"] = "bookmarked";
                        Enum["COLLABORATION"] = "collaboration";
                        Enum[// Old
                        "FEATURED"] = "featured";
                        Enum["ALL"] = "all";
                        Enum["UNFEATURED"] = "unfeatured";
                    })(Enum = DatasetSelectionGroup.Enum || (DatasetSelectionGroup.Enum = {}));
                    var EnumWireFormat3 = DatasetSelectionGroup.EnumWireFormat3 = {
                        toJson: function toJson(enumVal) {
                            switch(enumVal){
                                case Enum.PUBLIC:
                                case 0:
                                default:
                                    return "PUBLIC";
                                case Enum.MY:
                                case 1:
                                    return "MY";
                                case Enum.USER:
                                case 2:
                                    return "USER";
                                case Enum.USER_SHARED_WITH_ME:
                                case 3:
                                    return "USER_SHARED_WITH_ME";
                                case Enum.UPVOTED:
                                case 4:
                                    return "UPVOTED";
                                case Enum.MY_PRIVATE:
                                case 5:
                                    return "MY_PRIVATE";
                                case Enum.MY_PUBLIC:
                                case 10:
                                    return "MY_PUBLIC";
                                case Enum.ORGANIZATION:
                                case 6:
                                    return "ORGANIZATION";
                                case Enum.BOOKMARKED:
                                case 11:
                                    return "BOOKMARKED";
                                case Enum.COLLABORATION:
                                case 12:
                                    return "COLLABORATION";
                                case Enum.FEATURED:
                                case 7:
                                    return "FEATURED";
                                case Enum.ALL:
                                case 8:
                                    return "ALL";
                                case Enum.UNFEATURED:
                                case 9:
                                    return "UNFEATURED";
                            }
                        }
                    };
                })(DatasetSelectionGroup1 = Models.DatasetSelectionGroup || (Models.DatasetSelectionGroup = {}));
                var DatasetSizeGroup1;
                (function(DatasetSizeGroup) {
                    var Enum;
                    (function(Enum) {
                        Enum["ALL"] = "all";
                        Enum["SMALL"] = "small";
                        Enum["MEDIUM"] = "medium";
                        Enum["LARGE"] = "large";
                    })(Enum = DatasetSizeGroup.Enum || (DatasetSizeGroup.Enum = {}));
                    var EnumWireFormat3 = DatasetSizeGroup.EnumWireFormat3 = {
                        toJson: function toJson(enumVal) {
                            switch(enumVal){
                                case Enum.ALL:
                                case 0:
                                default:
                                    return "ALL";
                                case Enum.SMALL:
                                case 1:
                                    return "SMALL";
                                case Enum.MEDIUM:
                                case 2:
                                    return "MEDIUM";
                                case Enum.LARGE:
                                case 3:
                                    return "LARGE";
                            }
                        }
                    };
                })(DatasetSizeGroup1 = Models.DatasetSizeGroup || (Models.DatasetSizeGroup = {}));
                var DatasetSortBy1;
                (function(DatasetSortBy) {
                    var Enum;
                    (function(Enum) {
                        Enum["HOTTEST"] = "hottest";
                        Enum["VOTES"] = "votes";
                        Enum["UPDATED"] = "updated";
                        Enum[// Deprecated
                        "ACTIVE"] = "active";
                        Enum["PUBLISHED"] = "published";
                        Enum[// Old world
                        "RELEVANCE"] = "relevance";
                        Enum["LAST_VIEWED"] = "lastViewed";
                        Enum["USABILITY"] = "usability";
                    })(Enum = DatasetSortBy.Enum || (DatasetSortBy.Enum = {}));
                    var EnumWireFormat3 = DatasetSortBy.EnumWireFormat3 = {
                        toJson: function toJson(enumVal) {
                            switch(enumVal){
                                case Enum.HOTTEST:
                                case 0:
                                default:
                                    return "HOTTEST";
                                case Enum.VOTES:
                                case 1:
                                    return "VOTES";
                                case Enum.UPDATED:
                                case 2:
                                    return "UPDATED";
                                case Enum.ACTIVE:
                                case 3:
                                    return "ACTIVE";
                                case Enum.PUBLISHED:
                                case 4:
                                    return "PUBLISHED";
                                case Enum.RELEVANCE:
                                case 5:
                                    return "RELEVANCE";
                                case Enum.LAST_VIEWED:
                                case 6:
                                    return "LAST_VIEWED";
                                case Enum.USABILITY:
                                case 7:
                                    return "USABILITY";
                            }
                        }
                    };
                })(DatasetSortBy1 = Models.DatasetSortBy || (Models.DatasetSortBy = {}));
                var DatasetViewedGroup1;
                (function(DatasetViewedGroup) {
                    var Enum;
                    (function(Enum) {
                        Enum["ALL"] = "all";
                        Enum["VIEWED"] = "viewed";
                    })(Enum = DatasetViewedGroup.Enum || (DatasetViewedGroup.Enum = {}));
                    var EnumWireFormat3 = DatasetViewedGroup.EnumWireFormat3 = {
                        toJson: function toJson(enumVal) {
                            switch(enumVal){
                                case Enum.ALL:
                                case 0:
                                default:
                                    return "ALL";
                                case Enum.VIEWED:
                                case 1:
                                    return "VIEWED";
                            }
                        }
                    };
                })(DatasetViewedGroup1 = Models.DatasetViewedGroup || (Models.DatasetViewedGroup = {}));
                var DatasetEditResponseStatus;
                (function(DatasetEditResponseStatus) {
                    DatasetEditResponseStatus["UNSPECIFIED"] = "unspecified";
                    DatasetEditResponseStatus["OK"] = "ok";
                    DatasetEditResponseStatus["ERROR"] = "error";
                })(DatasetEditResponseStatus = Models.DatasetEditResponseStatus || (Models.DatasetEditResponseStatus = {}));
                var DatasetUploadResponseStatus;
                (function(DatasetUploadResponseStatus) {
                    DatasetUploadResponseStatus["UNSPECIFIED"] = "unspecified";
                    DatasetUploadResponseStatus["OK"] = "ok";
                    DatasetUploadResponseStatus["ERROR"] = "error";
                })(DatasetUploadResponseStatus = Models.DatasetUploadResponseStatus || (Models.DatasetUploadResponseStatus = {}));
            })(Models1 = Datasets.Models || (Datasets.Models = {}));
            var ActionFlagsWireFormat3 = Datasets.ActionFlagsWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultActivityNotGeneratedBanner = {};
            var ActivityNotGeneratedBannerWireFormat3 = Datasets.ActivityNotGeneratedBannerWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultActivityNotGeneratedBanner, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.img) {
                        message.img = KaggleSdkCommonImageWireFormat3.fromJson(wireFormat.img);
                    }
                    return message;
                }
            };
            var defaultActivityPage = {};
            var ActivityPageWireFormat3 = Datasets.ActivityPageWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultActivityPage, wireFormat);
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Datasets.ActivityPageStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.banner) {
                        message.banner = Kaggle.Sdk.Datasets.ActivityNotGeneratedBannerWireFormat3.fromJson(wireFormat.banner);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.summaryStats) {
                        message.summaryStats = Kaggle.Sdk.Datasets.ActivitySummaryStatsWireFormat3.fromJson(wireFormat.summaryStats);
                    }
                    return message;
                }
            };
            var defaultActivityPageContributorLocation = {
                count: 0
            };
            var ActivityPageContributorLocationWireFormat3 = Datasets.ActivityPageContributorLocationWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultActivityPageContributorLocation, wireFormat);
                    return message;
                }
            };
            var defaultActivityPageTimeSeries = {
                points: []
            };
            var ActivityPageTimeSeriesWireFormat3 = Datasets.ActivityPageTimeSeriesWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultActivityPageTimeSeries, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.points) {
                        message.points = wireFormat.points.map(function(i) {
                            return Kaggle.Sdk.Datasets.ActivityPageTimeSeriesPointWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultActivityPageTimeSeriesPoint = {
                count: 0
            };
            var ActivityPageTimeSeriesPointWireFormat3 = Datasets.ActivityPageTimeSeriesPointWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultActivityPageTimeSeriesPoint, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
                        message.date = new Date(wireFormat.date);
                    }
                    return message;
                }
            };
            var defaultActivitySummaryStats = {
                id: 0,
                schemaVersion: 0,
                datasetId: 0,
                datasetStats: [],
                timeSeries: {},
                topContributors: [],
                contributorLocations: [],
                kernelStats: [],
                kernelMedals: [],
                topKernels: [],
                tags: [],
                relatedDatasets: [],
                discussionStats: [],
                discussionMedals: [],
                topDiscussions: []
            };
            var ActivitySummaryStatsWireFormat3 = Datasets.ActivitySummaryStatsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultActivitySummaryStats, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.generatedDate) {
                        message.generatedDate = new Date(wireFormat.generatedDate);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetStats) {
                        message.datasetStats = wireFormat.datasetStats.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityPageStatWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.timeSeries) {
                        message.timeSeries = {};
                        Object.entries(wireFormat.timeSeries).forEach(function(param) {
                            var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                            message.timeSeries[key] = Kaggle.Sdk.Datasets.ActivityPageTimeSeriesWireFormat3.fromJson(value);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topContributors) {
                        message.topContributors = wireFormat.topContributors.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityPageContributorWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contributorLocations) {
                        message.contributorLocations = wireFormat.contributorLocations.map(function(i) {
                            return Kaggle.Sdk.Datasets.ActivityPageContributorLocationWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelStats) {
                        message.kernelStats = wireFormat.kernelStats.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityPageStatWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelMedals) {
                        message.kernelMedals = wireFormat.kernelMedals.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityPageMedalWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topKernels) {
                        message.topKernels = wireFormat.topKernels.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityPageKernelWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
                        message.tags = wireFormat.tags.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityPageTagWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.relatedDatasets) {
                        message.relatedDatasets = wireFormat.relatedDatasets.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityPageRelatedDatasetWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.discussionStats) {
                        message.discussionStats = wireFormat.discussionStats.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityPageStatWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.discussionMedals) {
                        message.discussionMedals = wireFormat.discussionMedals.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityPageMedalWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topDiscussions) {
                        message.topDiscussions = wireFormat.topDiscussions.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityPageDiscussionWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var AddDatasetCategoriesRequestWireFormat3 = Datasets.AddDatasetCategoriesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultAddDatasetCategoriesResponse = {};
            var AddDatasetCategoriesResponseWireFormat3 = Datasets.AddDatasetCategoriesResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultAddDatasetCategoriesResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updatedUsabilityRating) {
                        message.updatedUsabilityRating = Kaggle.Sdk.Datasets.DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.updatedUsabilityRating);
                    }
                    return message;
                }
            };
            var AttachCompetitionDatasetRequestWireFormat3 = Datasets.AttachCompetitionDatasetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultAutoGeneratedSource = {};
            var AutoGeneratedSourceWireFormat3 = Datasets.AutoGeneratedSourceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultAutoGeneratedSource, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelReference) {
                        message.kernelReference = Kaggle.Sdk.Datasets.KernelOutputKernelReferenceWireFormat3.fromJson(wireFormat.kernelReference);
                    }
                    return message;
                }
            };
            var defaultBasicKernelOutputKernelReference = {
                url: ""
            };
            var BasicKernelOutputKernelReferenceWireFormat3 = Datasets.BasicKernelOutputKernelReferenceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultBasicKernelOutputKernelReference, wireFormat);
                    return message;
                }
            };
            var defaultCompetitionDatabundleVersion = {
                id: 0,
                databundleId: 0,
                creatorUserId: 0
            };
            var CompetitionDatabundleVersionWireFormat3 = Datasets.CompetitionDatabundleVersionWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCompetitionDatabundleVersion, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationDate) {
                        message.creationDate = new Date(wireFormat.creationDate);
                    }
                    if (wireFormat) {
                        message.type = Kaggle.Sdk.Datasets.DatabundleVersionTypeWireFormat3.fromJson(wireFormat.type);
                    }
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Datasets.DatabundleVersionStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationStatus) {
                        message.creationStatus = Kaggle.Sdk.Datasets.DatabundleVersionCreationStatusWireFormat3.fromJson(wireFormat.creationStatus);
                    }
                    return message;
                }
            };
            var defaultCompetitionUploaderConfig = {};
            var CompetitionUploaderConfigWireFormat3 = Datasets.CompetitionUploaderConfigWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCompetitionUploaderConfig, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingData) {
                        message.existingData = Kaggle.Sdk.Datasets.ExistingDataInfoWireFormat3.fromJson(wireFormat.existingData);
                    }
                    return message;
                }
            };
            var CreateBigQueryDatasetRequestWireFormat3 = Datasets.CreateBigQueryDatasetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.basicInfo) {
                        wireFormat.basicInfo = Kaggle.Sdk.Datasets.DataCreationBasicInfoWireFormat3.toJson(message.basicInfo);
                    }
                    return wireFormat;
                }
            };
            var CreateCompetitionDataRequestWireFormat3 = Datasets.CreateCompetitionDataRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.basicInfo) {
                        wireFormat.basicInfo = Kaggle.Sdk.Datasets.DataCreationBasicInfoWireFormat3.toJson(message.basicInfo);
                    }
                    if (message === null || message === void 0 ? void 0 : message.existingDirectories) {
                        wireFormat.existingDirectories = message.existingDirectories.map(function(i) {
                            return Kaggle.Sdk.Datasets.ExistingDirectoryInfoWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.existingFiles) {
                        wireFormat.existingFiles = message.existingFiles.map(function(i) {
                            return Kaggle.Sdk.Datasets.ExistingFileInfoWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.competitionDatabundleType) {
                        wireFormat.competitionDatabundleType = Kaggle.Sdk.Datasets.CompetitionDatabundleTypeWireFormat3.toJson(message.competitionDatabundleType);
                    }
                    return wireFormat;
                }
            };
            var defaultCreateCompetitionDataResponse = {};
            var CreateCompetitionDataResponseWireFormat3 = Datasets.CreateCompetitionDataResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCreateCompetitionDataResponse, wireFormat);
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Datasets.CreationStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundleVersionReference) {
                        message.databundleVersionReference = Kaggle.Sdk.Datasets.DatabundleVersionReferenceWireFormat3.fromJson(wireFormat.databundleVersionReference);
                    }
                    return message;
                }
            };
            var CreateDatasetHashLinkRequestWireFormat3 = Datasets.CreateDatasetHashLinkRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultCreateDatasetHashLinkResponse = {
                datasetHashLink: ""
            };
            var CreateDatasetHashLinkResponseWireFormat3 = Datasets.CreateDatasetHashLinkResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCreateDatasetHashLinkResponse, wireFormat);
                    return message;
                }
            };
            var CreateDatasetRequestWireFormat3 = Datasets.CreateDatasetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.basicInfo) {
                        wireFormat.basicInfo = Kaggle.Sdk.Datasets.DataCreationBasicInfoWireFormat3.toJson(message.basicInfo);
                    }
                    return wireFormat;
                }
            };
            var CreateDatasetVersionRequestWireFormat3 = Datasets.CreateDatasetVersionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.basicInfo) {
                        wireFormat.basicInfo = Kaggle.Sdk.Datasets.DataCreationBasicInfoWireFormat3.toJson(message.basicInfo);
                    }
                    if (message === null || message === void 0 ? void 0 : message.existingDirectories) {
                        wireFormat.existingDirectories = message.existingDirectories.map(function(i) {
                            return Kaggle.Sdk.Datasets.ExistingDirectoryInfoWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.existingFiles) {
                        wireFormat.existingFiles = message.existingFiles.map(function(i) {
                            return Kaggle.Sdk.Datasets.ExistingFileInfoWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var CreateDoiApproverRequestWireFormat3 = Datasets.CreateDoiApproverRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultCreateDoiApproverResponse = {};
            var CreateDoiApproverResponseWireFormat3 = Datasets.CreateDoiApproverResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCreateDoiApproverResponse, wireFormat);
                    return message;
                }
            };
            var CreateDoiRequestWireFormat3 = Datasets.CreateDoiRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultCreateDoiResponse = {};
            var CreateDoiResponseWireFormat3 = Datasets.CreateDoiResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCreateDoiResponse, wireFormat);
                    return message;
                }
            };
            var defaultDatabundleInfo = {
                totalSize: 0,
                isFileset: false,
                canSeeDownload: false,
                canUpdate: false,
                firestorePath: "",
                downloadUrl: "",
                versionId: 0,
                id: 0
            };
            var DatabundleInfoWireFormat3 = Datasets.DatabundleInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatabundleInfo, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalSize) {
                        message.totalSize = parseInt(wireFormat.totalSize);
                    }
                    return message;
                }
            };
            var defaultDatabundleVersionCreationStatus = {
                creationPercentComplete: 0
            };
            var DatabundleVersionCreationStatusWireFormat3 = Datasets.DatabundleVersionCreationStatusWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatabundleVersionCreationStatus, wireFormat);
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Datasets.DatabundleVersionStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationPercentComplete) != undefined) {
                        message.creationPercentComplete = Number(wireFormat.creationPercentComplete);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationLastUpdate) {
                        message.creationLastUpdate = new Date(wireFormat.creationLastUpdate);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationStart) {
                        message.creationStart = new Date(wireFormat.creationStart);
                    }
                    return message;
                }
            };
            var defaultDatabundleVersionReference = {
                databundleId: 0,
                databundleVersionId: 0
            };
            var DatabundleVersionReferenceWireFormat3 = Datasets.DatabundleVersionReferenceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatabundleVersionReference, wireFormat);
                    if (wireFormat) {
                        message.databundleType = Kaggle.Sdk.Datasets.DatabundleTypeWireFormat3.fromJson(wireFormat.databundleType);
                    }
                    if (wireFormat) {
                        message.databundleVersionType = Kaggle.Sdk.Datasets.DatabundleVersionTypeWireFormat3.fromJson(wireFormat.databundleVersionType);
                    }
                    if (wireFormat) {
                        message.diffType = Kaggle.Sdk.Datasets.DatabundleDiffTypeWireFormat3.fromJson(wireFormat.diffType);
                    }
                    return message;
                }
            };
            var defaultDataCoverageAttribute = {};
            var DataCoverageAttributeWireFormat3 = Datasets.DataCoverageAttributeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDataCoverageAttribute, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.temporalCoverageFrom) {
                        message.temporalCoverageFrom = new Date(wireFormat.temporalCoverageFrom);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.temporalCoverageTo) {
                        message.temporalCoverageTo = new Date(wireFormat.temporalCoverageTo);
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.temporalCoverageFrom) {
                        wireFormat.temporalCoverageFrom = message.temporalCoverageFrom.toISOString();
                    }
                    if (message === null || message === void 0 ? void 0 : message.temporalCoverageTo) {
                        wireFormat.temporalCoverageTo = message.temporalCoverageTo.toISOString();
                    }
                    return wireFormat;
                }
            };
            var DataCreationBasicInfoWireFormat3 = Datasets.DataCreationBasicInfoWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.databundleVersionType) {
                        wireFormat.databundleVersionType = Kaggle.Sdk.Datasets.DatabundleVersionTypeWireFormat3.toJson(message.databundleVersionType);
                    }
                    if (message === null || message === void 0 ? void 0 : message.directories) {
                        wireFormat.directories = message.directories.map(function(i) {
                            return Kaggle.Sdk.Datasets.UploadDirectoryInfoWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.files) {
                        wireFormat.files = message.files.map(function(i) {
                            return Kaggle.Sdk.Datasets.UploadFileInfoWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.remoteUrlInfos) {
                        wireFormat.remoteUrlInfos = message.remoteUrlInfos.map(function(i) {
                            return KaggleSdkDatasetsDatabundlesRemoteUrlInfoWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.githubInfo) {
                        wireFormat.githubInfo = KaggleSdkDatasetsDatabundlesGithubInfoWireFormat3.toJson(message.githubInfo);
                    }
                    if (message === null || message === void 0 ? void 0 : message.kernelOutputInfo) {
                        wireFormat.kernelOutputInfo = Kaggle.Sdk.Datasets.UploadKernelOutputInfoWireFormat3.toJson(message.kernelOutputInfo);
                    }
                    if (message === null || message === void 0 ? void 0 : message.gcsFileSetInfo) {
                        wireFormat.gcsFileSetInfo = Kaggle.Sdk.Datasets.GcsFileSetInfoWireFormat3.toJson(message.gcsFileSetInfo);
                    }
                    if (message === null || message === void 0 ? void 0 : message.flags) {
                        wireFormat.flags = Kaggle.Sdk.Datasets.ActionFlagsWireFormat3.toJson(message.flags);
                    }
                    return wireFormat;
                }
            };
            var DataCreationSettingsWireFormat3 = Datasets.DataCreationSettingsWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultDatasetActivityDto = {};
            var DatasetActivityDtoWireFormat3 = Datasets.DatasetActivityDtoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetActivityDto, wireFormat);
                    if (wireFormat) {
                        message.activityType = Kaggle.Sdk.Datasets.DatasetActivityTypeWireFormat3.fromJson(wireFormat.activityType);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
                        message.date = new Date(wireFormat.date);
                    }
                    return message;
                }
            };
            var defaultDatasetActivityPageContributor = {
                totalUpvotesCount: 0
            };
            var DatasetActivityPageContributorWireFormat3 = Datasets.DatasetActivityPageContributorWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetActivityPageContributor, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.user) {
                        message.user = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.user);
                    }
                    return message;
                }
            };
            var defaultDatasetActivityPageDiscussion = {
                id: 0,
                replyCount: 0
            };
            var DatasetActivityPageDiscussionWireFormat3 = Datasets.DatasetActivityPageDiscussionWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetActivityPageDiscussion, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voteButtonDto) {
                        message.voteButtonDto = KaggleSdkCommonVoteButtonWireFormat3.fromJson(wireFormat.voteButtonDto);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.avatar) {
                        message.avatar = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.avatar);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.medal) {
                        message.medal = KaggleSdkCommonImageWireFormat3.fromJson(wireFormat.medal);
                    }
                    return message;
                }
            };
            var defaultDatasetActivityPageKernel = {
                id: 0,
                tags: []
            };
            var DatasetActivityPageKernelWireFormat3 = Datasets.DatasetActivityPageKernelWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetActivityPageKernel, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voteButtonDto) {
                        message.voteButtonDto = KaggleSdkCommonVoteButtonWireFormat3.fromJson(wireFormat.voteButtonDto);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.avatar) {
                        message.avatar = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.avatar);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.medal) {
                        message.medal = KaggleSdkCommonImageWireFormat3.fromJson(wireFormat.medal);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
                        message.tags = wireFormat.tags.map(function(i) {
                            return Kaggle.Sdk.Tags.TagWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultDatasetActivityPageMedal = {
                count: 0
            };
            var DatasetActivityPageMedalWireFormat3 = Datasets.DatasetActivityPageMedalWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetActivityPageMedal, wireFormat);
                    if (wireFormat) {
                        message.type = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.type);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.image) {
                        message.image = KaggleSdkCommonImageWireFormat3.fromJson(wireFormat.image);
                    }
                    return message;
                }
            };
            var defaultDatasetActivityPageRelatedDataset = {
                id: 0,
                kernelsCount: 0
            };
            var DatasetActivityPageRelatedDatasetWireFormat3 = Datasets.DatasetActivityPageRelatedDatasetWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetActivityPageRelatedDataset, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voteButtonDto) {
                        message.voteButtonDto = KaggleSdkCommonVoteButtonWireFormat3.fromJson(wireFormat.voteButtonDto);
                    }
                    return message;
                }
            };
            var defaultDatasetActivityPageStat = {
                value: 0
            };
            var DatasetActivityPageStatWireFormat3 = Datasets.DatasetActivityPageStatWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetActivityPageStat, wireFormat);
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.value) != undefined) {
                        message.value = Number(wireFormat.value);
                    }
                    return message;
                }
            };
            var defaultDatasetActivityPageTag = {
                kernelCount: 0
            };
            var DatasetActivityPageTagWireFormat3 = Datasets.DatasetActivityPageTagWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetActivityPageTag, wireFormat);
                    return message;
                }
            };
            var defaultDatasetAdminSettingsInfo = {
                slug: ""
            };
            var DatasetAdminSettingsInfoWireFormat3 = Datasets.DatasetAdminSettingsInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetAdminSettingsInfo, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maintainerOrganization) {
                        message.maintainerOrganization = Kaggle.Sdk.Datasets.OwnerWireFormat3.fromJson(wireFormat.maintainerOrganization);
                    }
                    return message;
                }
            };
            var defaultDatasetBasics = {
                datasetId: 0,
                slug: "",
                title: "",
                removed: false,
                private: false,
                description: "",
                viewCount: 0,
                downloadCount: 0,
                scriptCount: 0,
                topicCount: 0,
                overview: "",
                canEdit: false,
                coverImageUrl: "",
                voteCount: 0,
                medalUrl: "",
                downloadUrl: "",
                datasetVersionNumber: 0,
                alreadyVotedUp: false,
                inFlight: false,
                creatorDisplayName: "",
                cardImageUrl: "",
                bookmarked: false,
                datasetExternalUrl: "",
                ownerTwitter: "",
                collaborator: false,
                forumId: 0,
                datasetVersionId: 0,
                canCreateTasks: false,
                isReportedBannerDismissed: false,
                canPerformOwnerTasks: false,
                datasetHashLink: "",
                lastVersionNumber: 0,
                showAdminAllowlist: false,
                isReportedModalDismissed: false
            };
            var DatasetBasicsWireFormat3 = Datasets.DatasetBasicsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetBasics, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owner) {
                        message.owner = Kaggle.Sdk.Datasets.OwnerWireFormat3.fromJson(wireFormat.owner);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.license) {
                        message.license = Kaggle.Sdk.Datasets.LicenseWireFormat3.fromJson(wireFormat.license);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creatorKernel) {
                        message.creatorKernel = Kaggle.Sdk.Datasets.BasicKernelOutputKernelReferenceWireFormat3.fromJson(wireFormat.creatorKernel);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaboratorList) {
                        message.collaboratorList = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaboratorList);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.data) {
                        message.data = Kaggle.Sdk.Datasets.DatabundleInfoWireFormat3.fromJson(wireFormat.data);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastUpdateTime) {
                        message.lastUpdateTime = new Date(wireFormat.lastUpdateTime);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
                        message.categories = Kaggle.Sdk.Tags.TagListWireFormat3.fromJson(wireFormat.categories);
                    }
                    if (wireFormat) {
                        message.moderationStatus = KaggleSdkAbusePrivatedModerationStatusWireFormat3.fromJson(wireFormat.moderationStatus);
                    }
                    if (wireFormat) {
                        message.diffType = Kaggle.Sdk.Datasets.DatabundleDiffTypeWireFormat3.fromJson(wireFormat.diffType);
                    }
                    return message;
                }
            };
            var defaultDatasetCreationResponse = {};
            var DatasetCreationResponseWireFormat3 = Datasets.DatasetCreationResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetCreationResponse, wireFormat);
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Datasets.CreationStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundleVersionReference) {
                        message.databundleVersionReference = Kaggle.Sdk.Datasets.DatabundleVersionReferenceWireFormat3.fromJson(wireFormat.databundleVersionReference);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetVersionReference) {
                        message.datasetVersionReference = Kaggle.Sdk.Datasets.DatasetVersionReferenceWireFormat3.fromJson(wireFormat.datasetVersionReference);
                    }
                    return message;
                }
            };
            var defaultDatasetDatasourceListItem = {
                datasetId: 0,
                currentDatasetVersionId: 0,
                isPrivate: false,
                isDeleted: false
            };
            var DatasetDatasourceListItemWireFormat3 = Datasets.DatasetDatasourceListItemWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetDatasourceListItem, wireFormat);
                    if (wireFormat) {
                        message.type = Kaggle.Sdk.Datasets.DatabundleVersionTypeWireFormat3.fromJson(wireFormat.type);
                    }
                    if (wireFormat) {
                        message.diffType = Kaggle.Sdk.Datasets.DatabundleDiffTypeWireFormat3.fromJson(wireFormat.diffType);
                    }
                    return message;
                }
            };
            var defaultDatasetDto = {
                licenseId: 0,
                isPrivate: false,
                licenseGroups: [],
                owners: [],
                datasetId: 0,
                isRemoved: false,
                isVersionRemoved: false,
                datasetVersionId: 0,
                datasetVersionNumber: 0,
                lastVersionNumber: 0,
                voteCount: 0,
                creatorUserId: 0,
                hasAlreadyVotedUp: false,
                isOldDatasetVersion: false,
                numberOfViews: 0,
                numberOfDownloads: 0,
                numberOfScripts: 0,
                numberOfTopics: 0,
                numberOfTasks: 0,
                canEdit: false,
                canPerformOwnerTasks: false,
                canEditSlug: false,
                canEditPublishStatus: false,
                canEditDescription: false,
                hideVersionStatuses: false,
                datasetVersions: [],
                datasetVersionTotalCount: 0,
                feed: [],
                isNewTopic: false,
                canSeeDeletionButton: false,
                checklistDismissed: false,
                checklistCollapsed: false,
                isInFlight: false,
                bookmarked: false,
                isCollaborator: false,
                deletionNeedsReview: false,
                hasDatasetDoiApproved: false,
                canCreateDatasetTasks: false,
                blockTaskCreation: false,
                canSeeDatasetHashLink: false,
                showAdminAllowlist: false,
                isReportedBannerDismissed: false,
                isReportedModalDismissed: false
            };
            var DatasetDtoWireFormat3 = Datasets.DatasetDtoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetDto, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.data) {
                        message.data = Kaggle.Sdk.Datasets.LegacyDatabundleInfoWireFormat3.fromJson(wireFormat.data);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owner) {
                        message.owner = Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.fromJson(wireFormat.owner);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenseGroups) {
                        message.licenseGroups = wireFormat.licenseGroups.map(function(i) {
                            return Kaggle.Sdk.Datasets.LicenseGroupDtoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owners) {
                        message.owners = wireFormat.owners.map(function(i) {
                            return Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.license) {
                        message.license = Kaggle.Sdk.Datasets.LicenseDtoWireFormat3.fromJson(wireFormat.license);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastUpdated) {
                        message.lastUpdated = new Date(wireFormat.lastUpdated);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetVersions) {
                        message.datasetVersions = wireFormat.datasetVersions.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetVersionDtoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.feed) {
                        message.feed = wireFormat.feed.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityDtoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat) {
                        message.type = Kaggle.Sdk.Datasets.DatabundleVersionTypeWireFormat3.fromJson(wireFormat.type);
                    }
                    if (wireFormat) {
                        message.diffType = Kaggle.Sdk.Datasets.DatabundleDiffTypeWireFormat3.fromJson(wireFormat.diffType);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maintainerOrganization) {
                        message.maintainerOrganization = Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.fromJson(wireFormat.maintainerOrganization);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.createdByKernel) {
                        message.createdByKernel = Kaggle.Sdk.Datasets.KernelOutputKernelReferenceWireFormat3.fromJson(wireFormat.createdByKernel);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) {
                        message.usabilityRating = Kaggle.Sdk.Datasets.DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.usabilityRating);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.discussion) {
                        message.discussion = KaggleSdkDiscussionsTopicListDtoWireFormat3.fromJson(wireFormat.discussion);
                    }
                    if (wireFormat) {
                        message.currentTab = Kaggle.Sdk.Datasets.DatasetTabWireFormat3.fromJson(wireFormat.currentTab);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.newTopic) {
                        message.newTopic = KaggleSdkDiscussionsNewTopicDtoWireFormat3.fromJson(wireFormat.newTopic);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
                        message.categories = Kaggle.Sdk.Tags.TagListWireFormat3.fromJson(wireFormat.categories);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.upvoteSuggestion) {
                        message.upvoteSuggestion = Kaggle.Sdk.Datasets.UpvoteSuggestionDtoWireFormat3.fromJson(wireFormat.upvoteSuggestion);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaborators) {
                        message.collaborators = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaborators);
                    }
                    if (wireFormat) {
                        message.moderationStatus = KaggleSdkAbusePrivatedModerationStatusWireFormat3.fromJson(wireFormat.moderationStatus);
                    }
                    return message;
                }
            };
            var defaultDatasetFileSummary = {
                count: 0,
                totalSize: 0
            };
            var DatasetFileSummaryWireFormat3 = Datasets.DatasetFileSummaryWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetFileSummary, wireFormat);
                    if (wireFormat) {
                        message.fileType = Kaggle.Sdk.Datasets.Models.DatasetFileType.EnumWireFormat3.fromJson(wireFormat.fileType);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalSize) {
                        message.totalSize = parseInt(wireFormat.totalSize);
                    }
                    return message;
                }
            };
            var defaultDatasetForReview = {
                datasetId: 0
            };
            var DatasetForReviewWireFormat3 = Datasets.DatasetForReviewWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetForReview, wireFormat);
                    return message;
                }
            };
            var defaultDatasetHistory = {
                items: [],
                totalItems: 0
            };
            var DatasetHistoryWireFormat3 = Datasets.DatasetHistoryWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetHistory, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.items) {
                        message.items = wireFormat.items.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetHistoryItemWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultDatasetHistoryItem = {
                changes: []
            };
            var DatasetHistoryItemWireFormat3 = Datasets.DatasetHistoryItemWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetHistoryItem, wireFormat);
                    if (wireFormat) {
                        message.type = Kaggle.Sdk.Datasets.DatasetsActivityTypeEnumWireFormat3.fromJson(wireFormat.type);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.user) {
                        message.user = Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.fromJson(wireFormat.user);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.changes) {
                        message.changes = wireFormat.changes.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetSchemaDiffWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
                        message.date = new Date(wireFormat.date);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.summary) {
                        message.summary = Kaggle.Sdk.Datasets.DatasetSchemaDiffSummaryWireFormat3.fromJson(wireFormat.summary);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.versionInfo) {
                        message.versionInfo = Kaggle.Sdk.Datasets.DatasetHistoryVersionInfoWireFormat3.fromJson(wireFormat.versionInfo);
                    }
                    return message;
                }
            };
            var defaultDatasetHistoryVersionInfo = {
                databundleVersionId: 0
            };
            var DatasetHistoryVersionInfoWireFormat3 = Datasets.DatasetHistoryVersionInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetHistoryVersionInfo, wireFormat);
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Datasets.DatabundleVersionStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    return message;
                }
            };
            var defaultDatasetImageInfo = {
                cardImageUrl: "",
                cardImageLeft: 0,
                cardImageTop: 0,
                cardImageHeight: 0,
                cardImageWidth: 0,
                coverImageLeft: 0,
                coverImageHeight: 0,
                coverImageTop: 0,
                coverImageWidth: 0,
                coverImageUrl: "",
                originalImageUrl: "",
                thumbnailImageUrl: ""
            };
            var DatasetImageInfoWireFormat3 = Datasets.DatasetImageInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetImageInfo, wireFormat);
                    return message;
                }
            };
            var defaultDatasetLimits = {
                maxFiles: 0
            };
            var DatasetLimitsWireFormat3 = Datasets.DatasetLimitsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetLimits, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.publicLimits) {
                        message.publicLimits = Kaggle.Sdk.Datasets.DatasetPublicLimitsWireFormat3.fromJson(wireFormat.publicLimits);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateLimits) {
                        message.privateLimits = Kaggle.Sdk.Datasets.DatasetPrivateLimitsWireFormat3.fromJson(wireFormat.privateLimits);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maxFiles) {
                        message.maxFiles = parseInt(wireFormat.maxFiles);
                    }
                    return message;
                }
            };
            var defaultDatasetList = {
                items: []
            };
            var DatasetListWireFormat3 = Datasets.DatasetListWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetList, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.items) {
                        message.items = wireFormat.items.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetListItemWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultDatasetListItem = {
                datasetUrl: "",
                ownerAvatarUrl: "",
                ownerName: "",
                ownerUrl: "",
                creatorName: "",
                creatorUrl: "",
                creatorUserId: 0,
                scriptCount: 0,
                taskCount: 0,
                scriptsUrl: "",
                topicCount: 0,
                forumUrl: "",
                viewCount: 0,
                downloadCount: 0,
                fileCount: 0,
                isHidden: false,
                isFailed: false,
                bookmarked: false,
                isCollaborator: false,
                categories: [],
                licenseName: "",
                licenseShortName: "",
                commonFileTypes: [],
                downloadUrl: "",
                newKernelNotebookUrl: "",
                newKernelScriptUrl: "",
                description: "",
                rank: 0,
                hasHashLink: false
            };
            var DatasetListItemWireFormat3 = Datasets.DatasetListItemWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetListItem, wireFormat);
                    if (wireFormat) {
                        message.ownerTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.ownerTier);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
                        message.dateCreated = new Date(wireFormat.dateCreated);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateUpdated) {
                        message.dateUpdated = new Date(wireFormat.dateUpdated);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voteButton) {
                        message.voteButton = KaggleSdkCommonVoteButtonWireFormat3.fromJson(wireFormat.voteButton);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
                        message.categories = wireFormat.categories.map(function(i) {
                            return Kaggle.Sdk.Tags.TagWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetSize) {
                        message.datasetSize = parseInt(wireFormat.datasetSize);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.commonFileTypes) {
                        message.commonFileTypes = wireFormat.commonFileTypes.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetFileSummaryWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maintainerOrganization) {
                        message.maintainerOrganization = Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.fromJson(wireFormat.maintainerOrganization);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) {
                        message.usabilityRating = Kaggle.Sdk.Datasets.DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.usabilityRating);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasource) {
                        message.datasource = Kaggle.Sdk.Datasets.DatasetDatasourceListItemWireFormat3.fromJson(wireFormat.datasource);
                    }
                    return message;
                }
            };
            var defaultDatasetMaterialDto = {
                isNewTopic: false
            };
            var DatasetMaterialDtoWireFormat3 = Datasets.DatasetMaterialDtoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetMaterialDto, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.basics) {
                        message.basics = Kaggle.Sdk.Datasets.DatasetBasicsWireFormat3.fromJson(wireFormat.basics);
                    }
                    if (wireFormat) {
                        message.currentTab = Kaggle.Sdk.Datasets.DatasetTabWireFormat3.fromJson(wireFormat.currentTab);
                    }
                    return message;
                }
            };
            var defaultDatasetMetadata = {
                autoGeneratedSources: [],
                datasetId: 0,
                datasetVersionAuthors: [],
                datasetVersionId: 0,
                hasHashLink: false,
                isDatasetDoiApproved: false,
                isEditable: false,
                isPrivate: false,
                licenseGroups: [],
                licenseId: 0
            };
            var DatasetMetadataWireFormat3 = Datasets.DatasetMetadataWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetMetadata, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.autoGeneratedSources) {
                        message.autoGeneratedSources = wireFormat.autoGeneratedSources.map(function(i) {
                            return Kaggle.Sdk.Datasets.AutoGeneratedSourceWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaboratorList) {
                        message.collaboratorList = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaboratorList);
                    }
                    if (wireFormat) {
                        message.databundleDiffType = Kaggle.Sdk.Datasets.DatabundleDiffTypeWireFormat3.fromJson(wireFormat.databundleDiffType);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataCoverageAttribute) {
                        message.dataCoverageAttribute = Kaggle.Sdk.Datasets.DataCoverageAttributeWireFormat3.fromJson(wireFormat.dataCoverageAttribute);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetCreationTimestamp) {
                        message.datasetCreationTimestamp = new Date(wireFormat.datasetCreationTimestamp);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetVersionAuthors) {
                        message.datasetVersionAuthors = wireFormat.datasetVersionAuthors.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetVersionAuthorWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.expectedUpdateFrequency) {
                        message.expectedUpdateFrequency = Kaggle.Sdk.Datasets.ExpectedUpdateFrequencyWireFormat3.fromJson(wireFormat.expectedUpdateFrequency);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastDataUpdatedTimestamp) {
                        message.lastDataUpdatedTimestamp = new Date(wireFormat.lastDataUpdatedTimestamp);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenseGroups) {
                        message.licenseGroups = wireFormat.licenseGroups.map(function(i) {
                            return Kaggle.Sdk.Datasets.LicenseGroupDtoWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultDatasetPrivateLimits = {
                totalBytes: 0,
                usedBytes: 0,
                totalBytesAllVersions: 0,
                usedBytesAllVersions: 0
            };
            var DatasetPrivateLimitsWireFormat3 = Datasets.DatasetPrivateLimitsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetPrivateLimits, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalBytes) {
                        message.totalBytes = parseInt(wireFormat.totalBytes);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usedBytes) {
                        message.usedBytes = parseInt(wireFormat.usedBytes);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalBytesAllVersions) {
                        message.totalBytesAllVersions = parseInt(wireFormat.totalBytesAllVersions);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usedBytesAllVersions) {
                        message.usedBytesAllVersions = parseInt(wireFormat.usedBytesAllVersions);
                    }
                    return message;
                }
            };
            var defaultDatasetPublicLimits = {
                maxBytes: 0,
                isOrganizationLimit: false,
                isAdminLimit: false
            };
            var DatasetPublicLimitsWireFormat3 = Datasets.DatasetPublicLimitsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetPublicLimits, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maxBytes) {
                        message.maxBytes = parseInt(wireFormat.maxBytes);
                    }
                    return message;
                }
            };
            var defaultDatasetSchemaDiff = {};
            var DatasetSchemaDiffWireFormat3 = Datasets.DatasetSchemaDiffWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetSchemaDiff, wireFormat);
                    if (wireFormat) {
                        message.action = Kaggle.Sdk.Datasets.DatasetSchemaDiffActionWireFormat3.fromJson(wireFormat.action);
                    }
                    if (wireFormat) {
                        message.level = Kaggle.Sdk.Datasets.DatasetSchemaDiffContainerLevelWireFormat3.fromJson(wireFormat.level);
                    }
                    if (wireFormat) {
                        message.parentLevel = Kaggle.Sdk.Datasets.DatasetSchemaDiffContainerLevelWireFormat3.fromJson(wireFormat.parentLevel);
                    }
                    return message;
                }
            };
            var defaultDatasetSchemaDiffSummary = {
                addedCount: 0,
                modifiedCount: 0,
                deletedCount: 0,
                totalChangedEntities: 0,
                changedEntities: []
            };
            var DatasetSchemaDiffSummaryWireFormat3 = Datasets.DatasetSchemaDiffSummaryWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetSchemaDiffSummary, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.changedEntities) {
                        message.changedEntities = wireFormat.changedEntities.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetSchemaEntityWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultDatasetSchemaEntity = {};
            var DatasetSchemaEntityWireFormat3 = Datasets.DatasetSchemaEntityWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetSchemaEntity, wireFormat);
                    if (wireFormat) {
                        message.level = Kaggle.Sdk.Datasets.DatasetSchemaDiffContainerLevelWireFormat3.fromJson(wireFormat.level);
                    }
                    return message;
                }
            };
            var defaultDatasetSettings = {
                isPrivate: false,
                keywords: [],
                licenses: [],
                collaborators: [],
                data: []
            };
            var DatasetSettingsWireFormat3 = Datasets.DatasetSettingsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetSettings, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenses) {
                        message.licenses = wireFormat.licenses.map(function(i) {
                            return Kaggle.Sdk.Datasets.SettingsLicenseWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaborators) {
                        message.collaborators = wireFormat.collaborators.map(function(i) {
                            return Kaggle.Sdk.Datasets.UserRoleWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.data) {
                        message.data = wireFormat.data.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetSettingsFileWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.licenses) {
                        wireFormat.licenses = message.licenses.map(function(i) {
                            return Kaggle.Sdk.Datasets.SettingsLicenseWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.collaborators) {
                        wireFormat.collaborators = message.collaborators.map(function(i) {
                            return Kaggle.Sdk.Datasets.UserRoleWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.data) {
                        wireFormat.data = message.data.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetSettingsFileWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var defaultDatasetSettingsFile = {
                name: "",
                totalBytes: 0,
                columns: []
            };
            var DatasetSettingsFileWireFormat3 = Datasets.DatasetSettingsFileWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetSettingsFile, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalBytes) {
                        message.totalBytes = parseInt(wireFormat.totalBytes);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columns) {
                        message.columns = wireFormat.columns.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetSettingsFileColumnWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.totalBytes) {
                        wireFormat.totalBytes = message.totalBytes.toString();
                    }
                    if (message === null || message === void 0 ? void 0 : message.columns) {
                        wireFormat.columns = message.columns.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetSettingsFileColumnWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var defaultDatasetSettingsFileColumn = {
                name: ""
            };
            var DatasetSettingsFileColumnWireFormat3 = Datasets.DatasetSettingsFileColumnWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetSettingsFileColumn, wireFormat);
                    return message;
                },
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultDatasetTopicContent = {
                datasets: []
            };
            var DatasetTopicContentWireFormat3 = Datasets.DatasetTopicContentWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetTopicContent, wireFormat);
                    if (wireFormat) {
                        message.topicType = Kaggle.Sdk.Datasets.DatasetTopicEnumWireFormat3.fromJson(wireFormat.topicType);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasets) {
                        message.datasets = wireFormat.datasets.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetListItemWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultDatasetUploaderConfig = {
                allowedOwners: [],
                licenseGroups: []
            };
            var DatasetUploaderConfigWireFormat3 = Datasets.DatasetUploaderConfigWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetUploaderConfig, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingData) {
                        message.existingData = Kaggle.Sdk.Datasets.ExistingDataInfoWireFormat3.fromJson(wireFormat.existingData);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.allowedOwners) {
                        message.allowedOwners = wireFormat.allowedOwners.map(function(i) {
                            return Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenseGroups) {
                        message.licenseGroups = wireFormat.licenseGroups.map(function(i) {
                            return Kaggle.Sdk.Datasets.LicenseGroupDtoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.limits) {
                        message.limits = Kaggle.Sdk.Datasets.DatasetLimitsWireFormat3.fromJson(wireFormat.limits);
                    }
                    return message;
                }
            };
            var defaultDatasetUsabilityRating = {
                score: 0,
                coverImageScore: 0,
                fileDescriptionScore: 0,
                fileFormatScore: 0,
                licenseScore: 0,
                overviewScore: 0,
                provenanceScore: 0,
                publicKernelScore: 0,
                subtitleScore: 0,
                tagScore: 0,
                updateFrequencyScore: 0
            };
            var DatasetUsabilityRatingWireFormat3 = Datasets.DatasetUsabilityRatingWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetUsabilityRating, wireFormat);
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.score) != undefined) {
                        message.score = Number(wireFormat.score);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.coverImageScore) != undefined) {
                        message.coverImageScore = Number(wireFormat.coverImageScore);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileDescriptionScore) != undefined) {
                        message.fileDescriptionScore = Number(wireFormat.fileDescriptionScore);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileFormatScore) != undefined) {
                        message.fileFormatScore = Number(wireFormat.fileFormatScore);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenseScore) != undefined) {
                        message.licenseScore = Number(wireFormat.licenseScore);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.overviewScore) != undefined) {
                        message.overviewScore = Number(wireFormat.overviewScore);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.provenanceScore) != undefined) {
                        message.provenanceScore = Number(wireFormat.provenanceScore);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.publicKernelScore) != undefined) {
                        message.publicKernelScore = Number(wireFormat.publicKernelScore);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.subtitleScore) != undefined) {
                        message.subtitleScore = Number(wireFormat.subtitleScore);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tagScore) != undefined) {
                        message.tagScore = Number(wireFormat.tagScore);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updateFrequencyScore) != undefined) {
                        message.updateFrequencyScore = Number(wireFormat.updateFrequencyScore);
                    }
                    return message;
                }
            };
            var defaultDatasetVersionAuthor = {};
            var DatasetVersionAuthorWireFormat3 = Datasets.DatasetVersionAuthorWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetVersionAuthor, wireFormat);
                    return message;
                },
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultDatasetVersionDto = {
                id: 0,
                slug: "",
                name: "",
                versionNotes: "",
                thumbnailImageUrl: "",
                datasetVersionUrl: "",
                isRemoved: false,
                databundleVersionId: 0
            };
            var DatasetVersionDtoWireFormat3 = Datasets.DatasetVersionDtoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetVersionDto, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationDate) {
                        message.creationDate = new Date(wireFormat.creationDate);
                    }
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Datasets.DatabundleVersionStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creator) {
                        message.creator = Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.fromJson(wireFormat.creator);
                    }
                    return message;
                }
            };
            var defaultDatasetVersionReference = {
                datasetId: 0,
                datasetVersionId: 0
            };
            var DatasetVersionReferenceWireFormat3 = Datasets.DatasetVersionReferenceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDatasetVersionReference, wireFormat);
                    return message;
                }
            };
            var DeleteDatasetBySlugRequestWireFormat3 = Datasets.DeleteDatasetBySlugRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var DeleteDatasetCategoriesRequestWireFormat3 = Datasets.DeleteDatasetCategoriesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultDeleteDatasetCategoriesResponse = {};
            var DeleteDatasetCategoriesResponseWireFormat3 = Datasets.DeleteDatasetCategoriesResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDeleteDatasetCategoriesResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updatedUsabilityRating) {
                        message.updatedUsabilityRating = Kaggle.Sdk.Datasets.DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.updatedUsabilityRating);
                    }
                    return message;
                }
            };
            var DeleteDatasetHashLinkRequestWireFormat3 = Datasets.DeleteDatasetHashLinkRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var DetectDuplicateRequestWireFormat3 = Datasets.DetectDuplicateRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultDuplicationReference = {
                id: 0
            };
            var DuplicationReferenceWireFormat3 = Datasets.DuplicationReferenceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDuplicationReference, wireFormat);
                    if (wireFormat) {
                        message.type = Kaggle.Sdk.Datasets.DuplicationReferenceTypeWireFormat3.fromJson(wireFormat.type);
                    }
                    return message;
                }
            };
            var EditDatasetDescriptionRequestWireFormat3 = Datasets.EditDatasetDescriptionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultEditDatasetDescriptionResponse = {};
            var EditDatasetDescriptionResponseWireFormat3 = Datasets.EditDatasetDescriptionResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultEditDatasetDescriptionResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) {
                        message.usabilityRating = Kaggle.Sdk.Datasets.DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.usabilityRating);
                    }
                    return message;
                }
            };
            var defaultExistingDataInfo = {
                existingUploadDirectories: [],
                existingUploadFiles: [],
                existingRemoteUrls: []
            };
            var ExistingDataInfoWireFormat3 = Datasets.ExistingDataInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultExistingDataInfo, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingUploadDirectories) {
                        message.existingUploadDirectories = wireFormat.existingUploadDirectories.map(function(i) {
                            return Kaggle.Sdk.Datasets.ExistingDirectoryInfoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingUploadFiles) {
                        message.existingUploadFiles = wireFormat.existingUploadFiles.map(function(i) {
                            return Kaggle.Sdk.Datasets.ExistingFileInfoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingRemoteUrls) {
                        message.existingRemoteUrls = wireFormat.existingRemoteUrls.map(function(i) {
                            return KaggleSdkDatasetsDatabundlesRemoteUrlInfoWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultExistingDirectoryInfo = {
                name: "",
                directories: [],
                files: []
            };
            var ExistingDirectoryInfoWireFormat3 = Datasets.ExistingDirectoryInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultExistingDirectoryInfo, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.directories) {
                        message.directories = wireFormat.directories.map(function(i) {
                            return Kaggle.Sdk.Datasets.ExistingDirectoryInfoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.files) {
                        message.files = wireFormat.files.map(function(i) {
                            return Kaggle.Sdk.Datasets.ExistingFileInfoWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.directories) {
                        wireFormat.directories = message.directories.map(function(i) {
                            return Kaggle.Sdk.Datasets.ExistingDirectoryInfoWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.files) {
                        wireFormat.files = message.files.map(function(i) {
                            return Kaggle.Sdk.Datasets.ExistingFileInfoWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var defaultExistingFileInfo = {
                name: "",
                size: 0
            };
            var ExistingFileInfoWireFormat3 = Datasets.ExistingFileInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultExistingFileInfo, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.size) {
                        message.size = parseInt(wireFormat.size);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.legacyInfo) {
                        message.legacyInfo = Kaggle.Sdk.Datasets.LegacyExistingFileInfoWireFormat3.fromJson(wireFormat.legacyInfo);
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.size) {
                        wireFormat.size = message.size.toString();
                    }
                    if (message === null || message === void 0 ? void 0 : message.legacyInfo) {
                        wireFormat.legacyInfo = Kaggle.Sdk.Datasets.LegacyExistingFileInfoWireFormat3.toJson(message.legacyInfo);
                    }
                    return wireFormat;
                }
            };
            var defaultExpectedUpdateFrequency = {
                isAutoUpdatedTypedDataset: false,
                updateFrequency: ""
            };
            var ExpectedUpdateFrequencyWireFormat3 = Datasets.ExpectedUpdateFrequencyWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultExpectedUpdateFrequency, wireFormat);
                    return message;
                }
            };
            var GcsFileSetInfoWireFormat3 = Datasets.GcsFileSetInfoWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetCompetitionUploaderConfigRequestWireFormat3 = Datasets.GetCompetitionUploaderConfigRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.competitionDatabundleType) {
                        wireFormat.competitionDatabundleType = Kaggle.Sdk.Datasets.CompetitionDatabundleTypeWireFormat3.toJson(message.competitionDatabundleType);
                    }
                    return wireFormat;
                }
            };
            var GetDatabundleVersionCreationStatusRequestWireFormat3 = Datasets.GetDatabundleVersionCreationStatusRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetDatasetActivityFeedRequestWireFormat3 = Datasets.GetDatasetActivityFeedRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetDatasetActivityFeedResponse = {
                activities: []
            };
            var GetDatasetActivityFeedResponseWireFormat3 = Datasets.GetDatasetActivityFeedResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetDatasetActivityFeedResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.activities) {
                        message.activities = wireFormat.activities.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetActivityDtoWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var GetDatasetActivityRequestWireFormat3 = Datasets.GetDatasetActivityRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetDatasetAdminSettingsRequestWireFormat3 = Datasets.GetDatasetAdminSettingsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetDatasetAdminSettingsResponse = {};
            var GetDatasetAdminSettingsResponseWireFormat3 = Datasets.GetDatasetAdminSettingsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetDatasetAdminSettingsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.info) {
                        message.info = Kaggle.Sdk.Datasets.DatasetAdminSettingsInfoWireFormat3.fromJson(wireFormat.info);
                    }
                    return message;
                }
            };
            var GetDatasetBasicsRequestWireFormat3 = Datasets.GetDatasetBasicsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetDatasetByUrlRequestWireFormat3 = Datasets.GetDatasetByUrlRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetDatasetByUrlResponse = {};
            var GetDatasetByUrlResponseWireFormat3 = Datasets.GetDatasetByUrlResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetDatasetByUrlResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataset) {
                        message.dataset = Kaggle.Sdk.Datasets.DatasetListItemWireFormat3.fromJson(wireFormat.dataset);
                    }
                    return message;
                }
            };
            var GetDatasetHistoryRequestWireFormat3 = Datasets.GetDatasetHistoryRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetDatasetImageInfoRequestWireFormat3 = Datasets.GetDatasetImageInfoRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetDatasetImageInfoResponse = {};
            var GetDatasetImageInfoResponseWireFormat3 = Datasets.GetDatasetImageInfoResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetDatasetImageInfoResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.info) {
                        message.info = Kaggle.Sdk.Datasets.DatasetImageInfoWireFormat3.fromJson(wireFormat.info);
                    }
                    return message;
                }
            };
            var GetDatasetLimitsRequestWireFormat3 = Datasets.GetDatasetLimitsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetDatasetMetadataRequestWireFormat3 = Datasets.GetDatasetMetadataRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetDatasetsByIdRequestWireFormat3 = Datasets.GetDatasetsByIdRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetDatasetSettingsRequestWireFormat3 = Datasets.GetDatasetSettingsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetDatasetSuggestionsRequestWireFormat3 = Datasets.GetDatasetSuggestionsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetDatasetSuggestionsResponse = {
                suggestions: []
            };
            var GetDatasetSuggestionsResponseWireFormat3 = Datasets.GetDatasetSuggestionsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetDatasetSuggestionsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.suggestions) {
                        message.suggestions = wireFormat.suggestions.map(function(i) {
                            return Kaggle.Sdk.Datasets.SuggestionWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var GetDatasetUploaderConfigRequestWireFormat3 = Datasets.GetDatasetUploaderConfigRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetDatasetUpvotesRequestWireFormat3 = Datasets.GetDatasetUpvotesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetDatasetUpvotesResponse = {
                voteCount: 0,
                medalVoteCount: 0,
                upVoters: []
            };
            var GetDatasetUpvotesResponseWireFormat3 = Datasets.GetDatasetUpvotesResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetDatasetUpvotesResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.upVoters) {
                        message.upVoters = wireFormat.upVoters.map(function(i) {
                            return KaggleSdkUsersUserWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var GetDatasetUsabilityRatingRequestWireFormat3 = Datasets.GetDatasetUsabilityRatingRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetDatasetUsabilityRatingResponse = {};
            var GetDatasetUsabilityRatingResponseWireFormat3 = Datasets.GetDatasetUsabilityRatingResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetDatasetUsabilityRatingResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rating) {
                        message.rating = Kaggle.Sdk.Datasets.DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.rating);
                    }
                    return message;
                }
            };
            var GetDataViewExternalRequestWireFormat3 = Datasets.GetDataViewExternalRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.verificationInfo) {
                        wireFormat.verificationInfo = KaggleSdkDatasetsDatabundlesDatabundleVerificationInfoWireFormat3.toJson(message.verificationInfo);
                    }
                    if (message === null || message === void 0 ? void 0 : message.tableQuery) {
                        wireFormat.tableQuery = Kaggle.Sdk.Datasets.DataViewer.Protos.TableQueryWireFormat3.toJson(message.tableQuery);
                    }
                    return wireFormat;
                }
            };
            var GetGithubRepositoryInfoRequestWireFormat3 = Datasets.GetGithubRepositoryInfoRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetGithubRepositoryInfoResponse = {
                repositoryContents: []
            };
            var GetGithubRepositoryInfoResponseWireFormat3 = Datasets.GetGithubRepositoryInfoResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetGithubRepositoryInfoResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.repositoryContents) {
                        message.repositoryContents = wireFormat.repositoryContents.map(function(i) {
                            return Kaggle.Sdk.Datasets.GithubRepositoryContentWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var GetKernelOutputDatasetRequestWireFormat3 = Datasets.GetKernelOutputDatasetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetKernelOutputDataViewExternalRequestWireFormat3 = Datasets.GetKernelOutputDataViewExternalRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.tableQuery) {
                        wireFormat.tableQuery = Kaggle.Sdk.Datasets.DataViewer.Protos.TableQueryWireFormat3.toJson(message.tableQuery);
                    }
                    return wireFormat;
                }
            };
            var GetLandingPageTopicsRequestWireFormat3 = Datasets.GetLandingPageTopicsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetLandingPageTopicsResponse = {
                topics: []
            };
            var GetLandingPageTopicsResponseWireFormat3 = Datasets.GetLandingPageTopicsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetLandingPageTopicsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topics) {
                        message.topics = wireFormat.topics.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetTopicContentWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var GetPossibleCompetitionDatasetsRequestWireFormat3 = Datasets.GetPossibleCompetitionDatasetsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetProfileDatasetStatsRequestWireFormat3 = Datasets.GetProfileDatasetStatsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetProfileDatasetStatsResponse = {
                datasetsCount: 0,
                upvotesCount: 0,
                tasksCount: 0,
                acceptedSubmissionsCount: 0
            };
            var GetProfileDatasetStatsResponseWireFormat3 = Datasets.GetProfileDatasetStatsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetProfileDatasetStatsResponse, wireFormat);
                    return message;
                }
            };
            var GetRecentlyViewedDatasetsRequestWireFormat3 = Datasets.GetRecentlyViewedDatasetsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetRemoteUrlFileInfoRequestWireFormat3 = Datasets.GetRemoteUrlFileInfoRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetTopicalDatasetsRequestWireFormat3 = Datasets.GetTopicalDatasetsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.topicType) {
                        wireFormat.topicType = Kaggle.Sdk.Datasets.DatasetTopicEnumWireFormat3.toJson(message.topicType);
                    }
                    if (message === null || message === void 0 ? void 0 : message.sortBy) {
                        wireFormat.sortBy = Kaggle.Sdk.Datasets.Models.DatasetSortBy.EnumWireFormat3.toJson(message.sortBy);
                    }
                    if (message === null || message === void 0 ? void 0 : message.initialResponseUpdateTime) {
                        wireFormat.initialResponseUpdateTime = message.initialResponseUpdateTime.toISOString();
                    }
                    return wireFormat;
                }
            };
            var defaultGetTopicalDatasetsResponse = {
                datasets: [],
                hasMore: false
            };
            var GetTopicalDatasetsResponseWireFormat3 = Datasets.GetTopicalDatasetsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetTopicalDatasetsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasets) {
                        message.datasets = wireFormat.datasets.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetListItemWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.initialResponseUpdateTime) {
                        message.initialResponseUpdateTime = new Date(wireFormat.initialResponseUpdateTime);
                    }
                    return message;
                }
            };
            var GetUserDoiDatasetsRequestWireFormat3 = Datasets.GetUserDoiDatasetsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetUserDoiDatasetsResponse = {
                datasetIds: []
            };
            var GetUserDoiDatasetsResponseWireFormat3 = Datasets.GetUserDoiDatasetsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetUserDoiDatasetsResponse, wireFormat);
                    return message;
                }
            };
            var defaultGithubRepositoryContent = {
                name: "",
                repositoryPath: "",
                size: 0,
                children: []
            };
            var GithubRepositoryContentWireFormat3 = Datasets.GithubRepositoryContentWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGithubRepositoryContent, wireFormat);
                    if (wireFormat) {
                        message.type = Kaggle.Sdk.Datasets.GithubRepositoryContentTypeWireFormat3.fromJson(wireFormat.type);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.size) {
                        message.size = parseInt(wireFormat.size);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
                        message.children = wireFormat.children.map(function(i) {
                            return Kaggle.Sdk.Datasets.GithubRepositoryContentWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultKernelOutputDatasetReference = {
                datasetId: 0,
                currentDatasetVersionId: 0,
                title: "",
                isPrivate: false,
                slug: ""
            };
            var KernelOutputDatasetReferenceWireFormat3 = Datasets.KernelOutputDatasetReferenceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelOutputDatasetReference, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.license) {
                        message.license = Kaggle.Sdk.Datasets.LicenseDtoWireFormat3.fromJson(wireFormat.license);
                    }
                    return message;
                }
            };
            var defaultKernelOutputKernelReference = {
                kernelId: 0,
                isPrivate: false,
                outputFiles: []
            };
            var KernelOutputKernelReferenceWireFormat3 = Datasets.KernelOutputKernelReferenceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelOutputKernelReference, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owner) {
                        message.owner = Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.fromJson(wireFormat.owner);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outputFiles) {
                        message.outputFiles = wireFormat.outputFiles.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelSessionOutputFileWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateOutputToDatasetEnabled) {
                        message.dateOutputToDatasetEnabled = new Date(wireFormat.dateOutputToDatasetEnabled);
                    }
                    return message;
                }
            };
            var defaultKernelTaskSubmissionInfo = {
                isAcceptedSolution: false
            };
            var KernelTaskSubmissionInfoWireFormat3 = Datasets.KernelTaskSubmissionInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelTaskSubmissionInfo, wireFormat);
                    return message;
                }
            };
            var defaultLegacyDatabundleInfo = {
                databundleVersionId: 0
            };
            var LegacyDatabundleInfoWireFormat3 = Datasets.LegacyDatabundleInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultLegacyDatabundleInfo, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundle) {
                        message.databundle = KaggleSdkDatasetsDatabundlesDatabundleWireFormat3.fromJson(wireFormat.databundle);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundleVersion) {
                        message.databundleVersion = KaggleSdkDatasetsDatabundlesDatabundleVersionWireFormat3.fromJson(wireFormat.databundleVersion);
                    }
                    return message;
                }
            };
            var defaultLegacyExistingFileInfo = {
                databundleVersionObjectId: 0,
                blobFileId: 0
            };
            var LegacyExistingFileInfoWireFormat3 = Datasets.LegacyExistingFileInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultLegacyExistingFileInfo, wireFormat);
                    return message;
                },
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultLicense = {
                id: 0,
                name: "",
                url: ""
            };
            var LicenseWireFormat3 = Datasets.LicenseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultLicense, wireFormat);
                    return message;
                }
            };
            var defaultLicenseDto = {
                id: 0,
                name: "",
                description: ""
            };
            var LicenseDtoWireFormat3 = Datasets.LicenseDtoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultLicenseDto, wireFormat);
                    return message;
                }
            };
            var defaultLicenseGroupDto = {
                id: 0,
                licenses: []
            };
            var LicenseGroupDtoWireFormat3 = Datasets.LicenseGroupDtoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultLicenseGroupDto, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenses) {
                        message.licenses = wireFormat.licenses.map(function(i) {
                            return Kaggle.Sdk.Datasets.LicenseDtoWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultOwner = {
                id: 0,
                imageUrl: "",
                organization: false,
                maxFileSizeBytes: 0,
                name: "",
                organizationMemberCount: 0,
                profileUrl: "",
                slug: ""
            };
            var OwnerWireFormat3 = Datasets.OwnerWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultOwner, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maxFileSizeBytes) {
                        message.maxFileSizeBytes = parseInt(wireFormat.maxFileSizeBytes);
                    }
                    if (wireFormat) {
                        message.userTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.userTier);
                    }
                    return message;
                }
            };
            var defaultOwnerDto = {
                id: 0,
                isOrganization: false,
                name: "",
                slug: ""
            };
            var OwnerDtoWireFormat3 = Datasets.OwnerDtoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultOwnerDto, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maxFileSizeBytes) {
                        message.maxFileSizeBytes = parseInt(wireFormat.maxFileSizeBytes);
                    }
                    if (wireFormat) {
                        message.userTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.userTier);
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.maxFileSizeBytes) {
                        wireFormat.maxFileSizeBytes = message.maxFileSizeBytes.toString();
                    }
                    if (message === null || message === void 0 ? void 0 : message.userTier) {
                        wireFormat.userTier = KaggleSdkUsersUserAchievementTierWireFormat3.toJson(message.userTier);
                    }
                    return wireFormat;
                }
            };
            var RecreateDatasetArchiveRequestWireFormat3 = Datasets.RecreateDatasetArchiveRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultRecreateDatasetArchiveResponse = {
                databundleVersionId: 0,
                message: ""
            };
            var RecreateDatasetArchiveResponseWireFormat3 = Datasets.RecreateDatasetArchiveResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultRecreateDatasetArchiveResponse, wireFormat);
                    return message;
                }
            };
            var RefreshRemoteDatasetRequestWireFormat3 = Datasets.RefreshRemoteDatasetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.settings) {
                        wireFormat.settings = Kaggle.Sdk.Datasets.DataCreationSettingsWireFormat3.toJson(message.settings);
                    }
                    return wireFormat;
                }
            };
            var defaultRemoteUrlUploadFile = {
                contentLength: 0
            };
            var RemoteUrlUploadFileWireFormat3 = Datasets.RemoteUrlUploadFileWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultRemoteUrlUploadFile, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentLength) {
                        message.contentLength = parseInt(wireFormat.contentLength);
                    }
                    return message;
                }
            };
            var SearchDatasetsRequestWireFormat3 = Datasets.SearchDatasetsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.group) {
                        wireFormat.group = Kaggle.Sdk.Datasets.Models.DatasetSelectionGroup.EnumWireFormat3.toJson(message.group);
                    }
                    if (message === null || message === void 0 ? void 0 : message.size) {
                        wireFormat.size = Kaggle.Sdk.Datasets.Models.DatasetSizeGroup.EnumWireFormat3.toJson(message.size);
                    }
                    if (message === null || message === void 0 ? void 0 : message.fileType) {
                        wireFormat.fileType = Kaggle.Sdk.Datasets.Models.DatasetFileTypeGroup.EnumWireFormat3.toJson(message.fileType);
                    }
                    if (message === null || message === void 0 ? void 0 : message.license) {
                        wireFormat.license = Kaggle.Sdk.Datasets.Models.DatasetLicenseGroup.EnumWireFormat3.toJson(message.license);
                    }
                    if (message === null || message === void 0 ? void 0 : message.viewed) {
                        wireFormat.viewed = Kaggle.Sdk.Datasets.Models.DatasetViewedGroup.EnumWireFormat3.toJson(message.viewed);
                    }
                    if (message === null || message === void 0 ? void 0 : message.sortBy) {
                        wireFormat.sortBy = Kaggle.Sdk.Datasets.Models.DatasetSortBy.EnumWireFormat3.toJson(message.sortBy);
                    }
                    if (message === null || message === void 0 ? void 0 : message.minSize) {
                        wireFormat.minSize = message.minSize.toString();
                    }
                    if (message === null || message === void 0 ? void 0 : message.maxSize) {
                        wireFormat.maxSize = message.maxSize.toString();
                    }
                    if (message === null || message === void 0 ? void 0 : message.topicalDataset) {
                        wireFormat.topicalDataset = Kaggle.Sdk.Datasets.TopicalDatasetWireFormat3.toJson(message.topicalDataset);
                    }
                    return wireFormat;
                }
            };
            var defaultSearchDatasetsResponse = {
                hasMore: false
            };
            var SearchDatasetsResponseWireFormat3 = Datasets.SearchDatasetsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultSearchDatasetsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetList) {
                        message.datasetList = Kaggle.Sdk.Datasets.DatasetListWireFormat3.fromJson(wireFormat.datasetList);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topicalDataset) {
                        message.topicalDataset = Kaggle.Sdk.Datasets.TopicalDatasetWireFormat3.fromJson(wireFormat.topicalDataset);
                    }
                    return message;
                }
            };
            var SetDatabundleVersionNotesRequestWireFormat3 = Datasets.SetDatabundleVersionNotesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var SetDatasetChecklistVisibilityRequestWireFormat3 = Datasets.SetDatasetChecklistVisibilityRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.visibility) {
                        wireFormat.visibility = Kaggle.Sdk.Datasets.ChecklistVisibilityWireFormat3.toJson(message.visibility);
                    }
                    return wireFormat;
                }
            };
            var SetDatasetCollaboratorListRequestWireFormat3 = Datasets.SetDatasetCollaboratorListRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.collaboratorList) {
                        wireFormat.collaboratorList = KaggleSdkUsersCollaboratorListWireFormat3.toJson(message.collaboratorList);
                    }
                    return wireFormat;
                }
            };
            var SetDatasetSettingsRequestWireFormat3 = Datasets.SetDatasetSettingsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.settings) {
                        wireFormat.settings = Kaggle.Sdk.Datasets.DatasetSettingsWireFormat3.toJson(message.settings);
                    }
                    return wireFormat;
                }
            };
            var defaultSettingsLicense = {};
            var SettingsLicenseWireFormat3 = Datasets.SettingsLicenseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultSettingsLicense, wireFormat);
                    return message;
                },
                toJson: function toJson(message) {
                    return message;
                }
            };
            var SoftDeleteDatasetsForOrgRequestWireFormat3 = Datasets.SoftDeleteDatasetsForOrgRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var SoftDeleteDatasetsForUserRequestWireFormat3 = Datasets.SoftDeleteDatasetsForUserRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultStorageLocation = {};
            var StorageLocationWireFormat3 = Datasets.StorageLocationWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultStorageLocation, wireFormat);
                    return message;
                }
            };
            var defaultSuggestion = {
                entityId: 0
            };
            var SuggestionWireFormat3 = Datasets.SuggestionWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultSuggestion, wireFormat);
                    if (wireFormat) {
                        message.entityType = Kaggle.Sdk.Datasets.SuggestionTypeWireFormat3.fromJson(wireFormat.entityType);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owner) {
                        message.owner = Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.fromJson(wireFormat.owner);
                    }
                    return message;
                }
            };
            var defaultTopicalDataset = {
                isPopular: false,
                isTrending: false
            };
            var TopicalDatasetWireFormat3 = Datasets.TopicalDatasetWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultTopicalDataset, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topicUpdateTime) {
                        message.topicUpdateTime = new Date(wireFormat.topicUpdateTime);
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.topicUpdateTime) {
                        wireFormat.topicUpdateTime = message.topicUpdateTime.toISOString();
                    }
                    return wireFormat;
                }
            };
            var UndeleteDatasetsForUserRequestWireFormat3 = Datasets.UndeleteDatasetsForUserRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var UpdateDatasetCollaboratorsRequestWireFormat3 = Datasets.UpdateDatasetCollaboratorsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.collaborators) {
                        wireFormat.collaborators = KaggleSdkUsersCollaboratorListWireFormat3.toJson(message.collaborators);
                    }
                    return wireFormat;
                }
            };
            var UpdateDatasetGeneralRequestWireFormat3 = Datasets.UpdateDatasetGeneralRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.owner) {
                        wireFormat.owner = Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.toJson(message.owner);
                    }
                    if (message === null || message === void 0 ? void 0 : message.diffType) {
                        wireFormat.diffType = Kaggle.Sdk.Datasets.DatabundleDiffTypeWireFormat3.toJson(message.diffType);
                    }
                    if (message === null || message === void 0 ? void 0 : message.updateFrequency) {
                        wireFormat.updateFrequency = Kaggle.Sdk.Datasets.RemoteUrlUpdateFrequencyWireFormat3.toJson(message.updateFrequency);
                    }
                    if (message === null || message === void 0 ? void 0 : message.updateMask) {
                        var _paths;
                        wireFormat.updateMask = ((_paths = message.updateMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
                    }
                    return wireFormat;
                }
            };
            var defaultUpdateDatasetGeneralSettingsResponse = {};
            var UpdateDatasetGeneralSettingsResponseWireFormat3 = Datasets.UpdateDatasetGeneralSettingsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateDatasetGeneralSettingsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) {
                        message.usabilityRating = Kaggle.Sdk.Datasets.DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.usabilityRating);
                    }
                    return message;
                }
            };
            var UpdateDatasetImagesRequestWireFormat3 = Datasets.UpdateDatasetImagesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.image) {
                        wireFormat.image = KaggleSdkCommonCroppedImageUploadWireFormat3.toJson(message.image);
                    }
                    return wireFormat;
                }
            };
            var defaultUpdateDatasetImagesResponse = {
                cardImageUrl: "",
                coverImageUrl: "",
                thumbnailImageUrl: "",
                originalImageUrl: ""
            };
            var UpdateDatasetImagesResponseWireFormat3 = Datasets.UpdateDatasetImagesResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateDatasetImagesResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) {
                        message.usabilityRating = Kaggle.Sdk.Datasets.DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.usabilityRating);
                    }
                    return message;
                }
            };
            var UpdateDatasetMetadataRequestWireFormat3 = Datasets.UpdateDatasetMetadataRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.dataCoverageAttribute) {
                        wireFormat.dataCoverageAttribute = Kaggle.Sdk.Datasets.DataCoverageAttributeWireFormat3.toJson(message.dataCoverageAttribute);
                    }
                    if (message === null || message === void 0 ? void 0 : message.datasetVersionAuthors) {
                        wireFormat.datasetVersionAuthors = message.datasetVersionAuthors.map(function(i) {
                            return Kaggle.Sdk.Datasets.DatasetVersionAuthorWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var UpdateDatasetPrivacyRequestWireFormat3 = Datasets.UpdateDatasetPrivacyRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var UpdateDatasetRequestWireFormat3 = Datasets.UpdateDatasetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.maintainerOrganization) {
                        wireFormat.maintainerOrganization = Kaggle.Sdk.Datasets.OwnerDtoWireFormat3.toJson(message.maintainerOrganization);
                    }
                    return wireFormat;
                }
            };
            var defaultUpdateDatasetResponse = {};
            var UpdateDatasetResponseWireFormat3 = Datasets.UpdateDatasetResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateDatasetResponse, wireFormat);
                    return message;
                }
            };
            var UploadDirectoryInfoWireFormat3 = Datasets.UploadDirectoryInfoWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.directories) {
                        wireFormat.directories = message.directories.map(function(i) {
                            return Kaggle.Sdk.Datasets.UploadDirectoryInfoWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.files) {
                        wireFormat.files = message.files.map(function(i) {
                            return Kaggle.Sdk.Datasets.UploadFileInfoWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var UploadFileInfoWireFormat3 = Datasets.UploadFileInfoWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var UploadKernelOutputInfoWireFormat3 = Datasets.UploadKernelOutputInfoWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultUpvoteSuggestionDto = {
                voteCount: 0,
                medalVoteCount: 0,
                upVoters: []
            };
            var UpvoteSuggestionDtoWireFormat3 = Datasets.UpvoteSuggestionDtoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpvoteSuggestionDto, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.upVoters) {
                        message.upVoters = wireFormat.upVoters.map(function(i) {
                            return KaggleSdkCommonSimpleUserDtoWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultUserRole = {
                username: ""
            };
            var UserRoleWireFormat3 = Datasets.UserRoleWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUserRole, wireFormat);
                    if (wireFormat) {
                        message.role = KaggleSdkUsersCollaboratorTypeWireFormat3.fromJson(wireFormat.role);
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.role) {
                        wireFormat.role = KaggleSdkUsersCollaboratorTypeWireFormat3.toJson(message.role);
                    }
                    return wireFormat;
                }
            };
            var VoteOnDatasetRequestWireFormat3 = Datasets.VoteOnDatasetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.voteType) {
                        wireFormat.voteType = KaggleSdkCommonVoteTypeWireFormat3.toJson(message.voteType);
                    }
                    return wireFormat;
                }
            };
            var ActivityPageStatus;
            (function(ActivityPageStatus) {
                ActivityPageStatus["NOT_RELEVANT"] = "notRelevant";
                ActivityPageStatus["NO_SUMMARY_GENERATED"] = "noSummaryGenerated";
                ActivityPageStatus["HAS_SUMMARY"] = "hasSummary";
            })(ActivityPageStatus = Datasets.ActivityPageStatus || (Datasets.ActivityPageStatus = {}));
            var ActivityPageStatusWireFormat3 = Datasets.ActivityPageStatusWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "NOT_RELEVANT":
                        default:
                            return ActivityPageStatus.NOT_RELEVANT;
                        case "NO_SUMMARY_GENERATED":
                            return ActivityPageStatus.NO_SUMMARY_GENERATED;
                        case "HAS_SUMMARY":
                            return ActivityPageStatus.HAS_SUMMARY;
                    }
                }
            };
            var ChecklistVisibility;
            (function(ChecklistVisibility) {
                ChecklistVisibility["UNSPECIFIED"] = "unspecified";
                ChecklistVisibility["EXPANDED"] = "expanded";
                ChecklistVisibility["COLLAPSED"] = "collapsed";
                ChecklistVisibility["DISMISSED"] = "dismissed";
            })(ChecklistVisibility = Datasets.ChecklistVisibility || (Datasets.ChecklistVisibility = {}));
            var ChecklistVisibilityWireFormat3 = Datasets.ChecklistVisibilityWireFormat3 = {
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case ChecklistVisibility.UNSPECIFIED:
                        case 0:
                        default:
                            return "CHECKLIST_VISIBILITY_UNSPECIFIED";
                        case ChecklistVisibility.EXPANDED:
                        case 1:
                            return "EXPANDED";
                        case ChecklistVisibility.COLLAPSED:
                        case 2:
                            return "COLLAPSED";
                        case ChecklistVisibility.DISMISSED:
                        case 3:
                            return "DISMISSED";
                    }
                }
            };
            var CompetitionDatabundleType;
            (function(CompetitionDatabundleType) {
                CompetitionDatabundleType["UNSPECIFIED"] = "unspecified";
                CompetitionDatabundleType["PUBLIC"] = "public";
                CompetitionDatabundleType["RERUN"] = "rerun";
            })(CompetitionDatabundleType = Datasets.CompetitionDatabundleType || (Datasets.CompetitionDatabundleType = {}));
            var CompetitionDatabundleTypeWireFormat3 = Datasets.CompetitionDatabundleTypeWireFormat3 = {
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case CompetitionDatabundleType.UNSPECIFIED:
                        case 0:
                        default:
                            return "UNSPECIFIED";
                        case CompetitionDatabundleType.PUBLIC:
                        case 1:
                            return "PUBLIC";
                        case CompetitionDatabundleType.RERUN:
                        case 2:
                            return "RERUN";
                    }
                }
            };
            var CreationStatus;
            (function(CreationStatus) {
                CreationStatus["OK"] = "ok";
                CreationStatus["ERROR"] = "error";
            })(CreationStatus = Datasets.CreationStatus || (Datasets.CreationStatus = {}));
            var CreationStatusWireFormat3 = Datasets.CreationStatusWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "CREATION_STATUS_OK":
                        default:
                            return CreationStatus.OK;
                        case "CREATION_STATUS_ERROR":
                            return CreationStatus.ERROR;
                    }
                }
            };
            var DatabundleDiffType;
            (function(DatabundleDiffType) {
                DatabundleDiffType["REALTIME"] = "realtime";
                DatabundleDiffType["UNVERSIONED"] = "unversioned";
                DatabundleDiffType["VERSIONED"] = "versioned";
            })(DatabundleDiffType = Datasets.DatabundleDiffType || (Datasets.DatabundleDiffType = {}));
            var DatabundleDiffTypeWireFormat3 = Datasets.DatabundleDiffTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "REALTIME":
                        default:
                            return DatabundleDiffType.REALTIME;
                        case "UNVERSIONED":
                            return DatabundleDiffType.UNVERSIONED;
                        case "VERSIONED":
                            return DatabundleDiffType.VERSIONED;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case DatabundleDiffType.REALTIME:
                        case 0:
                        default:
                            return "REALTIME";
                        case DatabundleDiffType.UNVERSIONED:
                        case 1:
                            return "UNVERSIONED";
                        case DatabundleDiffType.VERSIONED:
                        case 2:
                            return "VERSIONED";
                    }
                }
            };
            var DatabundleStatus;
            (function(DatabundleStatus) {
                DatabundleStatus["CREATED"] = "created";
                DatabundleStatus["PROCESSING"] = "processing";
                DatabundleStatus["ERROR"] = "error";
                DatabundleStatus["READY"] = "ready";
            })(DatabundleStatus = Datasets.DatabundleStatus || (Datasets.DatabundleStatus = {}));
            var DatabundleStatusWireFormat3 = Datasets.DatabundleStatusWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DATABUNDLE_STATUS_CREATED":
                        default:
                            return DatabundleStatus.CREATED;
                        case "DATABUNDLE_STATUS_PROCESSING":
                            return DatabundleStatus.PROCESSING;
                        case "DATABUNDLE_STATUS_ERROR":
                            return DatabundleStatus.ERROR;
                        case "DATABUNDLE_STATUS_READY":
                            return DatabundleStatus.READY;
                    }
                }
            };
            var DatabundleType;
            (function(DatabundleType) {
                DatabundleType["UNSPECIFIED"] = "unspecified";
                DatabundleType["GENERAL"] = "general";
                DatabundleType["DATASET"] = "dataset";
                DatabundleType["COMPETITION"] = "competition";
                DatabundleType["NOTEBOOK"] = "notebook";
                DatabundleType["COMPETITION_RERUN"] = "competitionRerun";
            })(DatabundleType = Datasets.DatabundleType || (Datasets.DatabundleType = {}));
            var DatabundleTypeWireFormat3 = Datasets.DatabundleTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DATABUNDLE_TYPE_UNSPECIFIED":
                        default:
                            return DatabundleType.UNSPECIFIED;
                        case "DATABUNDLE_TYPE_GENERAL":
                            return DatabundleType.GENERAL;
                        case "DATABUNDLE_TYPE_DATASET":
                            return DatabundleType.DATASET;
                        case "DATABUNDLE_TYPE_COMPETITION":
                            return DatabundleType.COMPETITION;
                        case "DATABUNDLE_TYPE_NOTEBOOK":
                            return DatabundleType.NOTEBOOK;
                        case "DATABUNDLE_TYPE_COMPETITION_RERUN":
                            return DatabundleType.COMPETITION_RERUN;
                    }
                }
            };
            var DatabundleVersionStatus;
            (function(DatabundleVersionStatus) {
                DatabundleVersionStatus["NOT_YET_PERSISTED"] = "notYetPersisted";
                DatabundleVersionStatus["BLOBS_RECEIVED"] = "blobsReceived";
                DatabundleVersionStatus["BLOBS_DECOMPRESSED"] = "blobsDecompressed";
                DatabundleVersionStatus["BLOBS_COPIED_TO_SDS"] = "blobsCopiedToSds";
                DatabundleVersionStatus["INDIVIDUAL_BLOBS_COMPRESSED"] = "individualBlobsCompressed";
                DatabundleVersionStatus["READY"] = "ready";
                DatabundleVersionStatus["FAILED"] = "failed";
                DatabundleVersionStatus["DELETED"] = "deleted";
                DatabundleVersionStatus["REPROCESSING"] = "reprocessing";
            })(DatabundleVersionStatus = Datasets.DatabundleVersionStatus || (Datasets.DatabundleVersionStatus = {}));
            var DatabundleVersionStatusWireFormat3 = Datasets.DatabundleVersionStatusWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "NOT_YET_PERSISTED":
                        default:
                            return DatabundleVersionStatus.NOT_YET_PERSISTED;
                        case "BLOBS_RECEIVED":
                            return DatabundleVersionStatus.BLOBS_RECEIVED;
                        case "BLOBS_DECOMPRESSED":
                            return DatabundleVersionStatus.BLOBS_DECOMPRESSED;
                        case "BLOBS_COPIED_TO_SDS":
                            return DatabundleVersionStatus.BLOBS_COPIED_TO_SDS;
                        case "INDIVIDUAL_BLOBS_COMPRESSED":
                            return DatabundleVersionStatus.INDIVIDUAL_BLOBS_COMPRESSED;
                        case "READY":
                            return DatabundleVersionStatus.READY;
                        case "FAILED":
                            return DatabundleVersionStatus.FAILED;
                        case "DELETED":
                            return DatabundleVersionStatus.DELETED;
                        case "REPROCESSING":
                            return DatabundleVersionStatus.REPROCESSING;
                    }
                }
            };
            var DatabundleVersionType;
            (function(DatabundleVersionType) {
                DatabundleVersionType["UNSPECIFIED"] = "unspecified";
                DatabundleVersionType["FILESET"] = "fileset";
                DatabundleVersionType["BIG_QUERY"] = "bigQuery";
                DatabundleVersionType["REMOTE_URL_FILE_SET"] = "remoteUrlFileSet";
                DatabundleVersionType["REMOTE_GIT_REPOSITORY_FILE_SET"] = "remoteGitRepositoryFileSet";
                DatabundleVersionType["KERNEL_OUTPUT_FILE_SET"] = "kernelOutputFileSet";
                DatabundleVersionType["GCS_FILE_SET"] = "gcsFileSet";
            })(DatabundleVersionType = Datasets.DatabundleVersionType || (Datasets.DatabundleVersionType = {}));
            var DatabundleVersionTypeWireFormat3 = Datasets.DatabundleVersionTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DATABUNDLE_VERSION_TYPE_UNSPECIFIED":
                        default:
                            return DatabundleVersionType.UNSPECIFIED;
                        case "FILESET":
                            return DatabundleVersionType.FILESET;
                        case "BIG_QUERY":
                            return DatabundleVersionType.BIG_QUERY;
                        case "REMOTE_URL_FILE_SET":
                            return DatabundleVersionType.REMOTE_URL_FILE_SET;
                        case "REMOTE_GIT_REPOSITORY_FILE_SET":
                            return DatabundleVersionType.REMOTE_GIT_REPOSITORY_FILE_SET;
                        case "KERNEL_OUTPUT_FILE_SET":
                            return DatabundleVersionType.KERNEL_OUTPUT_FILE_SET;
                        case "GCS_FILE_SET":
                            return DatabundleVersionType.GCS_FILE_SET;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case DatabundleVersionType.UNSPECIFIED:
                        case 0:
                        default:
                            return "DATABUNDLE_VERSION_TYPE_UNSPECIFIED";
                        case DatabundleVersionType.FILESET:
                        case 1:
                            return "FILESET";
                        case DatabundleVersionType.BIG_QUERY:
                        case 2:
                            return "BIG_QUERY";
                        case DatabundleVersionType.REMOTE_URL_FILE_SET:
                        case 3:
                            return "REMOTE_URL_FILE_SET";
                        case DatabundleVersionType.REMOTE_GIT_REPOSITORY_FILE_SET:
                        case 4:
                            return "REMOTE_GIT_REPOSITORY_FILE_SET";
                        case DatabundleVersionType.KERNEL_OUTPUT_FILE_SET:
                        case 5:
                            return "KERNEL_OUTPUT_FILE_SET";
                        case DatabundleVersionType.GCS_FILE_SET:
                        case 6:
                            return "GCS_FILE_SET";
                    }
                }
            };
            var DatasetActivityType;
            (function(DatasetActivityType) {
                DatasetActivityType["SCRIPT"] = "script";
                DatasetActivityType["SCRIPT_FORK"] = "scriptFork";
                DatasetActivityType["SCRIPT_RUN"] = "scriptRun";
                DatasetActivityType["DATASET"] = "dataset";
                DatasetActivityType["DATASET_VERSION"] = "datasetVersion";
                DatasetActivityType["COMMENT"] = "comment";
                DatasetActivityType["SCRIPT_COMMENT"] = "scriptComment";
                DatasetActivityType["TOPIC"] = "topic";
            })(DatasetActivityType = Datasets.DatasetActivityType || (Datasets.DatasetActivityType = {}));
            var DatasetActivityTypeWireFormat3 = Datasets.DatasetActivityTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "SCRIPT":
                        default:
                            return DatasetActivityType.SCRIPT;
                        case "SCRIPT_FORK":
                            return DatasetActivityType.SCRIPT_FORK;
                        case "SCRIPT_RUN":
                            return DatasetActivityType.SCRIPT_RUN;
                        case "DATASET":
                            return DatasetActivityType.DATASET;
                        case "DATASET_VERSION":
                            return DatasetActivityType.DATASET_VERSION;
                        case "COMMENT":
                            return DatasetActivityType.COMMENT;
                        case "SCRIPT_COMMENT":
                            return DatasetActivityType.SCRIPT_COMMENT;
                        case "TOPIC":
                            return DatasetActivityType.TOPIC;
                    }
                }
            };
            var DatasetsActivityTypeEnum;
            (function(DatasetsActivityTypeEnum) {
                DatasetsActivityTypeEnum["UNSPECIFIED"] = "unspecified";
                DatasetsActivityTypeEnum["CREATE"] = "create";
                DatasetsActivityTypeEnum["NEW_VERSION"] = "newVersion";
                DatasetsActivityTypeEnum["FEATURE"] = "feature";
                DatasetsActivityTypeEnum["SUPER_FEATURE"] = "superFeature";
                DatasetsActivityTypeEnum["UN_FEATURE"] = "unFeature";
                DatasetsActivityTypeEnum["UN_SUPER_FEATURE"] = "unSuperFeature";
                DatasetsActivityTypeEnum["REMOVE"] = "remove";
                DatasetsActivityTypeEnum["REMOVE_VERSION"] = "removeVersion";
                DatasetsActivityTypeEnum["PUBLISH"] = "publish";
                DatasetsActivityTypeEnum["UN_PUBLISH"] = "unPublish";
                DatasetsActivityTypeEnum["MAKE_PUBLIC"] = "makePublic";
                DatasetsActivityTypeEnum["MAKE_PRIVATE"] = "makePrivate";
                DatasetsActivityTypeEnum["INTRA_VERSION_SCHEMA_UPDATE"] = "intraVersionSchemaUpdate";
            })(DatasetsActivityTypeEnum = Datasets.DatasetsActivityTypeEnum || (Datasets.DatasetsActivityTypeEnum = {}));
            var DatasetsActivityTypeEnumWireFormat3 = Datasets.DatasetsActivityTypeEnumWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DATASETS_ACTIVITY_TYPE_ENUM_UNSPECIFIED":
                        default:
                            return DatasetsActivityTypeEnum.UNSPECIFIED;
                        case "CREATE":
                            return DatasetsActivityTypeEnum.CREATE;
                        case "NEW_VERSION":
                            return DatasetsActivityTypeEnum.NEW_VERSION;
                        case "FEATURE":
                            return DatasetsActivityTypeEnum.FEATURE;
                        case "SUPER_FEATURE":
                            return DatasetsActivityTypeEnum.SUPER_FEATURE;
                        case "UN_FEATURE":
                            return DatasetsActivityTypeEnum.UN_FEATURE;
                        case "UN_SUPER_FEATURE":
                            return DatasetsActivityTypeEnum.UN_SUPER_FEATURE;
                        case "REMOVE":
                            return DatasetsActivityTypeEnum.REMOVE;
                        case "REMOVE_VERSION":
                            return DatasetsActivityTypeEnum.REMOVE_VERSION;
                        case "PUBLISH":
                            return DatasetsActivityTypeEnum.PUBLISH;
                        case "UN_PUBLISH":
                            return DatasetsActivityTypeEnum.UN_PUBLISH;
                        case "MAKE_PUBLIC":
                            return DatasetsActivityTypeEnum.MAKE_PUBLIC;
                        case "MAKE_PRIVATE":
                            return DatasetsActivityTypeEnum.MAKE_PRIVATE;
                        case "INTRA_VERSION_SCHEMA_UPDATE":
                            return DatasetsActivityTypeEnum.INTRA_VERSION_SCHEMA_UPDATE;
                    }
                }
            };
            var DatasetSchemaDiffAction;
            (function(DatasetSchemaDiffAction) {
                DatasetSchemaDiffAction["ADD"] = "add";
                DatasetSchemaDiffAction["DELETE"] = "delete";
                DatasetSchemaDiffAction["MODIFY_DESCRIPTION"] = "modifyDescription";
                DatasetSchemaDiffAction["MODIFY_TYPE"] = "modifyType";
                DatasetSchemaDiffAction["ROW_COUNT_CHANGE"] = "rowCountChange";
                DatasetSchemaDiffAction["SIZE_CHANGE"] = "sizeChange";
            })(DatasetSchemaDiffAction = Datasets.DatasetSchemaDiffAction || (Datasets.DatasetSchemaDiffAction = {}));
            var DatasetSchemaDiffActionWireFormat3 = Datasets.DatasetSchemaDiffActionWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DATASET_SCHEMA_DIFF_ACTION_ADD":
                        default:
                            return DatasetSchemaDiffAction.ADD;
                        case "DATASET_SCHEMA_DIFF_ACTION_DELETE":
                            return DatasetSchemaDiffAction.DELETE;
                        case "DATASET_SCHEMA_DIFF_ACTION_MODIFY_DESCRIPTION":
                            return DatasetSchemaDiffAction.MODIFY_DESCRIPTION;
                        case "DATASET_SCHEMA_DIFF_ACTION_MODIFY_TYPE":
                            return DatasetSchemaDiffAction.MODIFY_TYPE;
                        case "DATASET_SCHEMA_DIFF_ACTION_ROW_COUNT_CHANGE":
                            return DatasetSchemaDiffAction.ROW_COUNT_CHANGE;
                        case "DATASET_SCHEMA_DIFF_ACTION_SIZE_CHANGE":
                            return DatasetSchemaDiffAction.SIZE_CHANGE;
                    }
                }
            };
            var DatasetSchemaDiffContainerLevel;
            (function(DatasetSchemaDiffContainerLevel) {
                DatasetSchemaDiffContainerLevel["UNKNOWN"] = "unknown";
                DatasetSchemaDiffContainerLevel["DATASET"] = "dataset";
                DatasetSchemaDiffContainerLevel["FILE"] = "file";
                DatasetSchemaDiffContainerLevel["TABLE"] = "table";
                DatasetSchemaDiffContainerLevel["COLUMN"] = "column";
            })(DatasetSchemaDiffContainerLevel = Datasets.DatasetSchemaDiffContainerLevel || (Datasets.DatasetSchemaDiffContainerLevel = {}));
            var DatasetSchemaDiffContainerLevelWireFormat3 = Datasets.DatasetSchemaDiffContainerLevelWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DATASET_SCHEMA_DIFF_CONTAINER_LEVEL_UNKNOWN":
                        default:
                            return DatasetSchemaDiffContainerLevel.UNKNOWN;
                        case "DATASET_SCHEMA_DIFF_CONTAINER_LEVEL_DATASET":
                            return DatasetSchemaDiffContainerLevel.DATASET;
                        case "DATASET_SCHEMA_DIFF_CONTAINER_LEVEL_FILE":
                            return DatasetSchemaDiffContainerLevel.FILE;
                        case "DATASET_SCHEMA_DIFF_CONTAINER_LEVEL_TABLE":
                            return DatasetSchemaDiffContainerLevel.TABLE;
                        case "DATASET_SCHEMA_DIFF_CONTAINER_LEVEL_COLUMN":
                            return DatasetSchemaDiffContainerLevel.COLUMN;
                    }
                }
            };
            var DatasetTab;
            (function(DatasetTab) {
                DatasetTab["DATA"] = "data";
                DatasetTab["DATA_OLD"] = "dataOld";
                DatasetTab["KERNELS"] = "kernels";
                DatasetTab["NOTEBOOKS"] = "notebooks";
                DatasetTab["CODE"] = "code";
                DatasetTab["DISCUSSION"] = "discussion";
                DatasetTab["ACTIVITY"] = "activity";
                DatasetTab["METADATA"] = "metadata";
                DatasetTab["SETTINGS"] = "settings";
                DatasetTab["TASKS"] = "tasks";
                DatasetTab["HOME"] = "home";
                DatasetTab["ADMIN"] = "admin";
            })(DatasetTab = Datasets.DatasetTab || (Datasets.DatasetTab = {}));
            var DatasetTabWireFormat3 = Datasets.DatasetTabWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DATA":
                        default:
                            return DatasetTab.DATA;
                        case "DATA_OLD":
                            return DatasetTab.DATA_OLD;
                        case "KERNELS":
                            return DatasetTab.KERNELS;
                        case "NOTEBOOKS":
                            return DatasetTab.NOTEBOOKS;
                        case "CODE":
                            return DatasetTab.CODE;
                        case "DISCUSSION":
                            return DatasetTab.DISCUSSION;
                        case "ACTIVITY":
                            return DatasetTab.ACTIVITY;
                        case "METADATA":
                            return DatasetTab.METADATA;
                        case "SETTINGS":
                            return DatasetTab.SETTINGS;
                        case "TASKS":
                            return DatasetTab.TASKS;
                        case "HOME":
                            return DatasetTab.HOME;
                        case "ADMIN":
                            return DatasetTab.ADMIN;
                    }
                }
            };
            var DatasetTopicEnum;
            (function(DatasetTopicEnum) {
                DatasetTopicEnum["UNSPECIFIED"] = "unspecified";
                DatasetTopicEnum["POPULAR_DATASET"] = "popularDataset";
                DatasetTopicEnum["TRENDING_DATASET"] = "trendingDataset";
                DatasetTopicEnum["TRENDING_TASK"] = "trendingTask";
                DatasetTopicEnum["RECENTLY_VIEWED"] = "recentlyViewed";
                DatasetTopicEnum["BUSINESS_DATASET"] = "businessDataset";
                DatasetTopicEnum["ARTS_AND_ENTERTAINMENT_DATASET"] = "artsAndEntertainmentDataset";
                DatasetTopicEnum["EDUCATION_DATASET"] = "educationDataset";
                DatasetTopicEnum["HEALTH_DATASET"] = "healthDataset";
                DatasetTopicEnum["IMAGE_DATASET"] = "imageDataset";
                DatasetTopicEnum["ECONOMICS_DATASET"] = "economicsDataset";
                DatasetTopicEnum["COVID_DATASET"] = "covidDataset";
                DatasetTopicEnum["CLASSIFICATION_DATASET"] = "classificationDataset";
                DatasetTopicEnum["NLP_DATASET"] = "nlpDataset";
                DatasetTopicEnum["EARTH_AND_NATURE_DATASET"] = "earthAndNatureDataset";
                DatasetTopicEnum["COMPUTER_SCIENCE_DATASET"] = "computerScienceDataset";
                DatasetTopicEnum["CLOTHING_AND_ACCESSORIES_DATASET"] = "clothingAndAccessoriesDataset";
                DatasetTopicEnum["INTERNET_DATASET"] = "internetDataset";
                DatasetTopicEnum["ONLINE_COMMUNITIES_DATASET"] = "onlineCommunitiesDataset";
                DatasetTopicEnum["SOFTWARE_DATASET"] = "softwareDataset";
                DatasetTopicEnum["EXERCISE_DATASET"] = "exerciseDataset";
                DatasetTopicEnum["FOOD_DATASET"] = "foodDataset";
                DatasetTopicEnum["MOVIES_AND_TV_SHOWS_DATASET"] = "moviesAndTvShowsDataset";
                DatasetTopicEnum["NEWS_DATASET"] = "newsDataset";
                DatasetTopicEnum["PROGRAMMING_DATASET"] = "programmingDataset";
                DatasetTopicEnum["BIOLOGY_DATASET"] = "biologyDataset";
                DatasetTopicEnum["SOCIAL_SCIENCE_DATASET"] = "socialScienceDataset";
                DatasetTopicEnum["MUSIC_DATASET"] = "musicDataset";
                DatasetTopicEnum["FINANCE_DATASET"] = "financeDataset";
                DatasetTopicEnum["CANCER_DATASET"] = "cancerDataset";
                DatasetTopicEnum["AUTOMOBILES_AND_VEHICLES_DATASET"] = "automobilesAndVehiclesDataset";
                DatasetTopicEnum["RETAIL_AND_SHOPPING_DATASET"] = "retailAndShoppingDataset";
                DatasetTopicEnum["INVESTING_DATASET"] = "investingDataset";
                DatasetTopicEnum["SPORTS_DATASET"] = "sportsDataset";
                DatasetTopicEnum["STANDARDIZED_TESTING_DATASET"] = "standardizedTestingDataset";
                DatasetTopicEnum["TRANSPORTATION_DATASET"] = "transportationDataset";
                DatasetTopicEnum["UNIVERSITIES_AND_COLLEGES_DATASET"] = "universitiesAndCollegesDataset";
                DatasetTopicEnum["LAW_DATASET"] = "lawDataset";
                DatasetTopicEnum["GAMES_DATASET"] = "gamesDataset";
                DatasetTopicEnum["TRAVEL_DATASET"] = "travelDataset";
                DatasetTopicEnum["SOCIAL_NETWORKS_DATASET"] = "socialNetworksDataset";
                DatasetTopicEnum["SOCIAL_ISSUES_AND_ADVOCACY_DATASET"] = "socialIssuesAndAdvocacyDataset";
                DatasetTopicEnum["TEXT_DATASET"] = "textDataset";
            })(DatasetTopicEnum = Datasets.DatasetTopicEnum || (Datasets.DatasetTopicEnum = {}));
            var DatasetTopicEnumWireFormat3 = Datasets.DatasetTopicEnumWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DATASET_TOPIC_ENUM_UNSPECIFIED":
                        default:
                            return DatasetTopicEnum.UNSPECIFIED;
                        case "POPULAR_DATASET":
                            return DatasetTopicEnum.POPULAR_DATASET;
                        case "TRENDING_DATASET":
                            return DatasetTopicEnum.TRENDING_DATASET;
                        case "TRENDING_TASK":
                            return DatasetTopicEnum.TRENDING_TASK;
                        case "RECENTLY_VIEWED":
                            return DatasetTopicEnum.RECENTLY_VIEWED;
                        case "BUSINESS_DATASET":
                            return DatasetTopicEnum.BUSINESS_DATASET;
                        case "ARTS_AND_ENTERTAINMENT_DATASET":
                            return DatasetTopicEnum.ARTS_AND_ENTERTAINMENT_DATASET;
                        case "EDUCATION_DATASET":
                            return DatasetTopicEnum.EDUCATION_DATASET;
                        case "HEALTH_DATASET":
                            return DatasetTopicEnum.HEALTH_DATASET;
                        case "IMAGE_DATASET":
                            return DatasetTopicEnum.IMAGE_DATASET;
                        case "ECONOMICS_DATASET":
                            return DatasetTopicEnum.ECONOMICS_DATASET;
                        case "COVID_DATASET":
                            return DatasetTopicEnum.COVID_DATASET;
                        case "CLASSIFICATION_DATASET":
                            return DatasetTopicEnum.CLASSIFICATION_DATASET;
                        case "NLP_DATASET":
                            return DatasetTopicEnum.NLP_DATASET;
                        case "EARTH_AND_NATURE_DATASET":
                            return DatasetTopicEnum.EARTH_AND_NATURE_DATASET;
                        case "COMPUTER_SCIENCE_DATASET":
                            return DatasetTopicEnum.COMPUTER_SCIENCE_DATASET;
                        case "CLOTHING_AND_ACCESSORIES_DATASET":
                            return DatasetTopicEnum.CLOTHING_AND_ACCESSORIES_DATASET;
                        case "INTERNET_DATASET":
                            return DatasetTopicEnum.INTERNET_DATASET;
                        case "ONLINE_COMMUNITIES_DATASET":
                            return DatasetTopicEnum.ONLINE_COMMUNITIES_DATASET;
                        case "SOFTWARE_DATASET":
                            return DatasetTopicEnum.SOFTWARE_DATASET;
                        case "EXERCISE_DATASET":
                            return DatasetTopicEnum.EXERCISE_DATASET;
                        case "FOOD_DATASET":
                            return DatasetTopicEnum.FOOD_DATASET;
                        case "MOVIES_AND_TV_SHOWS_DATASET":
                            return DatasetTopicEnum.MOVIES_AND_TV_SHOWS_DATASET;
                        case "NEWS_DATASET":
                            return DatasetTopicEnum.NEWS_DATASET;
                        case "PROGRAMMING_DATASET":
                            return DatasetTopicEnum.PROGRAMMING_DATASET;
                        case "BIOLOGY_DATASET":
                            return DatasetTopicEnum.BIOLOGY_DATASET;
                        case "SOCIAL_SCIENCE_DATASET":
                            return DatasetTopicEnum.SOCIAL_SCIENCE_DATASET;
                        case "MUSIC_DATASET":
                            return DatasetTopicEnum.MUSIC_DATASET;
                        case "FINANCE_DATASET":
                            return DatasetTopicEnum.FINANCE_DATASET;
                        case "CANCER_DATASET":
                            return DatasetTopicEnum.CANCER_DATASET;
                        case "AUTOMOBILES_AND_VEHICLES_DATASET":
                            return DatasetTopicEnum.AUTOMOBILES_AND_VEHICLES_DATASET;
                        case "RETAIL_AND_SHOPPING_DATASET":
                            return DatasetTopicEnum.RETAIL_AND_SHOPPING_DATASET;
                        case "INVESTING_DATASET":
                            return DatasetTopicEnum.INVESTING_DATASET;
                        case "SPORTS_DATASET":
                            return DatasetTopicEnum.SPORTS_DATASET;
                        case "STANDARDIZED_TESTING_DATASET":
                            return DatasetTopicEnum.STANDARDIZED_TESTING_DATASET;
                        case "TRANSPORTATION_DATASET":
                            return DatasetTopicEnum.TRANSPORTATION_DATASET;
                        case "UNIVERSITIES_AND_COLLEGES_DATASET":
                            return DatasetTopicEnum.UNIVERSITIES_AND_COLLEGES_DATASET;
                        case "LAW_DATASET":
                            return DatasetTopicEnum.LAW_DATASET;
                        case "GAMES_DATASET":
                            return DatasetTopicEnum.GAMES_DATASET;
                        case "TRAVEL_DATASET":
                            return DatasetTopicEnum.TRAVEL_DATASET;
                        case "SOCIAL_NETWORKS_DATASET":
                            return DatasetTopicEnum.SOCIAL_NETWORKS_DATASET;
                        case "SOCIAL_ISSUES_AND_ADVOCACY_DATASET":
                            return DatasetTopicEnum.SOCIAL_ISSUES_AND_ADVOCACY_DATASET;
                        case "TEXT_DATASET":
                            return DatasetTopicEnum.TEXT_DATASET;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case DatasetTopicEnum.UNSPECIFIED:
                        case 0:
                        default:
                            return "DATASET_TOPIC_ENUM_UNSPECIFIED";
                        case DatasetTopicEnum.POPULAR_DATASET:
                        case 1:
                            return "POPULAR_DATASET";
                        case DatasetTopicEnum.TRENDING_DATASET:
                        case 2:
                            return "TRENDING_DATASET";
                        case DatasetTopicEnum.TRENDING_TASK:
                        case 3:
                            return "TRENDING_TASK";
                        case DatasetTopicEnum.RECENTLY_VIEWED:
                        case 4:
                            return "RECENTLY_VIEWED";
                        case DatasetTopicEnum.BUSINESS_DATASET:
                        case 11102:
                            return "BUSINESS_DATASET";
                        case DatasetTopicEnum.ARTS_AND_ENTERTAINMENT_DATASET:
                        case 2200:
                            return "ARTS_AND_ENTERTAINMENT_DATASET";
                        case DatasetTopicEnum.EDUCATION_DATASET:
                        case 11105:
                            return "EDUCATION_DATASET";
                        case DatasetTopicEnum.HEALTH_DATASET:
                        case 11111:
                            return "HEALTH_DATASET";
                        case DatasetTopicEnum.IMAGE_DATASET:
                        case 14102:
                            return "IMAGE_DATASET";
                        case DatasetTopicEnum.ECONOMICS_DATASET:
                        case 11205:
                            return "ECONOMICS_DATASET";
                        case DatasetTopicEnum.COVID_DATASET:
                        case 16575:
                            return "COVID_DATASET";
                        case DatasetTopicEnum.CLASSIFICATION_DATASET:
                        case 13302:
                            return "CLASSIFICATION_DATASET";
                        case DatasetTopicEnum.NLP_DATASET:
                        case 13204:
                            return "NLP_DATASET";
                        case DatasetTopicEnum.EARTH_AND_NATURE_DATASET:
                        case 7000:
                            return "EARTH_AND_NATURE_DATASET";
                        case DatasetTopicEnum.COMPUTER_SCIENCE_DATASET:
                        case 12107:
                            return "COMPUTER_SCIENCE_DATASET";
                        case DatasetTopicEnum.CLOTHING_AND_ACCESSORIES_DATASET:
                        case 8301:
                            return "CLOTHING_AND_ACCESSORIES_DATASET";
                        case DatasetTopicEnum.INTERNET_DATASET:
                        case 12116:
                            return "INTERNET_DATASET";
                        case DatasetTopicEnum.ONLINE_COMMUNITIES_DATASET:
                        case 16489:
                            return "ONLINE_COMMUNITIES_DATASET";
                        case DatasetTopicEnum.SOFTWARE_DATASET:
                        case 12127:
                            return "SOFTWARE_DATASET";
                        case DatasetTopicEnum.EXERCISE_DATASET:
                        case 4130:
                            return "EXERCISE_DATASET";
                        case DatasetTopicEnum.FOOD_DATASET:
                        case 16113:
                            return "FOOD_DATASET";
                        case DatasetTopicEnum.MOVIES_AND_TV_SHOWS_DATASET:
                        case 2303:
                            return "MOVIES_AND_TV_SHOWS_DATASET";
                        case DatasetTopicEnum.NEWS_DATASET:
                        case 16430:
                            return "NEWS_DATASET";
                        case DatasetTopicEnum.PROGRAMMING_DATASET:
                        case 12125:
                            return "PROGRAMMING_DATASET";
                        case DatasetTopicEnum.BIOLOGY_DATASET:
                        case 7100:
                            return "BIOLOGY_DATASET";
                        case DatasetTopicEnum.SOCIAL_SCIENCE_DATASET:
                        case 11200:
                            return "SOCIAL_SCIENCE_DATASET";
                        case DatasetTopicEnum.MUSIC_DATASET:
                        case 2304:
                            return "MUSIC_DATASET";
                        case DatasetTopicEnum.FINANCE_DATASET:
                        case 11108:
                            return "FINANCE_DATASET";
                        case DatasetTopicEnum.CANCER_DATASET:
                        case 16382:
                            return "CANCER_DATASET";
                        case DatasetTopicEnum.AUTOMOBILES_AND_VEHICLES_DATASET:
                        case 12402:
                            return "AUTOMOBILES_AND_VEHICLES_DATASET";
                        case DatasetTopicEnum.RETAIL_AND_SHOPPING_DATASET:
                        case 16281:
                            return "RETAIL_AND_SHOPPING_DATASET";
                        case DatasetTopicEnum.INVESTING_DATASET:
                        case 16371:
                            return "INVESTING_DATASET";
                        case DatasetTopicEnum.SPORTS_DATASET:
                        case 4141:
                            return "SPORTS_DATASET";
                        case DatasetTopicEnum.STANDARDIZED_TESTING_DATASET:
                        case 16410:
                            return "STANDARDIZED_TESTING_DATASET";
                        case DatasetTopicEnum.TRANSPORTATION_DATASET:
                        case 12400:
                            return "TRANSPORTATION_DATASET";
                        case DatasetTopicEnum.UNIVERSITIES_AND_COLLEGES_DATASET:
                        case 1222:
                            return "UNIVERSITIES_AND_COLLEGES_DATASET";
                        case DatasetTopicEnum.LAW_DATASET:
                        case 11115:
                            return "LAW_DATASET";
                        case DatasetTopicEnum.GAMES_DATASET:
                        case 2500:
                            return "GAMES_DATASET";
                        case DatasetTopicEnum.TRAVEL_DATASET:
                        case 16461:
                            return "TRAVEL_DATASET";
                        case DatasetTopicEnum.SOCIAL_NETWORKS_DATASET:
                        case 16502:
                            return "SOCIAL_NETWORKS_DATASET";
                        case DatasetTopicEnum.SOCIAL_ISSUES_AND_ADVOCACY_DATASET:
                        case 16453:
                            return "SOCIAL_ISSUES_AND_ADVOCACY_DATASET";
                        case DatasetTopicEnum.TEXT_DATASET:
                        case 14104:
                            return "TEXT_DATASET";
                    }
                }
            };
            var DuplicationReferenceType;
            (function(DuplicationReferenceType) {
                DuplicationReferenceType["COMPETITION"] = "competition";
                DuplicationReferenceType["DATASET"] = "dataset";
            })(DuplicationReferenceType = Datasets.DuplicationReferenceType || (Datasets.DuplicationReferenceType = {}));
            var DuplicationReferenceTypeWireFormat3 = Datasets.DuplicationReferenceTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DUPLICATION_REFERENCE_TYPE_COMPETITION":
                        default:
                            return DuplicationReferenceType.COMPETITION;
                        case "DUPLICATION_REFERENCE_TYPE_DATASET":
                            return DuplicationReferenceType.DATASET;
                    }
                }
            };
            var GithubRepositoryContentType;
            (function(GithubRepositoryContentType) {
                GithubRepositoryContentType["FILE"] = "file";
                GithubRepositoryContentType["FOLDER"] = "folder";
            })(GithubRepositoryContentType = Datasets.GithubRepositoryContentType || (Datasets.GithubRepositoryContentType = {}));
            var GithubRepositoryContentTypeWireFormat3 = Datasets.GithubRepositoryContentTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "GITHUB_REPOSITORY_CONTENT_TYPE_FILE":
                        default:
                            return GithubRepositoryContentType.FILE;
                        case "GITHUB_REPOSITORY_CONTENT_TYPE_FOLDER":
                            return GithubRepositoryContentType.FOLDER;
                    }
                }
            };
            var RemoteUrlUpdateFrequency;
            (function(RemoteUrlUpdateFrequency) {
                RemoteUrlUpdateFrequency["DAILY"] = "daily";
                RemoteUrlUpdateFrequency["WEEKLY"] = "weekly";
                RemoteUrlUpdateFrequency["MONTHLY"] = "monthly";
                RemoteUrlUpdateFrequency["NEVER"] = "never";
                RemoteUrlUpdateFrequency["QUARTERLY"] = "quarterly";
                RemoteUrlUpdateFrequency["ANNUALLY"] = "annually";
                RemoteUrlUpdateFrequency["HOURLY"] = "hourly";
                RemoteUrlUpdateFrequency[// The value of UNSPECIFIED should be 0 but we can't change the value of DAILY
                // because it is serialized as a number in the database (see the Settings column
                // in the DatabundleVersions table).
                "UNSPECIFIED"] = "unspecified";
            })(RemoteUrlUpdateFrequency = Datasets.RemoteUrlUpdateFrequency || (Datasets.RemoteUrlUpdateFrequency = {}));
            var RemoteUrlUpdateFrequencyWireFormat3 = Datasets.RemoteUrlUpdateFrequencyWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DAILY":
                        default:
                            return RemoteUrlUpdateFrequency.DAILY;
                        case "WEEKLY":
                            return RemoteUrlUpdateFrequency.WEEKLY;
                        case "MONTHLY":
                            return RemoteUrlUpdateFrequency.MONTHLY;
                        case "NEVER":
                            return RemoteUrlUpdateFrequency.NEVER;
                        case "QUARTERLY":
                            return RemoteUrlUpdateFrequency.QUARTERLY;
                        case "ANNUALLY":
                            return RemoteUrlUpdateFrequency.ANNUALLY;
                        case "HOURLY":
                            return RemoteUrlUpdateFrequency.HOURLY;
                        case "REMOTE_URL_UPDATE_FREQUENCY_UNSPECIFIED":
                            return RemoteUrlUpdateFrequency.UNSPECIFIED;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case RemoteUrlUpdateFrequency.DAILY:
                        case 0:
                        default:
                            return "DAILY";
                        case RemoteUrlUpdateFrequency.WEEKLY:
                        case 1:
                            return "WEEKLY";
                        case RemoteUrlUpdateFrequency.MONTHLY:
                        case 2:
                            return "MONTHLY";
                        case RemoteUrlUpdateFrequency.NEVER:
                        case 3:
                            return "NEVER";
                        case RemoteUrlUpdateFrequency.QUARTERLY:
                        case 4:
                            return "QUARTERLY";
                        case RemoteUrlUpdateFrequency.ANNUALLY:
                        case 5:
                            return "ANNUALLY";
                        case RemoteUrlUpdateFrequency.HOURLY:
                        case 6:
                            return "HOURLY";
                        case RemoteUrlUpdateFrequency.UNSPECIFIED:
                        case -1:
                            return "REMOTE_URL_UPDATE_FREQUENCY_UNSPECIFIED";
                    }
                }
            };
            var SuggestionType;
            (function(SuggestionType) {
                SuggestionType["COMPETITION"] = "competition";
                SuggestionType["KERNEL"] = "kernel";
                SuggestionType["DATASET"] = "dataset";
                SuggestionType["CATEGORY"] = "category";
            })(SuggestionType = Datasets.SuggestionType || (Datasets.SuggestionType = {}));
            var SuggestionTypeWireFormat3 = Datasets.SuggestionTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "SUGGESTION_TYPE_COMPETITION":
                        default:
                            return SuggestionType.COMPETITION;
                        case "SUGGESTION_TYPE_KERNEL":
                            return SuggestionType.KERNEL;
                        case "SUGGESTION_TYPE_DATASET":
                            return SuggestionType.DATASET;
                        case "SUGGESTION_TYPE_CATEGORY":
                            return SuggestionType.CATEGORY;
                    }
                }
            };
        })(Datasets1 = Sdk.Datasets || (Sdk.Datasets = {}));
        var Kernels1;
        (function(Kernels) {
            var defaultAcceleratorQuotaStatistics = {
                hasEverRun: false
            };
            var AcceleratorQuotaStatisticsWireFormat3 = Kernels.AcceleratorQuotaStatisticsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultAcceleratorQuotaStatistics, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.minimumTimeAllowed) {
                        message.minimumTimeAllowed = jsonStringToDuration(wireFormat.minimumTimeAllowed);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.timeReserved) {
                        message.timeReserved = jsonStringToDuration(wireFormat.timeReserved);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.timeUsed) {
                        message.timeUsed = jsonStringToDuration(wireFormat.timeUsed);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalTimeAllowed) {
                        message.totalTimeAllowed = jsonStringToDuration(wireFormat.totalTimeAllowed);
                    }
                    return message;
                }
            };
            var AcceptKernelCompetitionRulesRequestWireFormat3 = Kernels.AcceptKernelCompetitionRulesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var AddKernelCategoryRequestWireFormat3 = Kernels.AddKernelCategoryRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var AgentEntryWireFormat3 = Kernels.AgentEntryWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var BatchAutoTagKernelsRequestWireFormat3 = Kernels.BatchAutoTagKernelsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultBatchAutoTagKernelsResponse = {
                endingKernelId: 0,
                taggedKernelCount: 0
            };
            var BatchAutoTagKernelsResponseWireFormat3 = Kernels.BatchAutoTagKernelsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultBatchAutoTagKernelsResponse, wireFormat);
                    return message;
                }
            };
            var CancelKernelSessionRequestWireFormat3 = Kernels.CancelKernelSessionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var ClearPinnedKernelSessionRequestWireFormat3 = Kernels.ClearPinnedKernelSessionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var CommitAndRunRequestWireFormat3 = Kernels.CommitAndRunRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.dataSources) {
                        wireFormat.dataSources = message.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.editorType) {
                        wireFormat.editorType = Kaggle.Sdk.Kernels.EditorTypeWireFormat3.toJson(message.editorType);
                    }
                    if (message === null || message === void 0 ? void 0 : message.compute) {
                        wireFormat.compute = Kaggle.Sdk.Kernels.ComputeStateWireFormat3.toJson(message.compute);
                    }
                    if (message === null || message === void 0 ? void 0 : message.versionType) {
                        wireFormat.versionType = Kaggle.Sdk.Kernels.KernelVersionTypeWireFormat3.toJson(message.versionType);
                    }
                    if (message === null || message === void 0 ? void 0 : message.userPlanOverride) {
                        wireFormat.userPlanOverride = KaggleSdkUsersUserPlanWireFormat3.toJson(message.userPlanOverride);
                    }
                    if (message === null || message === void 0 ? void 0 : message.submissionRequestedDetails) {
                        wireFormat.submissionRequestedDetails = Kaggle.Sdk.Kernels.SubmissionRequestedDetailsWireFormat3.toJson(message.submissionRequestedDetails);
                    }
                    if (message === null || message === void 0 ? void 0 : message.githubSaveRequest) {
                        wireFormat.githubSaveRequest = Kaggle.Sdk.Kernels.GitHubSaveRequestWireFormat3.toJson(message.githubSaveRequest);
                    }
                    return wireFormat;
                }
            };
            var defaultCommitAndRunResponse = {
                kernelId: 0,
                kernelVersionId: 0,
                kernelRunId: 0
            };
            var CommitAndRunResponseWireFormat3 = Kernels.CommitAndRunResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCommitAndRunResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.diff) {
                        message.diff = Kaggle.Sdk.Kernels.KernelDiffWireFormat3.fromJson(wireFormat.diff);
                    }
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Kernels.KernelWorkerStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    return message;
                }
            };
            var CompleteQuickSessionRequestWireFormat3 = Kernels.CompleteQuickSessionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultCompleteQuickSessionResponse = {};
            var CompleteQuickSessionResponseWireFormat3 = Kernels.CompleteQuickSessionResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCompleteQuickSessionResponse, wireFormat);
                    return message;
                }
            };
            var ComputeConstraintStateWireFormat3 = Kernels.ComputeConstraintStateWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.maxStorageBytes) {
                        wireFormat.maxStorageBytes = message.maxStorageBytes.toString();
                    }
                    if (message === null || message === void 0 ? void 0 : message.maxMemoryBytes) {
                        wireFormat.maxMemoryBytes = message.maxMemoryBytes.toString();
                    }
                    return wireFormat;
                }
            };
            var ComputeInternetStateWireFormat3 = Kernels.ComputeInternetStateWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var ComputeKernelDiffRequestWireFormat3 = Kernels.ComputeKernelDiffRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultComputeKernelDiffResponse = {};
            var ComputeKernelDiffResponseWireFormat3 = Kernels.ComputeKernelDiffResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultComputeKernelDiffResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.diff) {
                        message.diff = Kaggle.Sdk.Kernels.KernelDiffWireFormat3.fromJson(wireFormat.diff);
                    }
                    return message;
                }
            };
            var ComputeStateWireFormat3 = Kernels.ComputeStateWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.accelerator) {
                        wireFormat.accelerator = Kaggle.Sdk.Kernels.AcceleratorTypeWireFormat3.toJson(message.accelerator);
                    }
                    if (message === null || message === void 0 ? void 0 : message.internet) {
                        wireFormat.internet = Kaggle.Sdk.Kernels.ComputeInternetStateWireFormat3.toJson(message.internet);
                    }
                    if (message === null || message === void 0 ? void 0 : message.constraints) {
                        wireFormat.constraints = Kaggle.Sdk.Kernels.ComputeConstraintStateWireFormat3.toJson(message.constraints);
                    }
                    return wireFormat;
                }
            };
            var CreateKernelParametersWireFormat3 = Kernels.CreateKernelParametersWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.compute) {
                        wireFormat.compute = Kaggle.Sdk.Kernels.ComputeStateWireFormat3.toJson(message.compute);
                    }
                    if (message === null || message === void 0 ? void 0 : message.dataSources) {
                        wireFormat.dataSources = message.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var CreateKernelSessionRequestWireFormat3 = Kernels.CreateKernelSessionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.versionType) {
                        wireFormat.versionType = Kaggle.Sdk.Kernels.KernelVersionTypeWireFormat3.toJson(message.versionType);
                    }
                    if (message === null || message === void 0 ? void 0 : message.userPlanOverride) {
                        wireFormat.userPlanOverride = KaggleSdkUsersUserPlanWireFormat3.toJson(message.userPlanOverride);
                    }
                    if (message === null || message === void 0 ? void 0 : message.diff) {
                        wireFormat.diff = Kaggle.Sdk.Kernels.KernelDiffWireFormat3.toJson(message.diff);
                    }
                    if (message === null || message === void 0 ? void 0 : message.forkParentDiff) {
                        wireFormat.forkParentDiff = Kaggle.Sdk.Kernels.KernelDiffWireFormat3.toJson(message.forkParentDiff);
                    }
                    if (message === null || message === void 0 ? void 0 : message.submissionRequestedDetails) {
                        wireFormat.submissionRequestedDetails = Kaggle.Sdk.Kernels.SubmissionRequestedDetailsWireFormat3.toJson(message.submissionRequestedDetails);
                    }
                    if (message === null || message === void 0 ? void 0 : message.parameters) {
                        wireFormat.parameters = Kaggle.Sdk.Kernels.CreateKernelParametersWireFormat3.toJson(message.parameters);
                    }
                    if (message === null || message === void 0 ? void 0 : message.githubSaveRequest) {
                        wireFormat.githubSaveRequest = Kaggle.Sdk.Kernels.GitHubSaveRequestWireFormat3.toJson(message.githubSaveRequest);
                    }
                    if (message === null || message === void 0 ? void 0 : message.environmentVariables) {
                        wireFormat.environmentVariables = message.environmentVariables.map(function(i) {
                            return Kaggle.Sdk.Kernels.EnvironmentVariableWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var defaultCreateKernelSessionResponse = {
                id: 0,
                useNewKernelsBackend: false,
                showParentForkSecretWarning: false
            };
            var CreateKernelSessionResponseWireFormat3 = Kernels.CreateKernelSessionResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCreateKernelSessionResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.resources) {
                        message.resources = Kaggle.Sdk.Kernels.KernelSessionResourcesWireFormat3.fromJson(wireFormat.resources);
                    }
                    return message;
                }
            };
            var CreateKernelUpvoteRequestWireFormat3 = Kernels.CreateKernelUpvoteRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultCreateKernelUpvoteResponse = {
                voteId: 0,
                isSelfVote: false
            };
            var CreateKernelUpvoteResponseWireFormat3 = Kernels.CreateKernelUpvoteResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCreateKernelUpvoteResponse, wireFormat);
                    return message;
                }
            };
            var CreateKernelWithSettingsRequestWireFormat3 = Kernels.CreateKernelWithSettingsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.sourceType) {
                        wireFormat.sourceType = Kaggle.Sdk.Kernels.EditorTypeWireFormat3.toJson(message.sourceType);
                    }
                    if (message === null || message === void 0 ? void 0 : message.accelerator) {
                        wireFormat.accelerator = Kaggle.Sdk.Kernels.AcceleratorTypeWireFormat3.toJson(message.accelerator);
                    }
                    return wireFormat;
                }
            };
            var defaultCreateKernelWithSettingsResponse = {
                id: 0
            };
            var CreateKernelWithSettingsResponseWireFormat3 = Kernels.CreateKernelWithSettingsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCreateKernelWithSettingsResponse, wireFormat);
                    return message;
                }
            };
            var CreateSnippetRequestWireFormat3 = Kernels.CreateSnippetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.data) {
                        wireFormat.data = Kaggle.Sdk.Kernels.SnippetDataWireFormat3.toJson(message.data);
                    }
                    return wireFormat;
                }
            };
            var defaultCreateSnippetResponse = {
                id: 0
            };
            var CreateSnippetResponseWireFormat3 = Kernels.CreateSnippetResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCreateSnippetResponse, wireFormat);
                    return message;
                }
            };
            var defaultDailySubmissionInfo = {
                submissionCount: 0
            };
            var DailySubmissionInfoWireFormat3 = Kernels.DailySubmissionInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDailySubmissionInfo, wireFormat);
                    return message;
                }
            };
            var defaultDataSource = {
                isPrivate: false
            };
            var DataSourceWireFormat3 = Kernels.DataSourceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDataSource, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.reference) {
                        message.reference = Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.fromJson(wireFormat.reference);
                    }
                    return message;
                }
            };
            var defaultDataSourceReference = {
                sourceId: 0
            };
            var DataSourceReferenceWireFormat3 = Kernels.DataSourceReferenceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDataSourceReference, wireFormat);
                    if (wireFormat) {
                        message.sourceType = Kaggle.Sdk.Kernels.DataSourceTypeWireFormat3.fromJson(wireFormat.sourceType);
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.sourceType) {
                        wireFormat.sourceType = Kaggle.Sdk.Kernels.DataSourceTypeWireFormat3.toJson(message.sourceType);
                    }
                    return wireFormat;
                }
            };
            var defaultDataSourceVersion = {};
            var DataSourceVersionWireFormat3 = Kernels.DataSourceVersionWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDataSourceVersion, wireFormat);
                    return message;
                }
            };
            var defaultDefaultSessionSettings = {};
            var DefaultSessionSettingsWireFormat3 = Kernels.DefaultSessionSettingsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDefaultSessionSettings, wireFormat);
                    if (wireFormat) {
                        message.batchSessionDefaultAccelerator = Kaggle.Sdk.Kernels.AcceleratorTypeWireFormat3.fromJson(wireFormat.batchSessionDefaultAccelerator);
                    }
                    if (wireFormat) {
                        message.defaultUserPlan = KaggleSdkUsersUserPlanWireFormat3.fromJson(wireFormat.defaultUserPlan);
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.batchSessionDefaultAccelerator) {
                        wireFormat.batchSessionDefaultAccelerator = Kaggle.Sdk.Kernels.AcceleratorTypeWireFormat3.toJson(message.batchSessionDefaultAccelerator);
                    }
                    if (message === null || message === void 0 ? void 0 : message.defaultUserPlan) {
                        wireFormat.defaultUserPlan = KaggleSdkUsersUserPlanWireFormat3.toJson(message.defaultUserPlan);
                    }
                    return wireFormat;
                }
            };
            var DeleteKernelRequestWireFormat3 = Kernels.DeleteKernelRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var DeleteKernelUpvoteRequestWireFormat3 = Kernels.DeleteKernelUpvoteRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var DeleteScheduledKernelSessionRequestWireFormat3 = Kernels.DeleteScheduledKernelSessionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultDeleteScheduledKernelSessionResponse = {};
            var DeleteScheduledKernelSessionResponseWireFormat3 = Kernels.DeleteScheduledKernelSessionResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDeleteScheduledKernelSessionResponse, wireFormat);
                    return message;
                }
            };
            var DeleteSnippetRequestWireFormat3 = Kernels.DeleteSnippetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultDockerImageVersionDetails = {};
            var DockerImageVersionDetailsWireFormat3 = Kernels.DockerImageVersionDetailsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDockerImageVersionDetails, wireFormat);
                    if (wireFormat) {
                        message.type = Kaggle.Sdk.Kernels.DockerImageVersionTypeWireFormat3.fromJson(wireFormat.type);
                    }
                    if (wireFormat) {
                        message.disabledReason = Kaggle.Sdk.Kernels.DockerImageVersionDisabledReasonWireFormat3.fromJson(wireFormat.disabledReason);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
                        message.dateCreated = new Date(wireFormat.dateCreated);
                    }
                    return message;
                }
            };
            var defaultDockerImageVersionDetailsList = {
                images: []
            };
            var DockerImageVersionDetailsListWireFormat3 = Kernels.DockerImageVersionDetailsListWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDockerImageVersionDetailsList, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.images) {
                        message.images = wireFormat.images.map(function(i) {
                            return Kaggle.Sdk.Kernels.DockerImageVersionDetailsWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat) {
                        message.selectedVersionType = Kaggle.Sdk.Kernels.DockerImageVersionTypeWireFormat3.fromJson(wireFormat.selectedVersionType);
                    }
                    return message;
                }
            };
            var EnvironmentVariableWireFormat3 = Kernels.EnvironmentVariableWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var ExportKernelRunForCaipRequestWireFormat3 = Kernels.ExportKernelRunForCaipRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultExportKernelRunForCaipResponse = {
                warnings: []
            };
            var ExportKernelRunForCaipResponseWireFormat3 = Kernels.ExportKernelRunForCaipResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultExportKernelRunForCaipResponse, wireFormat);
                    return message;
                }
            };
            var ExternalSourceDataWireFormat3 = Kernels.ExternalSourceDataWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var FetchExternalKernelContentRequestWireFormat3 = Kernels.FetchExternalKernelContentRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultFetchExternalKernelContentResponse = {
                externalContent: "",
                isPublic: false
            };
            var FetchExternalKernelContentResponseWireFormat3 = Kernels.FetchExternalKernelContentResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultFetchExternalKernelContentResponse, wireFormat);
                    return message;
                }
            };
            var FetchGitHubContentRequestWireFormat3 = Kernels.FetchGitHubContentRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultFetchGitHubContentResponse = {
                content: "",
                isPublic: false
            };
            var FetchGitHubContentResponseWireFormat3 = Kernels.FetchGitHubContentResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultFetchGitHubContentResponse, wireFormat);
                    return message;
                }
            };
            var defaultForkParentInfo = {
                isDeleted: false,
                isVisible: false,
                kernelId: 0
            };
            var ForkParentInfoWireFormat3 = Kernels.ForkParentInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultForkParentInfo, wireFormat);
                    return message;
                }
            };
            var GetAcceleratorQuotaStatisticsRequestWireFormat3 = Kernels.GetAcceleratorQuotaStatisticsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetAcceleratorQuotaStatisticsResponse = {
                kernelsMaxSizeInMb: 0
            };
            var GetAcceleratorQuotaStatisticsResponseWireFormat3 = Kernels.GetAcceleratorQuotaStatisticsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetAcceleratorQuotaStatisticsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.quotaRefreshTime) {
                        message.quotaRefreshTime = new Date(wireFormat.quotaRefreshTime);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tpuQuota) {
                        message.tpuQuota = Kaggle.Sdk.Kernels.AcceleratorQuotaStatisticsWireFormat3.fromJson(wireFormat.tpuQuota);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.gpuQuota) {
                        message.gpuQuota = Kaggle.Sdk.Kernels.AcceleratorQuotaStatisticsWireFormat3.fromJson(wireFormat.gpuQuota);
                    }
                    return message;
                }
            };
            var GetCompetitionsPaneInfoRequestWireFormat3 = Kernels.GetCompetitionsPaneInfoRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetCompetitionsPaneInfoResponse = {};
            var GetCompetitionsPaneInfoResponseWireFormat3 = Kernels.GetCompetitionsPaneInfoResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetCompetitionsPaneInfoResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bestKernelSessionScore) {
                        message.bestKernelSessionScore = Kaggle.Sdk.Kernels.KernelSessionScoreWireFormat3.fromJson(wireFormat.bestKernelSessionScore);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.latestKernelSessionScore) {
                        message.latestKernelSessionScore = Kaggle.Sdk.Kernels.KernelSessionScoreWireFormat3.fromJson(wireFormat.latestKernelSessionScore);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dailySubmissionInfo) {
                        message.dailySubmissionInfo = Kaggle.Sdk.Kernels.DailySubmissionInfoWireFormat3.fromJson(wireFormat.dailySubmissionInfo);
                    }
                    return message;
                }
            };
            var GetDefaultSessionSettingsRequestWireFormat3 = Kernels.GetDefaultSessionSettingsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetDeletedKernelRequestWireFormat3 = Kernels.GetDeletedKernelRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetDeletedKernelResponse = {
                commentCount: 0,
                userCanDownvoteComments: false
            };
            var GetDeletedKernelResponseWireFormat3 = Kernels.GetDeletedKernelResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetDeletedKernelResponse, wireFormat);
                    return message;
                }
            };
            var GetFirebaseAuthTokenRequestWireFormat3 = Kernels.GetFirebaseAuthTokenRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetFirebaseAuthTokenResponse = {
                authToken: ""
            };
            var GetFirebaseAuthTokenResponseWireFormat3 = Kernels.GetFirebaseAuthTokenResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetFirebaseAuthTokenResponse, wireFormat);
                    return message;
                }
            };
            var GetFirebaseConfigRequestWireFormat3 = Kernels.GetFirebaseConfigRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetFirebaseConfigResponse = {
                apiKey: "",
                authDomain: "",
                databaseUrl: "",
                projectId: "",
                storageBucket: "",
                messagingSenderId: "",
                appId: "",
                proxyDomain: ""
            };
            var GetFirebaseConfigResponseWireFormat3 = Kernels.GetFirebaseConfigResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetFirebaseConfigResponse, wireFormat);
                    return message;
                }
            };
            var GetKernelCategoryIdsRequestWireFormat3 = Kernels.GetKernelCategoryIdsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetKernelCollaboratorListRequestWireFormat3 = Kernels.GetKernelCollaboratorListRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetKernelCollaboratorListResponse = {};
            var GetKernelCollaboratorListResponseWireFormat3 = Kernels.GetKernelCollaboratorListResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetKernelCollaboratorListResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaboratorList) {
                        message.collaboratorList = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaboratorList);
                    }
                    return message;
                }
            };
            var GetKernelGitHubSettingsRequestWireFormat3 = Kernels.GetKernelGitHubSettingsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetKernelGitHubSettingsResponse = {
                githubLogin: "",
                repositories: [],
                branches: []
            };
            var GetKernelGitHubSettingsResponseWireFormat3 = Kernels.GetKernelGitHubSettingsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetKernelGitHubSettingsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.repositories) {
                        message.repositories = wireFormat.repositories.map(function(i) {
                            return Kaggle.Sdk.Kernels.GithubRepositoryInfoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.branches) {
                        message.branches = wireFormat.branches.map(function(i) {
                            return Kaggle.Sdk.Kernels.GithubBranchInfoWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastSettings) {
                        message.lastSettings = Kaggle.Sdk.Kernels.GitHubSaveRequestWireFormat3.fromJson(wireFormat.lastSettings);
                    }
                    return message;
                }
            };
            var GetKernelLandingPageRequestWireFormat3 = Kernels.GetKernelLandingPageRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetKernelLandingPageResponse = {
                shelves: [],
                totalPublicKernels: 0
            };
            var GetKernelLandingPageResponseWireFormat3 = Kernels.GetKernelLandingPageResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetKernelLandingPageResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.shelves) {
                        message.shelves = wireFormat.shelves.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelShelfWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var GetKernelListDetailsRequestWireFormat3 = Kernels.GetKernelListDetailsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.unauthorizedAccessBehavior) {
                        wireFormat.unauthorizedAccessBehavior = Kaggle.Sdk.Kernels.AccessBehaviorWireFormat3.toJson(message.unauthorizedAccessBehavior);
                    }
                    if (message === null || message === void 0 ? void 0 : message.deletedAccessBehavior) {
                        wireFormat.deletedAccessBehavior = Kaggle.Sdk.Kernels.AccessBehaviorWireFormat3.toJson(message.deletedAccessBehavior);
                    }
                    if (message === null || message === void 0 ? void 0 : message.readMask) {
                        var _paths;
                        wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
                    }
                    return wireFormat;
                }
            };
            var GetKernelRequestWireFormat3 = Kernels.GetKernelRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.readMask) {
                        var _paths;
                        wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
                    }
                    return wireFormat;
                }
            };
            var GetKernelRunSourceRequestWireFormat3 = Kernels.GetKernelRunSourceRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetKernelRunSourceResponse = {
                source: ""
            };
            var GetKernelRunSourceResponseWireFormat3 = Kernels.GetKernelRunSourceResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetKernelRunSourceResponse, wireFormat);
                    return message;
                }
            };
            var GetKernelSessionDataSourcesRequestWireFormat3 = Kernels.GetKernelSessionDataSourcesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetKernelSessionDataSourcesResponse = {
                dataSources: []
            };
            var GetKernelSessionDataSourcesResponseWireFormat3 = Kernels.GetKernelSessionDataSourcesResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetKernelSessionDataSourcesResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
                        message.dataSources = wireFormat.dataSources.map(function(i) {
                            return KaggleSdkDatasetsDatabundlesDataSourceWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var GetKernelStatusRequestWireFormat3 = Kernels.GetKernelStatusRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.existingStatus) {
                        wireFormat.existingStatus = Kaggle.Sdk.Kernels.KernelWorkerStatusWireFormat3.toJson(message.existingStatus);
                    }
                    return wireFormat;
                }
            };
            var defaultGetKernelStatusResponse = {};
            var GetKernelStatusResponseWireFormat3 = Kernels.GetKernelStatusResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetKernelStatusResponse, wireFormat);
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Kernels.KernelWorkerStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    return message;
                }
            };
            var GetKernelVersionRequestWireFormat3 = Kernels.GetKernelVersionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetKernelVersionResponse = {};
            var GetKernelVersionResponseWireFormat3 = Kernels.GetKernelVersionResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetKernelVersionResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelVersionAndRun) {
                        message.kernelVersionAndRun = Kaggle.Sdk.Kernels.KernelVersionAndRunWireFormat3.fromJson(wireFormat.kernelVersionAndRun);
                    }
                    return message;
                }
            };
            var defaultGetKernelViewModelResponse = {
                outputFiles: [],
                pageMessages: [],
                dataSources: [],
                renderableDataSources: [],
                versions: [],
                menuLinks: [],
                rightMenuLinks: [],
                canWrite: false,
                canAdminister: false,
                currentUserHasForked: false,
                forkParentIsRedacted: false,
                forkDiffLinesChanged: 0,
                forkDiffLinesDeleted: 0,
                forkDiffLinesInserted: 0,
                simplifiedViewer: false,
                disableComments: false,
                showSharingControls: false,
                showUnchangedCopyWarning: false,
                isReportedBannerDismissed: false,
                showAdminAllowlist: false,
                isReportedModalDismissed: false
            };
            var GetKernelViewModelResponseWireFormat3 = Kernels.GetKernelViewModelResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetKernelViewModelResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernel) {
                        message.kernel = Kaggle.Sdk.Kernels.KernelWireFormat3.fromJson(wireFormat.kernel);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelBlob) {
                        message.kernelBlob = Kaggle.Sdk.Kernels.KernelBlobWireFormat3.fromJson(wireFormat.kernelBlob);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelRun) {
                        message.kernelRun = Kaggle.Sdk.Kernels.KernelRunWireFormat3.fromJson(wireFormat.kernelRun);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
                        message.author = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.author);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaborators) {
                        message.collaborators = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaborators);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outputFiles) {
                        message.outputFiles = wireFormat.outputFiles.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelSessionOutputFileWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.ouputFilesOwnerInfo) {
                        message.ouputFilesOwnerInfo = KaggleSdkDatasetsDatabundlesDatabundleOwnerInfoWireFormat3.fromJson(wireFormat.ouputFilesOwnerInfo);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pageMessages) {
                        message.pageMessages = wireFormat.pageMessages.map(function(i) {
                            return KaggleSdkCommonPageMessageWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
                        message.dataSources = wireFormat.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.renderableDataSources) {
                        message.renderableDataSources = wireFormat.renderableDataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.versions) {
                        message.versions = wireFormat.versions.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelVersionHistoryWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
                        message.categories = Kaggle.Sdk.Tags.TagListWireFormat3.fromJson(wireFormat.categories);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submission) {
                        message.submission = Kaggle.Sdk.Kernels.KernelSubmissionWireFormat3.fromJson(wireFormat.submission);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bestSubmissionScore) {
                        message.bestSubmissionScore = Kaggle.Sdk.Kernels.KernelSessionScoreWireFormat3.fromJson(wireFormat.bestSubmissionScore);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.latestSubmissionScore) {
                        message.latestSubmissionScore = Kaggle.Sdk.Kernels.KernelSessionScoreWireFormat3.fromJson(wireFormat.latestSubmissionScore);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.menuLinks) {
                        message.menuLinks = wireFormat.menuLinks.map(function(i) {
                            return Kaggle.Sdk.Kernels.LinkModelWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rightMenuLinks) {
                        message.rightMenuLinks = wireFormat.rightMenuLinks.map(function(i) {
                            return Kaggle.Sdk.Kernels.LinkModelWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.callToAction) {
                        message.callToAction = Kaggle.Sdk.Kernels.LinkModelWireFormat3.fromJson(wireFormat.callToAction);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voteButton) {
                        message.voteButton = KaggleSdkCommonVoteButtonWireFormat3.fromJson(wireFormat.voteButton);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelOutputDataset) {
                        message.kernelOutputDataset = Kaggle.Sdk.Datasets.KernelOutputDatasetReferenceWireFormat3.fromJson(wireFormat.kernelOutputDataset);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.taskSubmissionInfo) {
                        message.taskSubmissionInfo = Kaggle.Sdk.Datasets.KernelTaskSubmissionInfoWireFormat3.fromJson(wireFormat.taskSubmissionInfo);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.learnSeriesNavigationData) {
                        message.learnSeriesNavigationData = KaggleSdkEducationLearnSeriesNavigationDataWireFormat3.fromJson(wireFormat.learnSeriesNavigationData);
                    }
                    if (wireFormat) {
                        message.moderationStatus = KaggleSdkAbusePrivatedModerationStatusWireFormat3.fromJson(wireFormat.moderationStatus);
                    }
                    return message;
                }
            };
            var GetOrCreateKernelSessionRequestWireFormat3 = Kernels.GetOrCreateKernelSessionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetOrCreateKernelSessionResponse = {
                sessionTimeoutSeconds: 0,
                hasMoreRecentCollaboratorVersion: false,
                kernelForkedFromPaidTierWarning: false
            };
            var GetOrCreateKernelSessionResponseWireFormat3 = Kernels.GetOrCreateKernelSessionResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetOrCreateKernelSessionResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.draft) {
                        message.draft = Kaggle.Sdk.Kernels.KernelDraftWireFormat3.fromJson(wireFormat.draft);
                    }
                    if (wireFormat) {
                        message.unusedAcceleratorRemoved = Kaggle.Sdk.Kernels.AcceleratorTypeWireFormat3.fromJson(wireFormat.unusedAcceleratorRemoved);
                    }
                    if (wireFormat) {
                        message.sessionStatus = Kaggle.Sdk.Kernels.KernelWorkerStatusWireFormat3.fromJson(wireFormat.sessionStatus);
                    }
                    return message;
                }
            };
            var GetScheduledKernelSessionRequestWireFormat3 = Kernels.GetScheduledKernelSessionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetScheduledKernelSessionResponse = {};
            var GetScheduledKernelSessionResponseWireFormat3 = Kernels.GetScheduledKernelSessionResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetScheduledKernelSessionResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.session) {
                        message.session = Kaggle.Sdk.Kernels.ScheduledKernelSessionWireFormat3.fromJson(wireFormat.session);
                    }
                    return message;
                }
            };
            var GetSourceIndexDataRequestWireFormat3 = Kernels.GetSourceIndexDataRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetSourceIndexDataResponse = {
                references: []
            };
            var GetSourceIndexDataResponseWireFormat3 = Kernels.GetSourceIndexDataResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetSourceIndexDataResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.definition) {
                        message.definition = Kaggle.Sdk.Kernels.SourceIndexReferenceWireFormat3.fromJson(wireFormat.definition);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.references) {
                        message.references = wireFormat.references.map(function(i) {
                            return Kaggle.Sdk.Kernels.SourceIndexReferenceWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var GetUserKernelAchievementsRequestWireFormat3 = Kernels.GetUserKernelAchievementsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetUserKernelAchievementsResponse = {
                totalUpvotes: 0,
                totalKernels: 0,
                totalForks: 0
            };
            var GetUserKernelAchievementsResponseWireFormat3 = Kernels.GetUserKernelAchievementsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetUserKernelAchievementsResponse, wireFormat);
                    return message;
                }
            };
            var defaultGithubBranchInfo = {
                name: ""
            };
            var GithubBranchInfoWireFormat3 = Kernels.GithubBranchInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGithubBranchInfo, wireFormat);
                    return message;
                }
            };
            var defaultGithubFileInfo = {
                owner: "",
                repo: "",
                path: "",
                ref: "",
                rawUrl: ""
            };
            var GithubFileInfoWireFormat3 = Kernels.GithubFileInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGithubFileInfo, wireFormat);
                    return message;
                }
            };
            var defaultGithubRepositoryInfo = {
                owner: "",
                name: "",
                defaultBranch: ""
            };
            var GithubRepositoryInfoWireFormat3 = Kernels.GithubRepositoryInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGithubRepositoryInfo, wireFormat);
                    return message;
                }
            };
            var defaultGitHubSaveRequest = {
                repositoryOwner: "",
                repositoryName: "",
                branch: "",
                fileName: "",
                commitMessage: "",
                includeKaggleBadge: false
            };
            var GitHubSaveRequestWireFormat3 = Kernels.GitHubSaveRequestWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGitHubSaveRequest, wireFormat);
                    return message;
                },
                toJson: function toJson(message) {
                    return message;
                }
            };
            var HasAcceptedKernelCompetitionRulesRequestWireFormat3 = Kernels.HasAcceptedKernelCompetitionRulesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultHasAcceptedKernelCompetitionRulesResponse = {
                competitionsRequiringAcceptance: []
            };
            var HasAcceptedKernelCompetitionRulesResponseWireFormat3 = Kernels.HasAcceptedKernelCompetitionRulesResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultHasAcceptedKernelCompetitionRulesResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionsRequiringAcceptance) {
                        message.competitionsRequiringAcceptance = wireFormat.competitionsRequiringAcceptance.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelCompetitionWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var IndexAllSnippetsRequestWireFormat3 = Kernels.IndexAllSnippetsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultIndexAllSnippetsResponse = {
                numberOfSnippetsToIndex: 0
            };
            var IndexAllSnippetsResponseWireFormat3 = Kernels.IndexAllSnippetsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultIndexAllSnippetsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.searchIndexResult) {
                        message.searchIndexResult = Kaggle.Sdk.Search.Protos.IndexSnippetResponseWireFormat3.fromJson(wireFormat.searchIndexResult);
                    }
                    return message;
                }
            };
            var defaultKernel = {
                id: 0,
                tags: [],
                commentCount: 0,
                upvoteCount: 0,
                viewCount: 0,
                forkCount: 0,
                isPrivate: false,
                isLanguageTemplate: false,
                disableComments: false,
                hasLinkedSubmission: false,
                currentUserHasBookmarked: false,
                canToggleVisibility: false
            };
            var KernelWireFormat3 = Kernels.KernelWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernel, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.forkParent) {
                        message.forkParent = Kaggle.Sdk.Kernels.KernelForkInfoWireFormat3.fromJson(wireFormat.forkParent);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
                        message.tags = wireFormat.tags.map(function(i) {
                            return Kaggle.Sdk.Kernels.TagWireFormat3.fromJson(i);
                        });
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bestPublicScore) != undefined) {
                        message.bestPublicScore = Number(wireFormat.bestPublicScore);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
                        message.author = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.author);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updatedTime) {
                        message.updatedTime = new Date(wireFormat.updatedTime);
                    }
                    if (wireFormat) {
                        message.dockerImagePinningType = Kaggle.Sdk.Kernels.DockerImagePinningTypeWireFormat3.fromJson(wireFormat.dockerImagePinningType);
                    }
                    if (wireFormat) {
                        message.medal = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.medal);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateOutputToDatasetEnabled) {
                        message.dateOutputToDatasetEnabled = new Date(wireFormat.dateOutputToDatasetEnabled);
                    }
                    return message;
                }
            };
            var defaultKernelBlob = {
                id: 0
            };
            var KernelBlobWireFormat3 = Kernels.KernelBlobWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelBlob, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.settings) {
                        message.settings = Kaggle.Sdk.Kernels.KernelBlobSettingsWireFormat3.fromJson(wireFormat.settings);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
                        message.dateCreated = new Date(wireFormat.dateCreated);
                    }
                    return message;
                }
            };
            var defaultKernelBlobSettings = {
                dataSources: [],
                isInternetEnabled: false,
                isGpuEnabled: false
            };
            var KernelBlobSettingsWireFormat3 = Kernels.KernelBlobSettingsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelBlobSettings, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
                        message.dataSources = wireFormat.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat) {
                        message.sourceType = Kaggle.Sdk.Kernels.EditorTypeWireFormat3.fromJson(wireFormat.sourceType);
                    }
                    if (wireFormat) {
                        message.language = Kaggle.Sdk.Kernels.LanguageWireFormat3.fromJson(wireFormat.language);
                    }
                    if (wireFormat) {
                        message.accelerator = Kaggle.Sdk.Kernels.AcceleratorTypeWireFormat3.fromJson(wireFormat.accelerator);
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.dataSources) {
                        wireFormat.dataSources = message.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.sourceType) {
                        wireFormat.sourceType = Kaggle.Sdk.Kernels.EditorTypeWireFormat3.toJson(message.sourceType);
                    }
                    if (message === null || message === void 0 ? void 0 : message.language) {
                        wireFormat.language = Kaggle.Sdk.Kernels.LanguageWireFormat3.toJson(message.language);
                    }
                    if (message === null || message === void 0 ? void 0 : message.accelerator) {
                        wireFormat.accelerator = Kaggle.Sdk.Kernels.AcceleratorTypeWireFormat3.toJson(message.accelerator);
                    }
                    return wireFormat;
                }
            };
            var defaultKernelCategoryIdList = {
                categoryIds: []
            };
            var KernelCategoryIdListWireFormat3 = Kernels.KernelCategoryIdListWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelCategoryIdList, wireFormat);
                    return message;
                }
            };
            var defaultKernelCompetition = {
                competitionId: 0,
                title: "",
                rulesUrl: ""
            };
            var KernelCompetitionWireFormat3 = Kernels.KernelCompetitionWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelCompetition, wireFormat);
                    return message;
                }
            };
            var defaultKernelDiff = {
                linesInserted: 0,
                linesDeleted: 0,
                linesChanged: 0,
                linesUnchanged: 0,
                newTotalLines: 0
            };
            var KernelDiffWireFormat3 = Kernels.KernelDiffWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelDiff, wireFormat);
                    return message;
                },
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultKernelDraft = {
                sequence: 0,
                kernelVersionId: 0,
                hasMoreRecentCollaboratorVersion: false
            };
            var KernelDraftWireFormat3 = Kernels.KernelDraftWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelDraft, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.blob) {
                        message.blob = Kaggle.Sdk.Kernels.KernelBlobWireFormat3.fromJson(wireFormat.blob);
                    }
                    return message;
                }
            };
            var defaultKernelForkInfo = {
                kernelId: 0,
                runId: 0,
                isRedacted: false,
                isPrivate: false,
                isFork: false
            };
            var KernelForkInfoWireFormat3 = Kernels.KernelForkInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelForkInfo, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
                        message.author = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.author);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.diff) {
                        message.diff = Kaggle.Sdk.Kernels.KernelDiffWireFormat3.fromJson(wireFormat.diff);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
                        message.dateCreated = new Date(wireFormat.dateCreated);
                    }
                    if (wireFormat) {
                        message.workerStatus = Kaggle.Sdk.Kernels.KernelWorkerStatusWireFormat3.fromJson(wireFormat.workerStatus);
                    }
                    if (wireFormat) {
                        message.versionType = Kaggle.Sdk.Kernels.KernelVersionTypeWireFormat3.fromJson(wireFormat.versionType);
                    }
                    return message;
                }
            };
            var defaultKernelList = {
                kernels: []
            };
            var KernelListWireFormat3 = Kernels.KernelListWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelList, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernels) {
                        message.kernels = wireFormat.kernels.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelListItemWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultKernelListItem = {
                currentUserHasVotedForThisScript: false,
                dataSources: [],
                forkDiffLinesChanged: 0,
                forkDiffLinesDeleted: 0,
                forkDiffLinesInserted: 0,
                hasCollaborators: false,
                id: 0,
                isFork: false,
                isPrivate: false,
                isNotebook: false,
                isGpuEnabled: false,
                categories: [],
                totalComments: 0,
                totalForks: 0,
                totalScripts: 0,
                totalViews: 0,
                totalVotes: 0,
                totalLines: 0,
                currentUserHasBookmarked: false,
                isRunning: false,
                isDeleted: false,
                isMyUncommittedDraft: false,
                outputFiles: [],
                canCurrentUserDeleteKernel: false,
                canCurrentUserEditKernel: false,
                hasLinkedSubmission: false,
                disableComments: false,
                scriptUrl: "",
                scriptCommentsUrl: "",
                scriptInputUrl: "",
                scriptEditUrl: "",
                hasDataOutputFiles: false
            };
            var KernelListItemWireFormat3 = Kernels.KernelListItemWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelListItem, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
                        message.author = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.author);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
                        message.dataSources = wireFormat.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceWireFormat3.fromJson(i);
                        });
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bestPublicScore) != undefined) {
                        message.bestPublicScore = Number(wireFormat.bestPublicScore);
                    }
                    if (wireFormat) {
                        message.medal = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.medal);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
                        message.categories = wireFormat.categories.map(function(i) {
                            return KaggleSdkCommonCategoryWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.scriptVersionDateCreated) {
                        message.scriptVersionDateCreated = new Date(wireFormat.scriptVersionDateCreated);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateEvaluated) {
                        message.dateEvaluated = new Date(wireFormat.dateEvaluated);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outputFiles) {
                        message.outputFiles = wireFormat.outputFiles.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelSessionOutputFileWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.taskSubmissionInfo) {
                        message.taskSubmissionInfo = Kaggle.Sdk.Datasets.KernelTaskSubmissionInfoWireFormat3.fromJson(wireFormat.taskSubmissionInfo);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.forkParentInfo) {
                        message.forkParentInfo = Kaggle.Sdk.Kernels.ForkParentInfoWireFormat3.fromJson(wireFormat.forkParentInfo);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateOutputToDatasetEnabled) {
                        message.dateOutputToDatasetEnabled = new Date(wireFormat.dateOutputToDatasetEnabled);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastRunTime) {
                        message.lastRunTime = new Date(wireFormat.lastRunTime);
                    }
                    return message;
                }
            };
            var defaultKernelRun = {
                id: 0,
                kernelId: 0,
                scriptLanguageId: 0,
                usedCustomDockerImage: false,
                dataSources: [],
                isGpuEnabled: false,
                isTpuEnabled: false,
                isInternetEnabled: false,
                isKernelScheduled: false
            };
            var KernelRunWireFormat3 = Kernels.KernelRunWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelRun, wireFormat);
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Kernels.KernelWorkerStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    if (wireFormat) {
                        message.kernelVersionType = Kaggle.Sdk.Kernels.KernelVersionTypeWireFormat3.fromJson(wireFormat.kernelVersionType);
                    }
                    if (wireFormat) {
                        message.sourceType = Kaggle.Sdk.Kernels.EditorTypeWireFormat3.fromJson(wireFormat.sourceType);
                    }
                    if (wireFormat) {
                        message.language = Kaggle.Sdk.Kernels.LanguageWireFormat3.fromJson(wireFormat.language);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
                        message.dateCreated = new Date(wireFormat.dateCreated);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateEvaluated) {
                        message.dateEvaluated = new Date(wireFormat.dateEvaluated);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCancelled) {
                        message.dateCancelled = new Date(wireFormat.dateCancelled);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.commit) {
                        message.commit = Kaggle.Sdk.Kernels.KernelBlobWireFormat3.fromJson(wireFormat.commit);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.resources) {
                        message.resources = Kaggle.Sdk.Kernels.KernelSessionResourcesWireFormat3.fromJson(wireFormat.resources);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.runInfo) {
                        message.runInfo = Kaggle.Sdk.Kernels.KernelSessionInfoWireFormat3.fromJson(wireFormat.runInfo);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
                        message.dataSources = wireFormat.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat) {
                        message.acceleratorType = Kaggle.Sdk.Kernels.AcceleratorTypeWireFormat3.fromJson(wireFormat.acceleratorType);
                    }
                    if (wireFormat) {
                        message.userPlan = KaggleSdkUsersUserPlanWireFormat3.fromJson(wireFormat.userPlan);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.nextScheduledSessionDate) {
                        message.nextScheduledSessionDate = new Date(wireFormat.nextScheduledSessionDate);
                    }
                    return message;
                }
            };
            var defaultKernelRunLog = {
                lineNumber: 0,
                elapsedSeconds: 0
            };
            var KernelRunLogWireFormat3 = Kernels.KernelRunLogWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelRunLog, wireFormat);
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.elapsedSeconds) != undefined) {
                        message.elapsedSeconds = Number(wireFormat.elapsedSeconds);
                    }
                    if (wireFormat) {
                        message.streamName = Kaggle.Sdk.Kernels.StreamNameWireFormat3.fromJson(wireFormat.streamName);
                    }
                    return message;
                }
            };
            var defaultKernelSession = {
                kernelId: 0,
                kernelRunId: 0,
                isInternetEnabled: false
            };
            var KernelSessionWireFormat3 = Kernels.KernelSessionWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelSession, wireFormat);
                    if (wireFormat) {
                        message.type = Kaggle.Sdk.Kernels.KernelVersionTypeWireFormat3.fromJson(wireFormat.type);
                    }
                    if (wireFormat) {
                        message.sourceType = Kaggle.Sdk.Kernels.EditorTypeWireFormat3.fromJson(wireFormat.sourceType);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
                        message.dateCreated = new Date(wireFormat.dateCreated);
                    }
                    if (wireFormat) {
                        message.accelerator = Kaggle.Sdk.Kernels.AcceleratorTypeWireFormat3.fromJson(wireFormat.accelerator);
                    }
                    return message;
                }
            };
            var defaultKernelSessionInfo = {
                exitCode: 0,
                runTimeSeconds: 0,
                usedAllSpace: false,
                timeoutExceeded: false,
                outOfMemory: false,
                invalidPathErrors: false,
                succeeded: false,
                wasKilled: false
            };
            var KernelSessionInfoWireFormat3 = Kernels.KernelSessionInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelSessionInfo, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outputSizeBytes) {
                        message.outputSizeBytes = parseInt(wireFormat.outputSizeBytes);
                    }
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.runTimeSeconds) != undefined) {
                        message.runTimeSeconds = Number(wireFormat.runTimeSeconds);
                    }
                    return message;
                }
            };
            var defaultKernelSessionList = {
                totalCount: 0,
                sessions: []
            };
            var KernelSessionListWireFormat3 = Kernels.KernelSessionListWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelSessionList, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.quotaLimits) {
                        message.quotaLimits = Kaggle.Sdk.Kernels.KernelSessionQuotaLimitsWireFormat3.fromJson(wireFormat.quotaLimits);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sessions) {
                        message.sessions = wireFormat.sessions.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelSessionWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultKernelSessionOutputFile = {
                kernelSessionId: 0,
                kernelId: 0,
                contentLength: 0
            };
            var KernelSessionOutputFileWireFormat3 = Kernels.KernelSessionOutputFileWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelSessionOutputFile, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentLength) {
                        message.contentLength = parseInt(wireFormat.contentLength);
                    }
                    return message;
                }
            };
            var defaultKernelSessionQuotaLimits = {
                gpuInteractive: 0,
                gpuBatch: 0,
                cpuInteractive: 0,
                cpuBatch: 0,
                tpuInteractive: 0,
                tpuBatch: 0
            };
            var KernelSessionQuotaLimitsWireFormat3 = Kernels.KernelSessionQuotaLimitsWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelSessionQuotaLimits, wireFormat);
                    return message;
                }
            };
            var defaultKernelSessionResources = {
                storageBytes: 0,
                memoryBytes: 0,
                cpuCores: 0,
                sessionTimeoutSeconds: 0,
                idleTimeoutSeconds: 0
            };
            var KernelSessionResourcesWireFormat3 = Kernels.KernelSessionResourcesWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelSessionResources, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.storageBytes) {
                        message.storageBytes = parseInt(wireFormat.storageBytes);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.memoryBytes) {
                        message.memoryBytes = parseInt(wireFormat.memoryBytes);
                    }
                    return message;
                }
            };
            var defaultKernelSessionScore = {
                score: 0,
                kernelVersionNumber: 0,
                kernelSessionUrl: ""
            };
            var KernelSessionScoreWireFormat3 = Kernels.KernelSessionScoreWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelSessionScore, wireFormat);
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.score) != undefined) {
                        message.score = Number(wireFormat.score);
                    }
                    return message;
                }
            };
            var defaultKernelShelf = {
                kernels: [],
                totalKernels: 0
            };
            var KernelShelfWireFormat3 = Kernels.KernelShelfWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelShelf, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernels) {
                        message.kernels = wireFormat.kernels.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelListItemWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.moreKernelsRequest) {
                        message.moreKernelsRequest = Kaggle.Sdk.Kernels.ListKernelIdsRequestWireFormat3.fromJson(wireFormat.moreKernelsRequest);
                    }
                    return message;
                }
            };
            var defaultKernelSubmission = {
                submissionId: 0,
                status: 0
            };
            var KernelSubmissionWireFormat3 = Kernels.KernelSubmissionWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelSubmission, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
                        message.date = new Date(wireFormat.date);
                    }
                    return message;
                }
            };
            var defaultKernelVersion = {
                id: 0,
                versionNumber: 0,
                linesTotal: 0,
                linesInserted: 0,
                linesDeleted: 0
            };
            var KernelVersionWireFormat3 = Kernels.KernelVersionWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelVersion, wireFormat);
                    if (wireFormat) {
                        message.pinningType = Kaggle.Sdk.Kernels.KernelVersionPinningTypeWireFormat3.fromJson(wireFormat.pinningType);
                    }
                    if (wireFormat) {
                        message.versionType = Kaggle.Sdk.Kernels.KernelVersionTypeWireFormat3.fromJson(wireFormat.versionType);
                    }
                    if (wireFormat) {
                        message.userPlan = KaggleSdkUsersUserPlanWireFormat3.fromJson(wireFormat.userPlan);
                    }
                    return message;
                }
            };
            var defaultKernelVersionAndRun = {
                isForkParent: false,
                viewerUrl: ""
            };
            var KernelVersionAndRunWireFormat3 = Kernels.KernelVersionAndRunWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelVersionAndRun, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
                        message.author = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.author);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.version) {
                        message.version = Kaggle.Sdk.Kernels.KernelVersionWireFormat3.fromJson(wireFormat.version);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.run) {
                        message.run = Kaggle.Sdk.Kernels.KernelRunWireFormat3.fromJson(wireFormat.run);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.blob) {
                        message.blob = Kaggle.Sdk.Kernels.KernelBlobWireFormat3.fromJson(wireFormat.blob);
                    }
                    return message;
                }
            };
            var defaultKernelVersionHistory = {
                id: 0,
                isForkParent: false,
                isNotebook: false,
                linesChangedFromPrevious: 0,
                linesDeletedFromPrevious: 0,
                linesInsertedFromPrevious: 0,
                outputFilesTotalSizeBytes: 0,
                url: "",
                versionNumber: 0,
                hasVersionNumber: false,
                isRedacted: false
            };
            var KernelVersionHistoryWireFormat3 = Kernels.KernelVersionHistoryWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelVersionHistory, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastRunTime) {
                        message.lastRunTime = new Date(wireFormat.lastRunTime);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outputFilesTotalSizeBytes) {
                        message.outputFilesTotalSizeBytes = parseInt(wireFormat.outputFilesTotalSizeBytes);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.runInfo) {
                        message.runInfo = Kaggle.Sdk.Kernels.KernelVersionRunInfoWireFormat3.fromJson(wireFormat.runInfo);
                    }
                    if (wireFormat) {
                        message.status = Kaggle.Sdk.Kernels.KernelWorkerStatusWireFormat3.fromJson(wireFormat.status);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.versionAuthor) {
                        message.versionAuthor = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.versionAuthor);
                    }
                    if (wireFormat) {
                        message.versionType = Kaggle.Sdk.Kernels.KernelVersionTypeWireFormat3.fromJson(wireFormat.versionType);
                    }
                    if (wireFormat) {
                        message.userPlan = KaggleSdkUsersUserPlanWireFormat3.fromJson(wireFormat.userPlan);
                    }
                    return message;
                }
            };
            var defaultKernelVersionList = {
                items: []
            };
            var KernelVersionListWireFormat3 = Kernels.KernelVersionListWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelVersionList, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.items) {
                        message.items = wireFormat.items.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelVersionAndRunWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultKernelVersionRunInfo = {
                exitCode: 0,
                isValidStatus: false,
                succeeded: false,
                timeoutExceeded: false
            };
            var KernelVersionRunInfoWireFormat3 = Kernels.KernelVersionRunInfoWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultKernelVersionRunInfo, wireFormat);
                    if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.runTimeSeconds) != undefined) {
                        message.runTimeSeconds = Number(wireFormat.runTimeSeconds);
                    }
                    return message;
                }
            };
            var defaultLinkModel = {
                showZeroCountExplicitly: false
            };
            var LinkModelWireFormat3 = Kernels.LinkModelWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultLinkModel, wireFormat);
                    return message;
                }
            };
            var ListDockerImagesRequestWireFormat3 = Kernels.ListDockerImagesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var ListGithubRepositoriesRequestWireFormat3 = Kernels.ListGithubRepositoriesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultListGithubRepositoriesResponse = {
                repositories: []
            };
            var ListGithubRepositoriesResponseWireFormat3 = Kernels.ListGithubRepositoriesResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListGithubRepositoriesResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.repositories) {
                        message.repositories = wireFormat.repositories.map(function(i) {
                            return Kaggle.Sdk.Kernels.GithubRepositoryInfoWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var ListGithubRepositoryBranchesRequestWireFormat3 = Kernels.ListGithubRepositoryBranchesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultListGithubRepositoryBranchesResponse = {
                branches: []
            };
            var ListGithubRepositoryBranchesResponseWireFormat3 = Kernels.ListGithubRepositoryBranchesResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListGithubRepositoryBranchesResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.branches) {
                        message.branches = wireFormat.branches.map(function(i) {
                            return Kaggle.Sdk.Kernels.GithubBranchInfoWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var ListGithubRepositoryFilesRequestWireFormat3 = Kernels.ListGithubRepositoryFilesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultListGithubRepositoryFilesResponse = {
                files: []
            };
            var ListGithubRepositoryFilesResponseWireFormat3 = Kernels.ListGithubRepositoryFilesResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListGithubRepositoryFilesResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.files) {
                        message.files = wireFormat.files.map(function(i) {
                            return Kaggle.Sdk.Kernels.GithubFileInfoWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultListKernelIdsRequest = {
                excludeResultsFilesOutputs: false,
                page: 0,
                pageSize: 0,
                wantOutputFiles: false
            };
            var ListKernelIdsRequestWireFormat3 = Kernels.ListKernelIdsRequestWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListKernelIdsRequest, wireFormat);
                    if (wireFormat) {
                        message.group = Kaggle.Sdk.Kernels.KernelsListViewTypeWireFormat3.fromJson(wireFormat.group);
                    }
                    if (wireFormat) {
                        message.sortBy = Kaggle.Sdk.Kernels.KernelsListSortTypeWireFormat3.fromJson(wireFormat.sortBy);
                    }
                    return message;
                },
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.group) {
                        wireFormat.group = Kaggle.Sdk.Kernels.KernelsListViewTypeWireFormat3.toJson(message.group);
                    }
                    if (message === null || message === void 0 ? void 0 : message.sortBy) {
                        wireFormat.sortBy = Kaggle.Sdk.Kernels.KernelsListSortTypeWireFormat3.toJson(message.sortBy);
                    }
                    return wireFormat;
                }
            };
            var defaultListKernelIdsResponse = {
                kernelIds: []
            };
            var ListKernelIdsResponseWireFormat3 = Kernels.ListKernelIdsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListKernelIdsResponse, wireFormat);
                    return message;
                }
            };
            var ListKernelRunLogsRequestWireFormat3 = Kernels.ListKernelRunLogsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultListKernelRunLogsResponse = {
                logs: []
            };
            var ListKernelRunLogsResponseWireFormat3 = Kernels.ListKernelRunLogsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListKernelRunLogsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.logs) {
                        message.logs = wireFormat.logs.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelRunLogWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var ListKernelSessionOutputFilesHierarchicalRequestWireFormat3 = Kernels.ListKernelSessionOutputFilesHierarchicalRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultListKernelSessionOutputFilesHierarchicalResponse = {
                directories: [],
                files: []
            };
            var ListKernelSessionOutputFilesHierarchicalResponseWireFormat3 = Kernels.ListKernelSessionOutputFilesHierarchicalResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListKernelSessionOutputFilesHierarchicalResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.directories) {
                        message.directories = wireFormat.directories.map(function(i) {
                            return KaggleSdkDatasetsDatabundlesDirectoryWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.files) {
                        message.files = wireFormat.files.map(function(i) {
                            return KaggleSdkDatasetsDatabundlesFileWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var ListKernelSessionOutputRequestWireFormat3 = Kernels.ListKernelSessionOutputRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultListKernelSessionOutputResponse = {
                items: []
            };
            var ListKernelSessionOutputResponseWireFormat3 = Kernels.ListKernelSessionOutputResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListKernelSessionOutputResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.items) {
                        message.items = wireFormat.items.map(function(i) {
                            return Kaggle.Sdk.Kernels.KernelSessionOutputFileWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var ListKernelSessionsRequestWireFormat3 = Kernels.ListKernelSessionsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var ListKernelsRequestWireFormat3 = Kernels.ListKernelsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.kernelFilterCriteria) {
                        wireFormat.kernelFilterCriteria = Kaggle.Sdk.Kernels.SearchKernelIdsRequestWireFormat3.toJson(message.kernelFilterCriteria);
                    }
                    if (message === null || message === void 0 ? void 0 : message.detailFilterCriteria) {
                        wireFormat.detailFilterCriteria = Kaggle.Sdk.Kernels.GetKernelListDetailsRequestWireFormat3.toJson(message.detailFilterCriteria);
                    }
                    return wireFormat;
                }
            };
            var ListKernelVersionsRequestWireFormat3 = Kernels.ListKernelVersionsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var ListSnippetsRequestWireFormat3 = Kernels.ListSnippetsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultListSnippetsResponse = {
                snippets: []
            };
            var ListSnippetsResponseWireFormat3 = Kernels.ListSnippetsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListSnippetsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.snippets) {
                        message.snippets = wireFormat.snippets.map(function(i) {
                            return Kaggle.Sdk.Kernels.SnippetWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultParentKernelVersionData = {
                kernelVersionId: 0
            };
            var ParentKernelVersionDataWireFormat3 = Kernels.ParentKernelVersionDataWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultParentKernelVersionData, wireFormat);
                    return message;
                }
            };
            var RemoveKernelCategoryRequestWireFormat3 = Kernels.RemoveKernelCategoryRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var RunEpisodeRequestWireFormat3 = Kernels.RunEpisodeRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.episodeType) {
                        wireFormat.episodeType = KaggleSdkCompetitionsEpisodeTypeWireFormat3.toJson(message.episodeType);
                    }
                    if (message === null || message === void 0 ? void 0 : message.agents) {
                        wireFormat.agents = message.agents.map(function(i) {
                            return Kaggle.Sdk.Kernels.AgentEntryWireFormat3.toJson(i);
                        });
                    }
                    if (message === null || message === void 0 ? void 0 : message.renderType) {
                        wireFormat.renderType = KaggleSdkCompetitionsEnvironmentRenderTypeWireFormat3.toJson(message.renderType);
                    }
                    return wireFormat;
                }
            };
            var defaultRunEpisodeResponse = {};
            var RunEpisodeResponseWireFormat3 = Kernels.RunEpisodeResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultRunEpisodeResponse, wireFormat);
                    return message;
                }
            };
            var defaultScheduledKernelSession = {
                id: 0,
                kernelId: 0,
                iterations: 0,
                iteration: 0
            };
            var ScheduledKernelSessionWireFormat3 = Kernels.ScheduledKernelSessionWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultScheduledKernelSession, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationDate) {
                        message.creationDate = new Date(wireFormat.creationDate);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.startDate) {
                        message.startDate = new Date(wireFormat.startDate);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastSessionDate) {
                        message.lastSessionDate = new Date(wireFormat.lastSessionDate);
                    }
                    if (wireFormat) {
                        message.frequency = Kaggle.Sdk.Kernels.ScheduleFrequencyTypeWireFormat3.fromJson(wireFormat.frequency);
                    }
                    if (wireFormat) {
                        message.trigger = Kaggle.Sdk.Kernels.ScheduleTriggerTypeWireFormat3.fromJson(wireFormat.trigger);
                    }
                    return message;
                }
            };
            var ScheduleKernelSessionRequestWireFormat3 = Kernels.ScheduleKernelSessionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.trigger) {
                        wireFormat.trigger = Kaggle.Sdk.Kernels.ScheduleTriggerTypeWireFormat3.toJson(message.trigger);
                    }
                    if (message === null || message === void 0 ? void 0 : message.frequency) {
                        wireFormat.frequency = Kaggle.Sdk.Kernels.ScheduleFrequencyTypeWireFormat3.toJson(message.frequency);
                    }
                    if (message === null || message === void 0 ? void 0 : message.startDate) {
                        wireFormat.startDate = message.startDate.toISOString();
                    }
                    return wireFormat;
                }
            };
            var SearchKernelIdsRequestWireFormat3 = Kernels.SearchKernelIdsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.listRequest) {
                        wireFormat.listRequest = Kaggle.Sdk.Kernels.ListKernelIdsRequestWireFormat3.toJson(message.listRequest);
                    }
                    if (message === null || message === void 0 ? void 0 : message.group) {
                        wireFormat.group = Kaggle.Sdk.Kernels.KernelsListViewTypeWireFormat3.toJson(message.group);
                    }
                    if (message === null || message === void 0 ? void 0 : message.sortBy) {
                        wireFormat.sortBy = Kaggle.Sdk.Kernels.KernelsListSortTypeWireFormat3.toJson(message.sortBy);
                    }
                    return wireFormat;
                }
            };
            var defaultSearchKernelIdsResponse = {
                kernelIds: []
            };
            var SearchKernelIdsResponseWireFormat3 = Kernels.SearchKernelIdsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultSearchKernelIdsResponse, wireFormat);
                    return message;
                }
            };
            var defaultSnippet = {
                id: 0,
                authorUserId: 0
            };
            var SnippetWireFormat3 = Kernels.SnippetWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultSnippet, wireFormat);
                    return message;
                }
            };
            var SnippetDataWireFormat3 = Kernels.SnippetDataWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultSnippetReference = {
                lineNumber: 0
            };
            var SnippetReferenceWireFormat3 = Kernels.SnippetReferenceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultSnippetReference, wireFormat);
                    return message;
                }
            };
            var defaultSourceIndexReference = {
                kernelId: 0,
                kernelRunId: 0,
                dataSources: [],
                totalVotes: 0,
                definitions: [],
                snippets: [],
                totalSnippetCount: 0
            };
            var SourceIndexReferenceWireFormat3 = Kernels.SourceIndexReferenceWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultSourceIndexReference, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
                        message.dataSources = wireFormat.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateEvaluated) {
                        message.dateEvaluated = new Date(wireFormat.dateEvaluated);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.definitions) {
                        message.definitions = wireFormat.definitions.map(function(i) {
                            return Kaggle.Sdk.Kernels.SnippetReferenceWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.snippets) {
                        message.snippets = wireFormat.snippets.map(function(i) {
                            return Kaggle.Sdk.Kernels.SnippetReferenceWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var SubmissionRequestedDetailsWireFormat3 = Kernels.SubmissionRequestedDetailsWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.fileNames) {
                        wireFormat.fileNames = message.fileNames.map(function(i) {
                            return google.protobuf.StringValueWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var defaultTag = {};
            var TagWireFormat3 = Kernels.TagWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultTag, wireFormat);
                    return message;
                }
            };
            var defaultUpdateDataSourceResult = {};
            var UpdateDataSourceResultWireFormat3 = Kernels.UpdateDataSourceResultWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateDataSourceResult, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.reference) {
                        message.reference = Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.fromJson(wireFormat.reference);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.mountedVersion) {
                        message.mountedVersion = Kaggle.Sdk.Kernels.DataSourceVersionWireFormat3.fromJson(wireFormat.mountedVersion);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.newVersion) {
                        message.newVersion = Kaggle.Sdk.Kernels.DataSourceVersionWireFormat3.fromJson(wireFormat.newVersion);
                    }
                    return message;
                }
            };
            var UpdateDefaultSessionSettingsRequestWireFormat3 = Kernels.UpdateDefaultSessionSettingsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.settings) {
                        wireFormat.settings = Kaggle.Sdk.Kernels.DefaultSessionSettingsWireFormat3.toJson(message.settings);
                    }
                    return wireFormat;
                }
            };
            var UpdateDockerImageVersionRequestWireFormat3 = Kernels.UpdateDockerImageVersionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var UpdateDockerPinningTypeRequestWireFormat3 = Kernels.UpdateDockerPinningTypeRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.dockerImagePinningType) {
                        wireFormat.dockerImagePinningType = Kaggle.Sdk.Kernels.DockerImagePinningTypeWireFormat3.toJson(message.dockerImagePinningType);
                    }
                    return wireFormat;
                }
            };
            var UpdateKernelCollaboratorsRequestWireFormat3 = Kernels.UpdateKernelCollaboratorsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.collaborators) {
                        wireFormat.collaborators = KaggleSdkUsersCollaboratorListWireFormat3.toJson(message.collaborators);
                    }
                    return wireFormat;
                }
            };
            var defaultUpdateKernelCollaboratorsResponse = {
                privateDataSources: []
            };
            var UpdateKernelCollaboratorsResponseWireFormat3 = Kernels.UpdateKernelCollaboratorsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateKernelCollaboratorsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateDataSources) {
                        message.privateDataSources = wireFormat.privateDataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaborators) {
                        message.collaborators = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaborators);
                    }
                    return message;
                }
            };
            var UpdateKernelDraftRequestWireFormat3 = Kernels.UpdateKernelDraftRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.settings) {
                        wireFormat.settings = Kaggle.Sdk.Kernels.KernelBlobSettingsWireFormat3.toJson(message.settings);
                    }
                    if (message === null || message === void 0 ? void 0 : message.externalSourceData) {
                        wireFormat.externalSourceData = Kaggle.Sdk.Kernels.ExternalSourceDataWireFormat3.toJson(message.externalSourceData);
                    }
                    return wireFormat;
                }
            };
            var defaultUpdateKernelDraftResponse = {
                sequence: 0,
                kernelVersionId: 0
            };
            var UpdateKernelDraftResponseWireFormat3 = Kernels.UpdateKernelDraftResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateKernelDraftResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.computedParent) {
                        message.computedParent = Kaggle.Sdk.Kernels.ParentKernelVersionDataWireFormat3.fromJson(wireFormat.computedParent);
                    }
                    return message;
                }
            };
            var UpdateKernelOutputToDatasetRequestWireFormat3 = Kernels.UpdateKernelOutputToDatasetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var UpdateKernelPrivacyRequestWireFormat3 = Kernels.UpdateKernelPrivacyRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultUpdateKernelPrivacyResponse = {
                canToggleVisibility: false
            };
            var UpdateKernelPrivacyResponseWireFormat3 = Kernels.UpdateKernelPrivacyResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateKernelPrivacyResponse, wireFormat);
                    return message;
                }
            };
            var UpdateKernelRunDataSourcesRequestWireFormat3 = Kernels.UpdateKernelRunDataSourcesRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.dataSources) {
                        wireFormat.dataSources = message.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var defaultUpdateKernelRunDataSourcesResponse = {
                results: [],
                anyChanges: false
            };
            var UpdateKernelRunDataSourcesResponseWireFormat3 = Kernels.UpdateKernelRunDataSourcesResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateKernelRunDataSourcesResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.results) {
                        message.results = wireFormat.results.map(function(i) {
                            return Kaggle.Sdk.Kernels.UpdateDataSourceResultWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var UpdateKernelSessionKeepaliveRequestWireFormat3 = Kernels.UpdateKernelSessionKeepaliveRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var UpdateKernelSessionRequestWireFormat3 = Kernels.UpdateKernelSessionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.dataSources) {
                        wireFormat.dataSources = message.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.toJson(i);
                        });
                    }
                    return wireFormat;
                }
            };
            var defaultUpdateKernelSessionResponse = {
                restartRequired: false,
                dataSources: []
            };
            var UpdateKernelSessionResponseWireFormat3 = Kernels.UpdateKernelSessionResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateKernelSessionResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
                        message.dataSources = wireFormat.dataSources.map(function(i) {
                            return Kaggle.Sdk.Kernels.DataSourceReferenceWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var UpdateKernelTitleRequestWireFormat3 = Kernels.UpdateKernelTitleRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultUpdateKernelTitleResponse = {};
            var UpdateKernelTitleResponseWireFormat3 = Kernels.UpdateKernelTitleResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateKernelTitleResponse, wireFormat);
                    return message;
                }
            };
            var UpdateKernelVersionNameRequestWireFormat3 = Kernels.UpdateKernelVersionNameRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var UpdatePinnedKernelSessionRequestWireFormat3 = Kernels.UpdatePinnedKernelSessionRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.pinningType) {
                        wireFormat.pinningType = Kaggle.Sdk.Kernels.KernelVersionPinningTypeWireFormat3.toJson(message.pinningType);
                    }
                    return wireFormat;
                }
            };
            var UpdateSnippetRequestWireFormat3 = Kernels.UpdateSnippetRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.data) {
                        wireFormat.data = Kaggle.Sdk.Kernels.SnippetDataWireFormat3.toJson(message.data);
                    }
                    return wireFormat;
                }
            };
            var UpdateUserKernelFirestoreAuthRequestWireFormat3 = Kernels.UpdateUserKernelFirestoreAuthRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultUpdateUserKernelFirestoreAuthResponse = {};
            var UpdateUserKernelFirestoreAuthResponseWireFormat3 = Kernels.UpdateUserKernelFirestoreAuthResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateUserKernelFirestoreAuthResponse, wireFormat);
                    return message;
                }
            };
            var UploadKernelSessionOutputRequestWireFormat3 = Kernels.UploadKernelSessionOutputRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var AcceleratorType;
            (function(AcceleratorType) {
                AcceleratorType[// Note: the enum values below should correspond
                // exactly to the values in AcceleratorTypes table.
                "NONE"] = "none";
                AcceleratorType["GPU"] = "gpu";
                AcceleratorType["TPU_V3_8"] = "tpuV38";
                AcceleratorType["TPU_V2_32"] = "tpuV232";
                AcceleratorType["TPU_V2_256"] = "tpuV2256";
            })(AcceleratorType = Kernels.AcceleratorType || (Kernels.AcceleratorType = {}));
            var AcceleratorTypeWireFormat3 = Kernels.AcceleratorTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "ACCELERATOR_TYPE_NONE":
                        default:
                            return AcceleratorType.NONE;
                        case "GPU":
                            return AcceleratorType.GPU;
                        case "TPU_V3_8":
                            return AcceleratorType.TPU_V3_8;
                        case "TPU_V2_32":
                            return AcceleratorType.TPU_V2_32;
                        case "TPU_V2_256":
                            return AcceleratorType.TPU_V2_256;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case AcceleratorType.NONE:
                        case 0:
                        default:
                            return "ACCELERATOR_TYPE_NONE";
                        case AcceleratorType.GPU:
                        case 2:
                            return "GPU";
                        case AcceleratorType.TPU_V3_8:
                        case 4:
                            return "TPU_V3_8";
                        case AcceleratorType.TPU_V2_32:
                        case 5:
                            return "TPU_V2_32";
                        case AcceleratorType.TPU_V2_256:
                        case 7:
                            return "TPU_V2_256";
                    }
                }
            };
            var AccessBehavior;
            (function(AccessBehavior) {
                AccessBehavior["RETURN_SHELL_ENTRY"] = "returnShellEntry";
                AccessBehavior["RETURN_NOTHING"] = "returnNothing";
            })(AccessBehavior = Kernels.AccessBehavior || (Kernels.AccessBehavior = {}));
            var AccessBehaviorWireFormat3 = Kernels.AccessBehaviorWireFormat3 = {
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case AccessBehavior.RETURN_SHELL_ENTRY:
                        case 0:
                        default:
                            return "RETURN_SHELL_ENTRY";
                        case AccessBehavior.RETURN_NOTHING:
                        case 1:
                            return "RETURN_NOTHING";
                    }
                }
            };
            var DataSourceType;
            (function(DataSourceType) {
                DataSourceType["COMPETITION"] = "competition";
                DataSourceType["DATASET_VERSION"] = "datasetVersion";
                DataSourceType["KERNEL_VERSION"] = "kernelVersion";
            })(DataSourceType = Kernels.DataSourceType || (Kernels.DataSourceType = {}));
            var DataSourceTypeWireFormat3 = Kernels.DataSourceTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DATA_SOURCE_TYPE_COMPETITION":
                        default:
                            return DataSourceType.COMPETITION;
                        case "DATA_SOURCE_TYPE_DATASET_VERSION":
                            return DataSourceType.DATASET_VERSION;
                        case "DATA_SOURCE_TYPE_KERNEL_VERSION":
                            return DataSourceType.KERNEL_VERSION;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case DataSourceType.COMPETITION:
                        case 0:
                        default:
                            return "DATA_SOURCE_TYPE_COMPETITION";
                        case DataSourceType.DATASET_VERSION:
                        case 1:
                            return "DATA_SOURCE_TYPE_DATASET_VERSION";
                        case DataSourceType.KERNEL_VERSION:
                        case 2:
                            return "DATA_SOURCE_TYPE_KERNEL_VERSION";
                    }
                }
            };
            var DockerImagePinningType;
            (function(DockerImagePinningType) {
                DockerImagePinningType["UNSPECIFIED"] = "unspecified";
                DockerImagePinningType["ORIGINAL"] = "original";
                DockerImagePinningType["LATEST"] = "latest";
            })(DockerImagePinningType = Kernels.DockerImagePinningType || (Kernels.DockerImagePinningType = {}));
            var DockerImagePinningTypeWireFormat3 = Kernels.DockerImagePinningTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DOCKER_IMAGE_PINNING_TYPE_UNSPECIFIED":
                        default:
                            return DockerImagePinningType.UNSPECIFIED;
                        case "DOCKER_IMAGE_PINNING_TYPE_ORIGINAL":
                            return DockerImagePinningType.ORIGINAL;
                        case "DOCKER_IMAGE_PINNING_TYPE_LATEST":
                            return DockerImagePinningType.LATEST;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case DockerImagePinningType.UNSPECIFIED:
                        case 0:
                        default:
                            return "DOCKER_IMAGE_PINNING_TYPE_UNSPECIFIED";
                        case DockerImagePinningType.ORIGINAL:
                        case 1:
                            return "DOCKER_IMAGE_PINNING_TYPE_ORIGINAL";
                        case DockerImagePinningType.LATEST:
                        case 2:
                            return "DOCKER_IMAGE_PINNING_TYPE_LATEST";
                    }
                }
            };
            var DockerImageVersionDisabledReason;
            (function(DockerImageVersionDisabledReason) {
                DockerImageVersionDisabledReason["UNSPECIFIED"] = "unspecified";
                DockerImageVersionDisabledReason["TPU_RESTRICTION"] = "tpuRestriction";
            })(DockerImageVersionDisabledReason = Kernels.DockerImageVersionDisabledReason || (Kernels.DockerImageVersionDisabledReason = {}));
            var DockerImageVersionDisabledReasonWireFormat3 = Kernels.DockerImageVersionDisabledReasonWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DOCKER_IMAGE_VERSION_DISABLED_REASON_UNSPECIFIED":
                        default:
                            return DockerImageVersionDisabledReason.UNSPECIFIED;
                        case "TPU_RESTRICTION":
                            return DockerImageVersionDisabledReason.TPU_RESTRICTION;
                    }
                }
            };
            var DockerImageVersionType;
            (function(DockerImageVersionType) {
                DockerImageVersionType["LATEST"] = "latest";
                DockerImageVersionType["ORIGINAL"] = "original";
                DockerImageVersionType["COMPETITION"] = "competition";
            })(DockerImageVersionType = Kernels.DockerImageVersionType || (Kernels.DockerImageVersionType = {}));
            var DockerImageVersionTypeWireFormat3 = Kernels.DockerImageVersionTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "DOCKER_IMAGE_VERSION_TYPE_LATEST":
                        default:
                            return DockerImageVersionType.LATEST;
                        case "DOCKER_IMAGE_VERSION_TYPE_ORIGINAL":
                            return DockerImageVersionType.ORIGINAL;
                        case "DOCKER_IMAGE_VERSION_TYPE_COMPETITION":
                            return DockerImageVersionType.COMPETITION;
                    }
                }
            };
            var EditorType;
            (function(EditorType) {
                EditorType["UNSPECIFIED"] = "unspecified";
                EditorType["SCRIPT"] = "script";
                EditorType["NOTEBOOK"] = "notebook";
            })(EditorType = Kernels.EditorType || (Kernels.EditorType = {}));
            var EditorTypeWireFormat3 = Kernels.EditorTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "EDITOR_TYPE_UNSPECIFIED":
                        default:
                            return EditorType.UNSPECIFIED;
                        case "EDITOR_TYPE_SCRIPT":
                            return EditorType.SCRIPT;
                        case "EDITOR_TYPE_NOTEBOOK":
                            return EditorType.NOTEBOOK;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case EditorType.UNSPECIFIED:
                        case 0:
                        default:
                            return "EDITOR_TYPE_UNSPECIFIED";
                        case EditorType.SCRIPT:
                        case 1:
                            return "EDITOR_TYPE_SCRIPT";
                        case EditorType.NOTEBOOK:
                        case 2:
                            return "EDITOR_TYPE_NOTEBOOK";
                    }
                }
            };
            var KernelAccessType;
            (function(KernelAccessType) {
                KernelAccessType["ADMINISTRATIVE"] = "administrative";
                KernelAccessType["READ"] = "read";
                KernelAccessType["WRITE"] = "write";
                KernelAccessType["COMMENT"] = "comment";
            })(KernelAccessType = Kernels.KernelAccessType || (Kernels.KernelAccessType = {}));
            var KernelsListSortType;
            (function(KernelsListSortType) {
                KernelsListSortType["HOTNESS"] = "hotness";
                KernelsListSortType["COMMENT_COUNT"] = "commentCount";
                KernelsListSortType["DATE_CREATED"] = "dateCreated";
                KernelsListSortType["DATE_RUN"] = "dateRun";
                KernelsListSortType["RELEVANCE"] = "relevance";
                KernelsListSortType["SCORE_ASCENDING"] = "scoreAscending";
                KernelsListSortType["SCORE_DESCENDING"] = "scoreDescending";
                KernelsListSortType["VIEW_COUNT"] = "viewCount";
                KernelsListSortType["VOTE_COUNT"] = "voteCount";
            })(KernelsListSortType = Kernels.KernelsListSortType || (Kernels.KernelsListSortType = {}));
            var KernelsListSortTypeWireFormat3 = Kernels.KernelsListSortTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "HOTNESS":
                        default:
                            return KernelsListSortType.HOTNESS;
                        case "COMMENT_COUNT":
                            return KernelsListSortType.COMMENT_COUNT;
                        case "DATE_CREATED":
                            return KernelsListSortType.DATE_CREATED;
                        case "DATE_RUN":
                            return KernelsListSortType.DATE_RUN;
                        case "RELEVANCE":
                            return KernelsListSortType.RELEVANCE;
                        case "SCORE_ASCENDING":
                            return KernelsListSortType.SCORE_ASCENDING;
                        case "SCORE_DESCENDING":
                            return KernelsListSortType.SCORE_DESCENDING;
                        case "VIEW_COUNT":
                            return KernelsListSortType.VIEW_COUNT;
                        case "VOTE_COUNT":
                            return KernelsListSortType.VOTE_COUNT;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case KernelsListSortType.HOTNESS:
                        case 0:
                        default:
                            return "HOTNESS";
                        case KernelsListSortType.COMMENT_COUNT:
                        case 1:
                            return "COMMENT_COUNT";
                        case KernelsListSortType.DATE_CREATED:
                        case 2:
                            return "DATE_CREATED";
                        case KernelsListSortType.DATE_RUN:
                        case 3:
                            return "DATE_RUN";
                        case KernelsListSortType.RELEVANCE:
                        case 4:
                            return "RELEVANCE";
                        case KernelsListSortType.SCORE_ASCENDING:
                        case 5:
                            return "SCORE_ASCENDING";
                        case KernelsListSortType.SCORE_DESCENDING:
                        case 6:
                            return "SCORE_DESCENDING";
                        case KernelsListSortType.VIEW_COUNT:
                        case 7:
                            return "VIEW_COUNT";
                        case KernelsListSortType.VOTE_COUNT:
                        case 8:
                            return "VOTE_COUNT";
                    }
                }
            };
            var KernelsListViewType;
            (function(KernelsListViewType) {
                KernelsListViewType["UNSPECIFIED"] = "unspecified";
                KernelsListViewType["PROFILE"] = "profile";
                KernelsListViewType["UPVOTED"] = "upvoted";
                KernelsListViewType["EVERYONE"] = "everyone";
                KernelsListViewType["COLLABORATION"] = "collaboration";
                KernelsListViewType["FORK"] = "fork";
                KernelsListViewType["BOOKMARKED"] = "bookmarked";
                KernelsListViewType["RECENTLY_VIEWED"] = "recentlyViewed";
            })(KernelsListViewType = Kernels.KernelsListViewType || (Kernels.KernelsListViewType = {}));
            var KernelsListViewTypeWireFormat3 = Kernels.KernelsListViewTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "KERNELS_LIST_VIEW_TYPE_UNSPECIFIED":
                        default:
                            return KernelsListViewType.UNSPECIFIED;
                        case "PROFILE":
                            return KernelsListViewType.PROFILE;
                        case "UPVOTED":
                            return KernelsListViewType.UPVOTED;
                        case "EVERYONE":
                            return KernelsListViewType.EVERYONE;
                        case "COLLABORATION":
                            return KernelsListViewType.COLLABORATION;
                        case "FORK":
                            return KernelsListViewType.FORK;
                        case "BOOKMARKED":
                            return KernelsListViewType.BOOKMARKED;
                        case "RECENTLY_VIEWED":
                            return KernelsListViewType.RECENTLY_VIEWED;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case KernelsListViewType.UNSPECIFIED:
                        case 0:
                        default:
                            return "KERNELS_LIST_VIEW_TYPE_UNSPECIFIED";
                        case KernelsListViewType.PROFILE:
                        case 1:
                            return "PROFILE";
                        case KernelsListViewType.UPVOTED:
                        case 2:
                            return "UPVOTED";
                        case KernelsListViewType.EVERYONE:
                        case 3:
                            return "EVERYONE";
                        case KernelsListViewType.COLLABORATION:
                        case 4:
                            return "COLLABORATION";
                        case KernelsListViewType.FORK:
                        case 5:
                            return "FORK";
                        case KernelsListViewType.BOOKMARKED:
                        case 6:
                            return "BOOKMARKED";
                        case KernelsListViewType.RECENTLY_VIEWED:
                        case 7:
                            return "RECENTLY_VIEWED";
                    }
                }
            };
            var KernelVersionPinningType;
            (function(KernelVersionPinningType) {
                KernelVersionPinningType["UNPINNED"] = "unpinned";
                KernelVersionPinningType["PINNED"] = "pinned";
            })(KernelVersionPinningType = Kernels.KernelVersionPinningType || (Kernels.KernelVersionPinningType = {}));
            var KernelVersionPinningTypeWireFormat3 = Kernels.KernelVersionPinningTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "UNPINNED":
                        default:
                            return KernelVersionPinningType.UNPINNED;
                        case "PINNED":
                            return KernelVersionPinningType.PINNED;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case KernelVersionPinningType.UNPINNED:
                        case 0:
                        default:
                            return "UNPINNED";
                        case KernelVersionPinningType.PINNED:
                        case 1:
                            return "PINNED";
                    }
                }
            };
            var KernelVersionType;
            (function(KernelVersionType) {
                KernelVersionType["UNSPECIFIED"] = "unspecified";
                KernelVersionType["BATCH"] = "batch";
                KernelVersionType["INTERACTIVE"] = "interactive";
                KernelVersionType["QUICK"] = "quick";
            })(KernelVersionType = Kernels.KernelVersionType || (Kernels.KernelVersionType = {}));
            var KernelVersionTypeWireFormat3 = Kernels.KernelVersionTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "KERNEL_VERSION_TYPE_UNSPECIFIED":
                        default:
                            return KernelVersionType.UNSPECIFIED;
                        case "BATCH":
                            return KernelVersionType.BATCH;
                        case "INTERACTIVE":
                            return KernelVersionType.INTERACTIVE;
                        case "QUICK":
                            return KernelVersionType.QUICK;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case KernelVersionType.UNSPECIFIED:
                        case 0:
                        default:
                            return "KERNEL_VERSION_TYPE_UNSPECIFIED";
                        case KernelVersionType.BATCH:
                        case 1:
                            return "BATCH";
                        case KernelVersionType.INTERACTIVE:
                        case 2:
                            return "INTERACTIVE";
                        case KernelVersionType.QUICK:
                        case 3:
                            return "QUICK";
                    }
                }
            };
            var KernelWorkerStatus;
            (function(KernelWorkerStatus) {
                KernelWorkerStatus["QUEUED"] = "queued";
                KernelWorkerStatus["RUNNING"] = "running";
                KernelWorkerStatus["COMPLETE"] = "complete";
                KernelWorkerStatus["ERROR"] = "error";
                KernelWorkerStatus["CANCEL_REQUESTED"] = "cancelRequested";
                KernelWorkerStatus["CANCEL_ACKNOWLEDGED"] = "cancelAcknowledged";
                KernelWorkerStatus["NEW_SCRIPT"] = "newScript";
            })(KernelWorkerStatus = Kernels.KernelWorkerStatus || (Kernels.KernelWorkerStatus = {}));
            var KernelWorkerStatusWireFormat3 = Kernels.KernelWorkerStatusWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "QUEUED":
                        default:
                            return KernelWorkerStatus.QUEUED;
                        case "RUNNING":
                            return KernelWorkerStatus.RUNNING;
                        case "COMPLETE":
                            return KernelWorkerStatus.COMPLETE;
                        case "ERROR":
                            return KernelWorkerStatus.ERROR;
                        case "CANCEL_REQUESTED":
                            return KernelWorkerStatus.CANCEL_REQUESTED;
                        case "CANCEL_ACKNOWLEDGED":
                            return KernelWorkerStatus.CANCEL_ACKNOWLEDGED;
                        case "NEW_SCRIPT":
                            return KernelWorkerStatus.NEW_SCRIPT;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case KernelWorkerStatus.QUEUED:
                        case 0:
                        default:
                            return "QUEUED";
                        case KernelWorkerStatus.RUNNING:
                        case 1:
                            return "RUNNING";
                        case KernelWorkerStatus.COMPLETE:
                        case 2:
                            return "COMPLETE";
                        case KernelWorkerStatus.ERROR:
                        case 3:
                            return "ERROR";
                        case KernelWorkerStatus.CANCEL_REQUESTED:
                        case 4:
                            return "CANCEL_REQUESTED";
                        case KernelWorkerStatus.CANCEL_ACKNOWLEDGED:
                        case 5:
                            return "CANCEL_ACKNOWLEDGED";
                        case KernelWorkerStatus.NEW_SCRIPT:
                        case 6:
                            return "NEW_SCRIPT";
                    }
                }
            };
            var Language;
            (function(Language) {
                Language["UNSPECIFIED"] = "unspecified";
                Language["PYTHON"] = "python";
                Language["R"] = "r";
                Language["RMARKDOWN"] = "rmarkdown";
                Language["JULIA"] = "julia";
                Language["SQLITE"] = "sqlite";
            })(Language = Kernels.Language || (Kernels.Language = {}));
            var LanguageWireFormat3 = Kernels.LanguageWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "LANGUAGE_UNSPECIFIED":
                        default:
                            return Language.UNSPECIFIED;
                        case "LANGUAGE_PYTHON":
                            return Language.PYTHON;
                        case "LANGUAGE_R":
                            return Language.R;
                        case "LANGUAGE_RMARKDOWN":
                            return Language.RMARKDOWN;
                        case "LANGUAGE_JULIA":
                            return Language.JULIA;
                        case "LANGUAGE_SQLITE":
                            return Language.SQLITE;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case Language.UNSPECIFIED:
                        case 0:
                        default:
                            return "LANGUAGE_UNSPECIFIED";
                        case Language.PYTHON:
                        case 1:
                            return "LANGUAGE_PYTHON";
                        case Language.R:
                        case 2:
                            return "LANGUAGE_R";
                        case Language.RMARKDOWN:
                        case 3:
                            return "LANGUAGE_RMARKDOWN";
                        case Language.JULIA:
                        case 4:
                            return "LANGUAGE_JULIA";
                        case Language.SQLITE:
                        case 5:
                            return "LANGUAGE_SQLITE";
                    }
                }
            };
            var LegacyDataSourceType;
            (function(LegacyDataSourceType) {
                LegacyDataSourceType["DATASET"] = "dataset";
                LegacyDataSourceType["COMPETITION"] = "competition";
                LegacyDataSourceType["KERNEL"] = "kernel";
            })(LegacyDataSourceType = Kernels.LegacyDataSourceType || (Kernels.LegacyDataSourceType = {}));
            var ScheduleFrequencyType;
            (function(ScheduleFrequencyType) {
                ScheduleFrequencyType["SCHEDULE_FREQUENCY_UNSPECIFIED"] = "scheduleFrequencyUnspecified";
                ScheduleFrequencyType["DAILY"] = "daily";
                ScheduleFrequencyType["WEEKLY"] = "weekly";
                ScheduleFrequencyType["MONTHLY"] = "monthly";
            })(ScheduleFrequencyType = Kernels.ScheduleFrequencyType || (Kernels.ScheduleFrequencyType = {}));
            var ScheduleFrequencyTypeWireFormat3 = Kernels.ScheduleFrequencyTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "SCHEDULE_FREQUENCY_UNSPECIFIED":
                        default:
                            return ScheduleFrequencyType.SCHEDULE_FREQUENCY_UNSPECIFIED;
                        case "DAILY":
                            return ScheduleFrequencyType.DAILY;
                        case "WEEKLY":
                            return ScheduleFrequencyType.WEEKLY;
                        case "MONTHLY":
                            return ScheduleFrequencyType.MONTHLY;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case ScheduleFrequencyType.SCHEDULE_FREQUENCY_UNSPECIFIED:
                        case 0:
                        default:
                            return "SCHEDULE_FREQUENCY_UNSPECIFIED";
                        case ScheduleFrequencyType.DAILY:
                        case 1:
                            return "DAILY";
                        case ScheduleFrequencyType.WEEKLY:
                        case 2:
                            return "WEEKLY";
                        case ScheduleFrequencyType.MONTHLY:
                        case 3:
                            return "MONTHLY";
                    }
                }
            };
            var ScheduleTriggerType;
            (function(ScheduleTriggerType) {
                ScheduleTriggerType["UNSPECIFIED"] = "unspecified";
                ScheduleTriggerType["SCHEDULED_TIME"] = "scheduledTime";
                ScheduleTriggerType["DATASOURCE_UPDATE"] = "datasourceUpdate";
            })(ScheduleTriggerType = Kernels.ScheduleTriggerType || (Kernels.ScheduleTriggerType = {}));
            var ScheduleTriggerTypeWireFormat3 = Kernels.ScheduleTriggerTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "SCHEDULE_TRIGGER_TYPE_UNSPECIFIED":
                        default:
                            return ScheduleTriggerType.UNSPECIFIED;
                        case "SCHEDULED_TIME":
                            return ScheduleTriggerType.SCHEDULED_TIME;
                        case "DATASOURCE_UPDATE":
                            return ScheduleTriggerType.DATASOURCE_UPDATE;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case ScheduleTriggerType.UNSPECIFIED:
                        case 0:
                        default:
                            return "SCHEDULE_TRIGGER_TYPE_UNSPECIFIED";
                        case ScheduleTriggerType.SCHEDULED_TIME:
                        case 1:
                            return "SCHEDULED_TIME";
                        case ScheduleTriggerType.DATASOURCE_UPDATE:
                        case 2:
                            return "DATASOURCE_UPDATE";
                    }
                }
            };
            var StreamName;
            (function(StreamName) {
                StreamName["STDOUT"] = "stdout";
                StreamName["STDERR"] = "stderr";
            })(StreamName = Kernels.StreamName || (Kernels.StreamName = {}));
            var StreamNameWireFormat3 = Kernels.StreamNameWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "STREAM_NAME_STDOUT":
                        default:
                            return StreamName.STDOUT;
                        case "STREAM_NAME_STDERR":
                            return StreamName.STDERR;
                    }
                }
            };
        })(Kernels1 = Sdk.Kernels || (Sdk.Kernels = {}));
        var Search1;
        (function(Search) {
            var Protos2;
            (function(Protos) {
                var defaultCategoryFilter = {
                    count: 0
                };
                var CategoryFilterWireFormat3 = Protos.CategoryFilterWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultCategoryFilter, wireFormat);
                        if (wireFormat) {
                            message.name = Kaggle.Sdk.Search.Protos.DocumentTypeWireFormat3.fromJson(wireFormat.name);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.count) {
                            message.count = parseInt(wireFormat.count);
                        }
                        return message;
                    }
                };
                var defaultCommentItemInfo = {
                    forumName: "",
                    forumType: "",
                    matchingText: ""
                };
                var CommentItemInfoWireFormat3 = Protos.CommentItemInfoWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultCommentItemInfo, wireFormat);
                        return message;
                    }
                };
                var defaultCompetitionItemInfo = {
                    teamsCount: 0,
                    prizeValue: 0,
                    hasEntered: false,
                    isKernelsOnly: false
                };
                var CompetitionItemInfoWireFormat3 = Protos.CompetitionItemInfoWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultCompetitionItemInfo, wireFormat);
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.deadlineDate) {
                            message.deadlineDate = new Date(wireFormat.deadlineDate);
                        }
                        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.prizeValue) != undefined) {
                            message.prizeValue = Number(wireFormat.prizeValue);
                        }
                        if (wireFormat) {
                            message.type = KaggleSdkCompetitionsHostSegmentWireFormat3.fromJson(wireFormat.type);
                        }
                        return message;
                    }
                };
                var defaultDatasetItemInfo = {
                    size: 0,
                    fileTypes: [],
                    kernelsCount: 0,
                    filesCount: 0,
                    maintainedByKaggle: false,
                    currentDatasetVersionId: 0
                };
                var DatasetItemInfoWireFormat3 = Protos.DatasetItemInfoWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultDatasetItemInfo, wireFormat);
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.size) {
                            message.size = parseInt(wireFormat.size);
                        }
                        return message;
                    }
                };
                var defaultFilterOption = {
                    name: "",
                    count: 0
                };
                var FilterOptionWireFormat3 = Protos.FilterOptionWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultFilterOption, wireFormat);
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.count) {
                            message.count = parseInt(wireFormat.count);
                        }
                        return message;
                    }
                };
                var defaultFullSearchResponse = {
                    documents: [],
                    count: 0,
                    filters: [],
                    categories: []
                };
                var FullSearchResponseWireFormat3 = Protos.FullSearchResponseWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultFullSearchResponse, wireFormat);
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.documents) {
                            message.documents = wireFormat.documents.map(function(i) {
                                return Kaggle.Sdk.Search.Protos.SearchItemWireFormat3.fromJson(i);
                            });
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.count) {
                            message.count = parseInt(wireFormat.count);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.filters) {
                            message.filters = wireFormat.filters.map(function(i) {
                                return Kaggle.Sdk.Search.Protos.SearchFilterWireFormat3.fromJson(i);
                            });
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
                            message.categories = wireFormat.categories.map(function(i) {
                                return Kaggle.Sdk.Search.Protos.CategoryFilterWireFormat3.fromJson(i);
                            });
                        }
                        return message;
                    }
                };
                var FullSearchWebRequestWireFormat3 = Protos.FullSearchWebRequestWireFormat3 = {
                    toJson: function toJson(message) {
                        return message;
                    }
                };
                var GetAutoCompleteSuggestionsRequestWireFormat3 = Protos.GetAutoCompleteSuggestionsRequestWireFormat3 = {
                    toJson: function toJson(message) {
                        return message;
                    }
                };
                var defaultGetAutoCompleteSuggestionsResponse = {
                    autoCompleteSuggestions: []
                };
                var GetAutoCompleteSuggestionsResponseWireFormat3 = Protos.GetAutoCompleteSuggestionsResponseWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultGetAutoCompleteSuggestionsResponse, wireFormat);
                        return message;
                    }
                };
                var GetPopularTagsRequestWireFormat3 = Protos.GetPopularTagsRequestWireFormat3 = {
                    toJson: function toJson(message) {
                        return message;
                    }
                };
                var defaultGetPopularTagsResponse = {
                    popularTags: []
                };
                var GetPopularTagsResponseWireFormat3 = Protos.GetPopularTagsResponseWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultGetPopularTagsResponse, wireFormat);
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.popularTags) {
                            message.popularTags = wireFormat.popularTags.map(function(i) {
                                return Kaggle.Sdk.Search.Protos.FilterOptionWireFormat3.fromJson(i);
                            });
                        }
                        return message;
                    }
                };
                var GetRecentSearchesRequestWireFormat3 = Protos.GetRecentSearchesRequestWireFormat3 = {
                    toJson: function toJson(message) {
                        var wireFormat = _objectSpread({}, message);
                        if (message === null || message === void 0 ? void 0 : message.specificSearchIndices) {
                            wireFormat.specificSearchIndices = message.specificSearchIndices.map(function(i) {
                                return Kaggle.Sdk.Search.Protos.SearchIndexWireFormat3.toJson(i);
                            });
                        }
                        return wireFormat;
                    }
                };
                var defaultGetRecentSearchesResponse = {
                    recentSearches: []
                };
                var GetRecentSearchesResponseWireFormat3 = Protos.GetRecentSearchesResponseWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultGetRecentSearchesResponse, wireFormat);
                        return message;
                    }
                };
                var GetTrendingSearchesRequestWireFormat3 = Protos.GetTrendingSearchesRequestWireFormat3 = {
                    toJson: function toJson(message) {
                        return message;
                    }
                };
                var defaultGetTrendingSearchesResponse = {
                    trendingSearches: []
                };
                var GetTrendingSearchesResponseWireFormat3 = Protos.GetTrendingSearchesResponseWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultGetTrendingSearchesResponse, wireFormat);
                        return message;
                    }
                };
                var defaultIndexSnippetResponse = {
                    indexCreateResponse: "",
                    createdIndex: "",
                    bulkIndexResponse: "",
                    indexedCount: 0,
                    deleteIndexResponse: "",
                    deletedIndex: "",
                    aliasResponse: ""
                };
                var IndexSnippetResponseWireFormat3 = Protos.IndexSnippetResponseWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultIndexSnippetResponse, wireFormat);
                        return message;
                    }
                };
                var defaultKernelItemInfo = {
                    languageGroup: "",
                    secondsToRun: 0,
                    dataSource: "",
                    forksCount: 0,
                    kernelSessionId: 0,
                    hasDataOutputFiles: false,
                    isUtilityScript: false
                };
                var KernelItemInfoWireFormat3 = Protos.KernelItemInfoWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultKernelItemInfo, wireFormat);
                        return message;
                    }
                };
                var LogSearchRequestWireFormat3 = Protos.LogSearchRequestWireFormat3 = {
                    toJson: function toJson(message) {
                        var wireFormat = _objectSpread({}, message);
                        if ((message === null || message === void 0 ? void 0 : message.secondsSpentSearching) != undefined && (message === null || message === void 0 ? void 0 : message.secondsSpentSearching) != 0) {
                            wireFormat.secondsSpentSearching = Number.isFinite(message.secondsSpentSearching) ? message.secondsSpentSearching : Number(message.secondsSpentSearching).toString();
                        }
                        return wireFormat;
                    }
                };
                var defaultOrganizationItemInfo = {
                    location: "",
                    datasetCount: 0,
                    competitionCount: 0,
                    memberCount: 0
                };
                var OrganizationItemInfoWireFormat3 = Protos.OrganizationItemInfoWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultOrganizationItemInfo, wireFormat);
                        return message;
                    }
                };
                var defaultSearchFilter = {
                    options: [],
                    categories: []
                };
                var SearchFilterWireFormat3 = Protos.SearchFilterWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultSearchFilter, wireFormat);
                        if (wireFormat) {
                            message.name = Kaggle.Sdk.Search.Protos.FilterNameWireFormat3.fromJson(wireFormat.name);
                        }
                        if (wireFormat) {
                            message.type = Kaggle.Sdk.Search.Protos.FilterTypeWireFormat3.fromJson(wireFormat.type);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.options) {
                            message.options = wireFormat.options.map(function(i) {
                                return Kaggle.Sdk.Search.Protos.FilterOptionWireFormat3.fromJson(i);
                            });
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
                            message.categories = wireFormat.categories.map(function(i) {
                                return Kaggle.Sdk.Search.Protos.DocumentTypeWireFormat3.fromJson(i);
                            });
                        }
                        return message;
                    }
                };
                var defaultSearchItem = {
                    id: "",
                    databaseId: 0,
                    title: "",
                    url: "",
                    thumbnailImageUrl: "",
                    rank: 0,
                    score: 0,
                    isPrivate: false,
                    votes: 0,
                    authorSlug: "",
                    authorDisplayName: "",
                    matchedText: "",
                    isCreatedByCurrentUser: false
                };
                var SearchItemWireFormat3 = Protos.SearchItemWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultSearchItem, wireFormat);
                        if (wireFormat) {
                            message.documentType = Kaggle.Sdk.Search.Protos.DocumentTypeWireFormat3.fromJson(wireFormat.documentType);
                        }
                        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.score) != undefined) {
                            message.score = Number(wireFormat.score);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
                            message.date = new Date(wireFormat.date);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.commentInfo) {
                            message.commentInfo = Kaggle.Sdk.Search.Protos.CommentItemInfoWireFormat3.fromJson(wireFormat.commentInfo);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionInfo) {
                            message.competitionInfo = Kaggle.Sdk.Search.Protos.CompetitionItemInfoWireFormat3.fromJson(wireFormat.competitionInfo);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetInfo) {
                            message.datasetInfo = Kaggle.Sdk.Search.Protos.DatasetItemInfoWireFormat3.fromJson(wireFormat.datasetInfo);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelInfo) {
                            message.kernelInfo = Kaggle.Sdk.Search.Protos.KernelItemInfoWireFormat3.fromJson(wireFormat.kernelInfo);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topicInfo) {
                            message.topicInfo = Kaggle.Sdk.Search.Protos.TopicItemInfoWireFormat3.fromJson(wireFormat.topicInfo);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userInfo) {
                            message.userInfo = Kaggle.Sdk.Search.Protos.UserItemInfoWireFormat3.fromJson(wireFormat.userInfo);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.organizationInfo) {
                            message.organizationInfo = Kaggle.Sdk.Search.Protos.OrganizationItemInfoWireFormat3.fromJson(wireFormat.organizationInfo);
                        }
                        return message;
                    }
                };
                var defaultSearchResultGroup = {
                    documents: [],
                    count: 0
                };
                var SearchResultGroupWireFormat3 = Protos.SearchResultGroupWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultSearchResultGroup, wireFormat);
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.documents) {
                            message.documents = wireFormat.documents.map(function(i) {
                                return Kaggle.Sdk.Search.Protos.SearchItemWireFormat3.fromJson(i);
                            });
                        }
                        if (wireFormat) {
                            message.type = Kaggle.Sdk.Search.Protos.DocumentTypeWireFormat3.fromJson(wireFormat.type);
                        }
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.count) {
                            message.count = parseInt(wireFormat.count);
                        }
                        return message;
                    }
                };
                var defaultSuggestedSearchResponse = {
                    groups: []
                };
                var SuggestedSearchResponseWireFormat3 = Protos.SuggestedSearchResponseWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultSuggestedSearchResponse, wireFormat);
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.groups) {
                            message.groups = wireFormat.groups.map(function(i) {
                                return Kaggle.Sdk.Search.Protos.SearchResultGroupWireFormat3.fromJson(i);
                            });
                        }
                        return message;
                    }
                };
                var SuggestedSearchWebRequestWireFormat3 = Protos.SuggestedSearchWebRequestWireFormat3 = {
                    toJson: function toJson(message) {
                        return message;
                    }
                };
                var TimeSpentOnClickedResultRequestWireFormat3 = Protos.TimeSpentOnClickedResultRequestWireFormat3 = {
                    toJson: function toJson(message) {
                        return message;
                    }
                };
                var defaultTopicItemInfo = {
                    forumName: "",
                    forumType: "",
                    matchingText: ""
                };
                var TopicItemInfoWireFormat3 = Protos.TopicItemInfoWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultTopicItemInfo, wireFormat);
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationDate) {
                            message.creationDate = new Date(wireFormat.creationDate);
                        }
                        return message;
                    }
                };
                var defaultUserItemInfo = {
                    kernelsCount: 0,
                    topicsCount: 0,
                    description: "",
                    location: ""
                };
                var UserItemInfoWireFormat3 = Protos.UserItemInfoWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        var message = _objectSpread({}, defaultUserItemInfo, wireFormat);
                        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastSeenDate) {
                            message.lastSeenDate = new Date(wireFormat.lastSeenDate);
                        }
                        if (wireFormat) {
                            message.performanceTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.performanceTier);
                        }
                        return message;
                    }
                };
                var DocumentType;
                (function(DocumentType) {
                    DocumentType["UNSPECIFIED"] = "unspecified";
                    DocumentType["BLOG"] = "blog";
                    DocumentType["COMPETITION"] = "competition";
                    DocumentType["DATASET"] = "dataset";
                    DocumentType["KERNEL"] = "kernel";
                    DocumentType["COMMENT"] = "comment";
                    DocumentType["ORGANIZATION"] = "organization";
                    DocumentType["TOPIC"] = "topic";
                    DocumentType["USER"] = "user";
                    DocumentType["COURSE"] = "course";
                    DocumentType["TUTORIAL"] = "tutorial";
                })(DocumentType = Protos.DocumentType || (Protos.DocumentType = {}));
                var DocumentTypeWireFormat3 = Protos.DocumentTypeWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        switch(wireFormat){
                            case "DOCUMENT_TYPE_UNSPECIFIED":
                            default:
                                return DocumentType.UNSPECIFIED;
                            case "BLOG":
                                return DocumentType.BLOG;
                            case "COMPETITION":
                                return DocumentType.COMPETITION;
                            case "DATASET":
                                return DocumentType.DATASET;
                            case "KERNEL":
                                return DocumentType.KERNEL;
                            case "COMMENT":
                                return DocumentType.COMMENT;
                            case "ORGANIZATION":
                                return DocumentType.ORGANIZATION;
                            case "TOPIC":
                                return DocumentType.TOPIC;
                            case "USER":
                                return DocumentType.USER;
                            case "COURSE":
                                return DocumentType.COURSE;
                            case "TUTORIAL":
                                return DocumentType.TUTORIAL;
                        }
                    }
                };
                var FilterName;
                (function(FilterName) {
                    FilterName["DATE"] = "date";
                    FilterName["IN"] = "in";
                    FilterName["BY"] = "by";
                    FilterName["TAGS"] = "tags";
                    FilterName["OWNER"] = "owner";
                    FilterName["SORT_BY"] = "sortBy";
                    FilterName["COMPETITION_EVALUATION_ALGORITHM"] = "competitionEvaluationAlgorithm";
                    FilterName["DATASET_LICENSE"] = "datasetLicense";
                    FilterName["DATASET_SIZE"] = "datasetSize";
                    FilterName["DATASET_SIZE_GROUP"] = "datasetSizeGroup";
                    FilterName["DATASET_FILE_TYPES"] = "datasetFileTypes";
                    FilterName["NOTEBOOK_LANGUAGE"] = "notebookLanguage";
                    FilterName["VIEWED_BY_YOU"] = "viewedByYou";
                })(FilterName = Protos.FilterName || (Protos.FilterName = {}));
                var FilterNameWireFormat3 = Protos.FilterNameWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        switch(wireFormat){
                            case "DATE":
                            default:
                                return FilterName.DATE;
                            case "IN":
                                return FilterName.IN;
                            case "BY":
                                return FilterName.BY;
                            case "TAGS":
                                return FilterName.TAGS;
                            case "OWNER":
                                return FilterName.OWNER;
                            case "SORT_BY":
                                return FilterName.SORT_BY;
                            case "COMPETITION_EVALUATION_ALGORITHM":
                                return FilterName.COMPETITION_EVALUATION_ALGORITHM;
                            case "DATASET_LICENSE":
                                return FilterName.DATASET_LICENSE;
                            case "DATASET_SIZE":
                                return FilterName.DATASET_SIZE;
                            case "DATASET_SIZE_GROUP":
                                return FilterName.DATASET_SIZE_GROUP;
                            case "DATASET_FILE_TYPES":
                                return FilterName.DATASET_FILE_TYPES;
                            case "NOTEBOOK_LANGUAGE":
                                return FilterName.NOTEBOOK_LANGUAGE;
                            case "VIEWED_BY_YOU":
                                return FilterName.VIEWED_BY_YOU;
                        }
                    }
                };
                var FilterType;
                (function(FilterType) {
                    FilterType["RADIO"] = "radio";
                    FilterType["CHECKBOX"] = "checkbox";
                    FilterType["TEXT"] = "text";
                })(FilterType = Protos.FilterType || (Protos.FilterType = {}));
                var FilterTypeWireFormat3 = Protos.FilterTypeWireFormat3 = {
                    fromJson: function fromJson(wireFormat) {
                        switch(wireFormat){
                            case "RADIO":
                            default:
                                return FilterType.RADIO;
                            case "CHECKBOX":
                                return FilterType.CHECKBOX;
                            case "TEXT":
                                return FilterType.TEXT;
                        }
                    }
                };
                var SearchIndex;
                (function(SearchIndex) {
                    SearchIndex["UNSPECIFIED"] = "unspecified";
                    SearchIndex["COMPETITIONS"] = "competitions";
                    SearchIndex["DATASETS"] = "datasets";
                    SearchIndex["GLOBAL"] = "global";
                    SearchIndex["KERNELS"] = "kernels";
                    SearchIndex["TOPICS"] = "topics";
                })(SearchIndex = Protos.SearchIndex || (Protos.SearchIndex = {}));
                var SearchIndexWireFormat3 = Protos.SearchIndexWireFormat3 = {
                    toJson: function toJson(enumVal) {
                        switch(enumVal){
                            case SearchIndex.UNSPECIFIED:
                            case 0:
                            default:
                                return "SEARCH_INDEX_UNSPECIFIED";
                            case SearchIndex.COMPETITIONS:
                            case 1:
                                return "COMPETITIONS";
                            case SearchIndex.DATASETS:
                            case 2:
                                return "DATASETS";
                            case SearchIndex.GLOBAL:
                            case 3:
                                return "GLOBAL";
                            case SearchIndex.KERNELS:
                            case 5:
                                return "KERNELS";
                            case SearchIndex.TOPICS:
                            case 6:
                                return "TOPICS";
                        }
                    }
                };
            })(Protos2 = Search.Protos || (Search.Protos = {}));
        })(Search1 = Sdk.Search || (Sdk.Search = {}));
        var Security1;
        (function(Security) {
            var DataAccessReasonWireFormat3 = Security.DataAccessReasonWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
        })(Security1 = Sdk.Security || (Sdk.Security = {}));
        var Tags1;
        (function(Tags) {
            var CreateCompetitionTagsRequestWireFormat3 = Tags.CreateCompetitionTagsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultCreateCompetitionTagsResponse = {};
            var CreateCompetitionTagsResponseWireFormat3 = Tags.CreateCompetitionTagsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCreateCompetitionTagsResponse, wireFormat);
                    return message;
                }
            };
            var CreateLearnTrackTagsRequestWireFormat3 = Tags.CreateLearnTrackTagsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultCreateLearnTrackTagsResponse = {};
            var CreateLearnTrackTagsResponseWireFormat3 = Tags.CreateLearnTrackTagsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultCreateLearnTrackTagsResponse, wireFormat);
                    return message;
                }
            };
            var CreateTagRequestWireFormat3 = Tags.CreateTagRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var DeleteCompetitionTagsRequestWireFormat3 = Tags.DeleteCompetitionTagsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultDeleteCompetitionTagsResponse = {};
            var DeleteCompetitionTagsResponseWireFormat3 = Tags.DeleteCompetitionTagsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDeleteCompetitionTagsResponse, wireFormat);
                    return message;
                }
            };
            var DeleteLearnTrackTagsRequestWireFormat3 = Tags.DeleteLearnTrackTagsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultDeleteLearnTrackTagsResponse = {};
            var DeleteLearnTrackTagsResponseWireFormat3 = Tags.DeleteLearnTrackTagsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDeleteLearnTrackTagsResponse, wireFormat);
                    return message;
                }
            };
            var GetTagHierarchyRequestWireFormat3 = Tags.GetTagHierarchyRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetTagHierarchyResponse = {
                roots: []
            };
            var GetTagHierarchyResponseWireFormat3 = Tags.GetTagHierarchyResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetTagHierarchyResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.roots) {
                        message.roots = wireFormat.roots.map(function(i) {
                            return Kaggle.Sdk.Tags.TagNodeWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var GetTagsByIdRequestWireFormat3 = Tags.GetTagsByIdRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var ListTagsRequestWireFormat3 = Tags.ListTagsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultListTagsResponse = {
                featuredTags: [],
                hotTags: [],
                tagsCount: 0,
                pageSize: 0
            };
            var ListTagsResponseWireFormat3 = Tags.ListTagsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListTagsResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.featuredTags) {
                        message.featuredTags = wireFormat.featuredTags.map(function(i) {
                            return Kaggle.Sdk.Tags.TagWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.hotTags) {
                        message.hotTags = wireFormat.hotTags.map(function(i) {
                            return Kaggle.Sdk.Tags.TagWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var SearchTagsLegacyRequestWireFormat3 = Tags.SearchTagsLegacyRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultSearchTagsLegacyResponse = {
                tags: []
            };
            var SearchTagsLegacyResponseWireFormat3 = Tags.SearchTagsLegacyResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultSearchTagsLegacyResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
                        message.tags = wireFormat.tags.map(function(i) {
                            return Kaggle.Sdk.Tags.TagWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var SearchTagsRequestWireFormat3 = Tags.SearchTagsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.searchType) {
                        wireFormat.searchType = Kaggle.Sdk.Tags.TagTypeWireFormat3.toJson(message.searchType);
                    }
                    return wireFormat;
                }
            };
            var defaultTag = {
                id: 0,
                name: "",
                fullPath: "",
                listingUrl: "",
                datasetCount: 0,
                competitionCount: 0,
                notebookCount: 0,
                tagUrl: "",
                displayName: "",
                fontAwesomeIcon: ""
            };
            var TagWireFormat3 = Tags.TagWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultTag, wireFormat);
                    return message;
                }
            };
            var defaultTagList = {
                tags: []
            };
            var TagListWireFormat3 = Tags.TagListWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultTagList, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
                        message.tags = wireFormat.tags.map(function(i) {
                            return Kaggle.Sdk.Tags.TagWireFormat3.fromJson(i);
                        });
                    }
                    if (wireFormat) {
                        message.type = Kaggle.Sdk.Tags.TagTypeWireFormat3.fromJson(wireFormat.type);
                    }
                    return message;
                }
            };
            var defaultTagNode = {
                children: []
            };
            var TagNodeWireFormat3 = Tags.TagNodeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultTagNode, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tag) {
                        message.tag = Kaggle.Sdk.Tags.TagWireFormat3.fromJson(wireFormat.tag);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
                        message.children = wireFormat.children.map(function(i) {
                            return Kaggle.Sdk.Tags.TagNodeWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var UpdateForumTopicTagsRequestWireFormat3 = Tags.UpdateForumTopicTagsRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultUpdateForumTopicTagsResponse = {};
            var UpdateForumTopicTagsResponseWireFormat3 = Tags.UpdateForumTopicTagsResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUpdateForumTopicTagsResponse, wireFormat);
                    return message;
                }
            };
            var TagType;
            (function(TagType) {
                TagType["UNSPECIFIED"] = "unspecified";
                TagType["SEARCH_RESULT"] = "searchResult";
                TagType["DATASET"] = "dataset";
                TagType["COMPETITION"] = "competition";
                TagType["NOTEBOOK"] = "notebook";
                TagType["TASK"] = "task";
            })(TagType = Tags.TagType || (Tags.TagType = {}));
            var TagTypeWireFormat3 = Tags.TagTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "TAG_TYPE_UNSPECIFIED":
                        default:
                            return TagType.UNSPECIFIED;
                        case "TAG_TYPE_SEARCH_RESULT":
                            return TagType.SEARCH_RESULT;
                        case "TAG_TYPE_DATASET":
                            return TagType.DATASET;
                        case "TAG_TYPE_COMPETITION":
                            return TagType.COMPETITION;
                        case "TAG_TYPE_NOTEBOOK":
                            return TagType.NOTEBOOK;
                        case "TAG_TYPE_TASK":
                            return TagType.TASK;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case TagType.UNSPECIFIED:
                        case 0:
                        default:
                            return "TAG_TYPE_UNSPECIFIED";
                        case TagType.SEARCH_RESULT:
                        case 1:
                            return "TAG_TYPE_SEARCH_RESULT";
                        case TagType.DATASET:
                        case 2:
                            return "TAG_TYPE_DATASET";
                        case TagType.COMPETITION:
                        case 3:
                            return "TAG_TYPE_COMPETITION";
                        case TagType.NOTEBOOK:
                        case 4:
                            return "TAG_TYPE_NOTEBOOK";
                        case TagType.TASK:
                        case 5:
                            return "TAG_TYPE_TASK";
                    }
                }
            };
        })(Tags1 = Sdk.Tags || (Sdk.Tags = {}));
        var UserSecrets1;
        (function(UserSecrets) {
            var AddSecretKernelAttachmentRequestWireFormat3 = UserSecrets.AddSecretKernelAttachmentRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var DeleteSecretKernelAttachmentRequestWireFormat3 = UserSecrets.DeleteSecretKernelAttachmentRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var DeleteUserSecretRequestWireFormat3 = UserSecrets.DeleteUserSecretRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultDeleteUserSecretResponse = {
                wasAttached: false,
                secretId: 0
            };
            var DeleteUserSecretResponseWireFormat3 = UserSecrets.DeleteUserSecretResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultDeleteUserSecretResponse, wireFormat);
                    return message;
                }
            };
            var ExchangeGcloudAuthorizationCodeRequestWireFormat3 = UserSecrets.ExchangeGcloudAuthorizationCodeRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var GetGitHubAccessInfoRequestWireFormat3 = UserSecrets.GetGitHubAccessInfoRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetGitHubAccessInfoResponse = {
                secretId: 0
            };
            var GetGitHubAccessInfoResponseWireFormat3 = UserSecrets.GetGitHubAccessInfoResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetGitHubAccessInfoResponse, wireFormat);
                    return message;
                }
            };
            var GetUserSecretByLabelRequestWireFormat3 = UserSecrets.GetUserSecretByLabelRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultGetUserSecretResponse = {
                secretId: 0,
                expiresInSeconds: 0
            };
            var GetUserSecretResponseWireFormat3 = UserSecrets.GetUserSecretResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultGetUserSecretResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.expiresInSeconds) {
                        message.expiresInSeconds = parseInt(wireFormat.expiresInSeconds);
                    }
                    if (wireFormat) {
                        message.secretType = Kaggle.Sdk.UserSecrets.UserSecretTypeWireFormat3.fromJson(wireFormat.secretType);
                    }
                    if (wireFormat) {
                        message.secretProvider = Kaggle.Sdk.UserSecrets.UserSecretProviderTypeWireFormat3.fromJson(wireFormat.secretProvider);
                    }
                    return message;
                }
            };
            var ListKernelSecretsMetadataRequestWireFormat3 = UserSecrets.ListKernelSecretsMetadataRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultListKernelSecretsMetadataResponse = {
                kernelSecretsMetadata: []
            };
            var ListKernelSecretsMetadataResponseWireFormat3 = UserSecrets.ListKernelSecretsMetadataResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListKernelSecretsMetadataResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelSecretsMetadata) {
                        message.kernelSecretsMetadata = wireFormat.kernelSecretsMetadata.map(function(i) {
                            return Kaggle.Sdk.UserSecrets.UserSecretKernelAttachmentMetadataWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var ListKernelsWithSecretRequestWireFormat3 = UserSecrets.ListKernelsWithSecretRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultListKernelsWithSecretResponse = {
                kernelsWithSecret: []
            };
            var ListKernelsWithSecretResponseWireFormat3 = UserSecrets.ListKernelsWithSecretResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListKernelsWithSecretResponse, wireFormat);
                    return message;
                }
            };
            var ListUserSecretsMetadataRequestWireFormat3 = UserSecrets.ListUserSecretsMetadataRequestWireFormat3 = {
                toJson: function toJson(message) {
                    var wireFormat = _objectSpread({}, message);
                    if (message === null || message === void 0 ? void 0 : message.target) {
                        wireFormat.target = Kaggle.Sdk.UserSecrets.UserSecretTargetTypeWireFormat3.toJson(message.target);
                    }
                    if (message === null || message === void 0 ? void 0 : message.provider) {
                        wireFormat.provider = Kaggle.Sdk.UserSecrets.UserSecretProviderTypeWireFormat3.toJson(message.provider);
                    }
                    return wireFormat;
                }
            };
            var defaultListUserSecretsMetadataResponse = {
                userSecretsMetadata: []
            };
            var ListUserSecretsMetadataResponseWireFormat3 = UserSecrets.ListUserSecretsMetadataResponseWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultListUserSecretsMetadataResponse, wireFormat);
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userSecretsMetadata) {
                        message.userSecretsMetadata = wireFormat.userSecretsMetadata.map(function(i) {
                            return Kaggle.Sdk.UserSecrets.UserSecretMetadataWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var UpsertCustomUserSecretRequestWireFormat3 = UserSecrets.UpsertCustomUserSecretRequestWireFormat3 = {
                toJson: function toJson(message) {
                    return message;
                }
            };
            var defaultUserSecretKernelAttachmentMetadata = {
                attachmentId: 0,
                secretId: 0,
                secretTargets: []
            };
            var UserSecretKernelAttachmentMetadataWireFormat3 = UserSecrets.UserSecretKernelAttachmentMetadataWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUserSecretKernelAttachmentMetadata, wireFormat);
                    if (wireFormat) {
                        message.secretType = Kaggle.Sdk.UserSecrets.UserSecretTypeWireFormat3.fromJson(wireFormat.secretType);
                    }
                    if (wireFormat) {
                        message.secretProvider = Kaggle.Sdk.UserSecrets.UserSecretProviderTypeWireFormat3.fromJson(wireFormat.secretProvider);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.secretTargets) {
                        message.secretTargets = wireFormat.secretTargets.map(function(i) {
                            return Kaggle.Sdk.UserSecrets.UserSecretTargetTypeWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var defaultUserSecretMetadata = {
                secretId: 0,
                secretTargets: []
            };
            var UserSecretMetadataWireFormat3 = UserSecrets.UserSecretMetadataWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    var message = _objectSpread({}, defaultUserSecretMetadata, wireFormat);
                    if (wireFormat) {
                        message.secretType = Kaggle.Sdk.UserSecrets.UserSecretTypeWireFormat3.fromJson(wireFormat.secretType);
                    }
                    if (wireFormat) {
                        message.secretProvider = Kaggle.Sdk.UserSecrets.UserSecretProviderTypeWireFormat3.fromJson(wireFormat.secretProvider);
                    }
                    if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.secretTargets) {
                        message.secretTargets = wireFormat.secretTargets.map(function(i) {
                            return Kaggle.Sdk.UserSecrets.UserSecretTargetTypeWireFormat3.fromJson(i);
                        });
                    }
                    return message;
                }
            };
            var UserSecretProviderType;
            (function(UserSecretProviderType) {
                UserSecretProviderType["UNSPECIFIED"] = "unspecified";
                UserSecretProviderType["GOOGLE"] = "google";
                UserSecretProviderType["USER"] = "user";
                UserSecretProviderType["GITHUB"] = "github";
            })(UserSecretProviderType = UserSecrets.UserSecretProviderType || (UserSecrets.UserSecretProviderType = {}));
            var UserSecretProviderTypeWireFormat3 = UserSecrets.UserSecretProviderTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "USER_SECRET_PROVIDER_TYPE_UNSPECIFIED":
                        default:
                            return UserSecretProviderType.UNSPECIFIED;
                        case "GOOGLE":
                            return UserSecretProviderType.GOOGLE;
                        case "USER":
                            return UserSecretProviderType.USER;
                        case "GITHUB":
                            return UserSecretProviderType.GITHUB;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case UserSecretProviderType.UNSPECIFIED:
                        case 0:
                        default:
                            return "USER_SECRET_PROVIDER_TYPE_UNSPECIFIED";
                        case UserSecretProviderType.GOOGLE:
                        case 1:
                            return "GOOGLE";
                        case UserSecretProviderType.USER:
                        case 2:
                            return "USER";
                        case UserSecretProviderType.GITHUB:
                        case 3:
                            return "GITHUB";
                    }
                }
            };
            var UserSecretTargetType;
            (function(UserSecretTargetType) {
                UserSecretTargetType["UNSPECIFIED"] = "unspecified";
                UserSecretTargetType["BIGQUERY"] = "bigquery";
                UserSecretTargetType["GCS"] = "gcs";
                UserSecretTargetType["CLOUD_AI"] = "cloudAi";
                UserSecretTargetType[// Left AutoMl temporarily for transition (in this order)
                "AUTO_ML"] = "autoMl";
            })(UserSecretTargetType = UserSecrets.UserSecretTargetType || (UserSecrets.UserSecretTargetType = {}));
            var UserSecretTargetTypeWireFormat3 = UserSecrets.UserSecretTargetTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "USER_SECRET_TARGET_TYPE_UNSPECIFIED":
                        default:
                            return UserSecretTargetType.UNSPECIFIED;
                        case "BIGQUERY":
                            return UserSecretTargetType.BIGQUERY;
                        case "GCS":
                            return UserSecretTargetType.GCS;
                        case "CLOUD_AI":
                            return UserSecretTargetType.CLOUD_AI;
                        case "AUTO_ML":
                            return UserSecretTargetType.AUTO_ML;
                    }
                },
                toJson: function toJson(enumVal) {
                    switch(enumVal){
                        case UserSecretTargetType.UNSPECIFIED:
                        case 0:
                        default:
                            return "USER_SECRET_TARGET_TYPE_UNSPECIFIED";
                        case UserSecretTargetType.BIGQUERY:
                        case 1:
                            return "BIGQUERY";
                        case UserSecretTargetType.GCS:
                        case 2:
                            return "GCS";
                        case UserSecretTargetType.CLOUD_AI:
                        case 3:
                            return "CLOUD_AI";
                        case UserSecretTargetType.AUTO_ML:
                        case 4:
                            return "AUTO_ML";
                    }
                }
            };
            var UserSecretType;
            (function(UserSecretType) {
                UserSecretType["UNSPECIFIED"] = "unspecified";
                UserSecretType["REFRESH_TOKEN"] = "refreshToken";
                UserSecretType["CUSTOM"] = "custom";
                UserSecretType["ACCESS_TOKEN"] = "accessToken";
            })(UserSecretType = UserSecrets.UserSecretType || (UserSecrets.UserSecretType = {}));
            var UserSecretTypeWireFormat3 = UserSecrets.UserSecretTypeWireFormat3 = {
                fromJson: function fromJson(wireFormat) {
                    switch(wireFormat){
                        case "USER_SECRET_TYPE_UNSPECIFIED":
                        default:
                            return UserSecretType.UNSPECIFIED;
                        case "REFRESH_TOKEN":
                            return UserSecretType.REFRESH_TOKEN;
                        case "CUSTOM":
                            return UserSecretType.CUSTOM;
                        case "ACCESS_TOKEN":
                            return UserSecretType.ACCESS_TOKEN;
                    }
                }
            };
        })(UserSecrets1 = Sdk.UserSecrets || (Sdk.UserSecrets = {}));
    })(Sdk1 = Kaggle1.Sdk || (Kaggle1.Sdk = {}));
})(Kaggle || (Kaggle = {}));
export var datasetsClient = {
    datasetDetailService: {
        getDatasetAdminSettings: createClient(Kaggle.Sdk.Datasets.GetDatasetAdminSettingsRequestWireFormat3, Kaggle.Sdk.Datasets.GetDatasetAdminSettingsResponseWireFormat3, "datasets.DatasetDetailService/GetDatasetAdminSettings"),
        getDatasetBasics: createClient(Kaggle.Sdk.Datasets.GetDatasetBasicsRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetBasicsWireFormat3, "datasets.DatasetDetailService/GetDatasetBasics"),
        getDatasetImageInfo: createClient(Kaggle.Sdk.Datasets.GetDatasetImageInfoRequestWireFormat3, Kaggle.Sdk.Datasets.GetDatasetImageInfoResponseWireFormat3, "datasets.DatasetDetailService/GetDatasetImageInfo"),
        getDatasetSettings: createClient(Kaggle.Sdk.Datasets.GetDatasetSettingsRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetSettingsWireFormat3, "datasets.DatasetDetailService/GetDatasetSettings"),
        getDatasetUpvotes: createClient(Kaggle.Sdk.Datasets.GetDatasetUpvotesRequestWireFormat3, Kaggle.Sdk.Datasets.GetDatasetUpvotesResponseWireFormat3, "datasets.DatasetDetailService/GetDatasetUpvotes"),
        getDatasetUsabilityRating: createClient(Kaggle.Sdk.Datasets.GetDatasetUsabilityRatingRequestWireFormat3, Kaggle.Sdk.Datasets.GetDatasetUsabilityRatingResponseWireFormat3, "datasets.DatasetDetailService/GetDatasetUsabilityRating"),
        setDatasetSettings: createClient(Kaggle.Sdk.Datasets.SetDatasetSettingsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetDetailService/SetDatasetSettings"),
        updateDatasetImages: createClient(Kaggle.Sdk.Datasets.UpdateDatasetImagesRequestWireFormat3, Kaggle.Sdk.Datasets.UpdateDatasetImagesResponseWireFormat3, "datasets.DatasetDetailService/UpdateDatasetImages")
    },
    datasetService: {
        addDatasetCategories: createClient(Kaggle.Sdk.Datasets.AddDatasetCategoriesRequestWireFormat3, Kaggle.Sdk.Datasets.AddDatasetCategoriesResponseWireFormat3, "datasets.DatasetService/AddDatasetCategories"),
        attachCompetitionDataset: createClient(Kaggle.Sdk.Datasets.AttachCompetitionDatasetRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/AttachCompetitionDataset"),
        createBigQueryDataset: createClient(Kaggle.Sdk.Datasets.CreateBigQueryDatasetRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetCreationResponseWireFormat3, "datasets.DatasetService/CreateBigQueryDataset"),
        createCompetitionData: createClient(Kaggle.Sdk.Datasets.CreateCompetitionDataRequestWireFormat3, Kaggle.Sdk.Datasets.CreateCompetitionDataResponseWireFormat3, "datasets.DatasetService/CreateCompetitionData"),
        createDataset: createClient(Kaggle.Sdk.Datasets.CreateDatasetRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetCreationResponseWireFormat3, "datasets.DatasetService/CreateDataset"),
        createDatasetHashLink: createClient(Kaggle.Sdk.Datasets.CreateDatasetHashLinkRequestWireFormat3, Kaggle.Sdk.Datasets.CreateDatasetHashLinkResponseWireFormat3, "datasets.DatasetService/CreateDatasetHashLink"),
        createDatasetVersion: createClient(Kaggle.Sdk.Datasets.CreateDatasetVersionRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetCreationResponseWireFormat3, "datasets.DatasetService/CreateDatasetVersion"),
        createDoi: createClient(Kaggle.Sdk.Datasets.CreateDoiRequestWireFormat3, Kaggle.Sdk.Datasets.CreateDoiResponseWireFormat3, "datasets.DatasetService/CreateDoi"),
        createDoiApprover: createClient(Kaggle.Sdk.Datasets.CreateDoiApproverRequestWireFormat3, Kaggle.Sdk.Datasets.CreateDoiApproverResponseWireFormat3, "datasets.DatasetService/CreateDoiApprover"),
        deleteDatasetBySlug: createClient(Kaggle.Sdk.Datasets.DeleteDatasetBySlugRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/DeleteDatasetBySlug"),
        deleteDatasetCategories: createClient(Kaggle.Sdk.Datasets.DeleteDatasetCategoriesRequestWireFormat3, Kaggle.Sdk.Datasets.DeleteDatasetCategoriesResponseWireFormat3, "datasets.DatasetService/DeleteDatasetCategories"),
        deleteDatasetHashLink: createClient(Kaggle.Sdk.Datasets.DeleteDatasetHashLinkRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/DeleteDatasetHashLink"),
        detectDuplicate: createClient(Kaggle.Sdk.Datasets.DetectDuplicateRequestWireFormat3, Kaggle.Sdk.Datasets.DuplicationReferenceWireFormat3, "datasets.DatasetService/DetectDuplicate"),
        editDatasetDescription: createClient(Kaggle.Sdk.Datasets.EditDatasetDescriptionRequestWireFormat3, Kaggle.Sdk.Datasets.EditDatasetDescriptionResponseWireFormat3, "datasets.DatasetService/EditDatasetDescription"),
        getCompetitionUploaderConfig: createClient(Kaggle.Sdk.Datasets.GetCompetitionUploaderConfigRequestWireFormat3, Kaggle.Sdk.Datasets.CompetitionUploaderConfigWireFormat3, "datasets.DatasetService/GetCompetitionUploaderConfig"),
        getDatabundleVersionCreationStatus: createClient(Kaggle.Sdk.Datasets.GetDatabundleVersionCreationStatusRequestWireFormat3, Kaggle.Sdk.Datasets.DatabundleVersionCreationStatusWireFormat3, "datasets.DatasetService/GetDatabundleVersionCreationStatus"),
        getDatasetActivity: createClient(Kaggle.Sdk.Datasets.GetDatasetActivityRequestWireFormat3, Kaggle.Sdk.Datasets.ActivityPageWireFormat3, "datasets.DatasetService/GetDatasetActivity"),
        getDatasetActivityFeed: createClient(Kaggle.Sdk.Datasets.GetDatasetActivityFeedRequestWireFormat3, Kaggle.Sdk.Datasets.GetDatasetActivityFeedResponseWireFormat3, "datasets.DatasetService/GetDatasetActivityFeed"),
        getDatasetByUrl: createClient(Kaggle.Sdk.Datasets.GetDatasetByUrlRequestWireFormat3, Kaggle.Sdk.Datasets.GetDatasetByUrlResponseWireFormat3, "datasets.DatasetService/GetDatasetByUrl"),
        getDatasetHistory: createClient(Kaggle.Sdk.Datasets.GetDatasetHistoryRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetHistoryWireFormat3, "datasets.DatasetService/GetDatasetHistory"),
        getDatasetLimits: createClient(Kaggle.Sdk.Datasets.GetDatasetLimitsRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetLimitsWireFormat3, "datasets.DatasetService/GetDatasetLimits"),
        getDatasetMetadata: createClient(Kaggle.Sdk.Datasets.GetDatasetMetadataRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetMetadataWireFormat3, "datasets.DatasetService/GetDatasetMetadata"),
        getDatasetsById: createClient(Kaggle.Sdk.Datasets.GetDatasetsByIdRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetListWireFormat3, "datasets.DatasetService/GetDatasetsById"),
        getDatasetSuggestions: createClient(Kaggle.Sdk.Datasets.GetDatasetSuggestionsRequestWireFormat3, Kaggle.Sdk.Datasets.GetDatasetSuggestionsResponseWireFormat3, "datasets.DatasetService/GetDatasetSuggestions"),
        getDatasetUploaderConfig: createClient(Kaggle.Sdk.Datasets.GetDatasetUploaderConfigRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetUploaderConfigWireFormat3, "datasets.DatasetService/GetDatasetUploaderConfig"),
        getDataViewExternal: createClient(Kaggle.Sdk.Datasets.GetDataViewExternalRequestWireFormat3, Kaggle.Sdk.Datasets.DataViewer.Protos.GetDataViewResponseWireFormat3, "datasets.DatasetService/GetDataViewExternal"),
        getGithubRepositoryInfo: createClient(Kaggle.Sdk.Datasets.GetGithubRepositoryInfoRequestWireFormat3, Kaggle.Sdk.Datasets.GetGithubRepositoryInfoResponseWireFormat3, "datasets.DatasetService/GetGithubRepositoryInfo"),
        getKernelOutputDataset: createClient(Kaggle.Sdk.Datasets.GetKernelOutputDatasetRequestWireFormat3, Kaggle.Sdk.Datasets.KernelOutputDatasetReferenceWireFormat3, "datasets.DatasetService/GetKernelOutputDataset"),
        getKernelOutputDataViewExternal: createClient(Kaggle.Sdk.Datasets.GetKernelOutputDataViewExternalRequestWireFormat3, Kaggle.Sdk.Datasets.DataViewer.Protos.GetDataViewResponseWireFormat3, "datasets.DatasetService/GetKernelOutputDataViewExternal"),
        getLandingPageTopics: createClient(Kaggle.Sdk.Datasets.GetLandingPageTopicsRequestWireFormat3, Kaggle.Sdk.Datasets.GetLandingPageTopicsResponseWireFormat3, "datasets.DatasetService/GetLandingPageTopics"),
        getPossibleCompetitionDatasets: createClient(Kaggle.Sdk.Datasets.GetPossibleCompetitionDatasetsRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetListWireFormat3, "datasets.DatasetService/GetPossibleCompetitionDatasets"),
        // retrieve counts of the content that the user has created. This is used for display on the User Profile > Dataset tab
        getProfileDatasetStats: createClient(Kaggle.Sdk.Datasets.GetProfileDatasetStatsRequestWireFormat3, Kaggle.Sdk.Datasets.GetProfileDatasetStatsResponseWireFormat3, "datasets.DatasetService/GetProfileDatasetStats"),
        getRecentlyViewedDatasets: createClient(Kaggle.Sdk.Datasets.GetRecentlyViewedDatasetsRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetListWireFormat3, "datasets.DatasetService/GetRecentlyViewedDatasets"),
        getRemoteUrlFileInfo: createClient(Kaggle.Sdk.Datasets.GetRemoteUrlFileInfoRequestWireFormat3, Kaggle.Sdk.Datasets.RemoteUrlUploadFileWireFormat3, "datasets.DatasetService/GetRemoteUrlFileInfo"),
        getTopicalDatasets: createClient(Kaggle.Sdk.Datasets.GetTopicalDatasetsRequestWireFormat3, Kaggle.Sdk.Datasets.GetTopicalDatasetsResponseWireFormat3, "datasets.DatasetService/GetTopicalDatasets"),
        getUserDoiDatasets: createClient(Kaggle.Sdk.Datasets.GetUserDoiDatasetsRequestWireFormat3, Kaggle.Sdk.Datasets.GetUserDoiDatasetsResponseWireFormat3, "datasets.DatasetService/GetUserDoiDatasets"),
        // Sometime the databundle zipper would fail, this give moderator/host to recreate the databundle zip file
        recreateDatasetArchive: createClient(Kaggle.Sdk.Datasets.RecreateDatasetArchiveRequestWireFormat3, Kaggle.Sdk.Datasets.RecreateDatasetArchiveResponseWireFormat3, "datasets.DatasetService/RecreateDatasetArchive"),
        refreshRemoteDataset: createClient(Kaggle.Sdk.Datasets.RefreshRemoteDatasetRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetCreationResponseWireFormat3, "datasets.DatasetService/RefreshRemoteDataset"),
        searchDatasets: createClient(Kaggle.Sdk.Datasets.SearchDatasetsRequestWireFormat3, Kaggle.Sdk.Datasets.SearchDatasetsResponseWireFormat3, "datasets.DatasetService/SearchDatasets"),
        setDatabundleVersionNotes: createClient(Kaggle.Sdk.Datasets.SetDatabundleVersionNotesRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/SetDatabundleVersionNotes"),
        setDatasetChecklistVisibility: createClient(Kaggle.Sdk.Datasets.SetDatasetChecklistVisibilityRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/SetDatasetChecklistVisibility"),
        setDatasetCollaboratorList: createClient(Kaggle.Sdk.Datasets.SetDatasetCollaboratorListRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/SetDatasetCollaboratorList"),
        softDeleteDatasetsForOrg: createClient(Kaggle.Sdk.Datasets.SoftDeleteDatasetsForOrgRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/SoftDeleteDatasetsForOrg"),
        softDeleteDatasetsForUser: createClient(Kaggle.Sdk.Datasets.SoftDeleteDatasetsForUserRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/SoftDeleteDatasetsForUser"),
        undeleteDatasetsForUser: createClient(Kaggle.Sdk.Datasets.UndeleteDatasetsForUserRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/UndeleteDatasetsForUser"),
        updateDataset: createClient(Kaggle.Sdk.Datasets.UpdateDatasetRequestWireFormat3, Kaggle.Sdk.Datasets.UpdateDatasetResponseWireFormat3, "datasets.DatasetService/UpdateDataset"),
        updateDatasetCollaborators: createClient(Kaggle.Sdk.Datasets.UpdateDatasetCollaboratorsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/UpdateDatasetCollaborators"),
        updateDatasetGeneral: createClient(Kaggle.Sdk.Datasets.UpdateDatasetGeneralRequestWireFormat3, Kaggle.Sdk.Datasets.UpdateDatasetGeneralSettingsResponseWireFormat3, "datasets.DatasetService/UpdateDatasetGeneral"),
        updateDatasetMetadata: createClient(Kaggle.Sdk.Datasets.UpdateDatasetMetadataRequestWireFormat3, Kaggle.Sdk.Datasets.DatasetUsabilityRatingWireFormat3, "datasets.DatasetService/UpdateDatasetMetadata"),
        updateDatasetPrivacy: createClient(Kaggle.Sdk.Datasets.UpdateDatasetPrivacyRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/UpdateDatasetPrivacy"),
        voteOnDataset: createClient(Kaggle.Sdk.Datasets.VoteOnDatasetRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/VoteOnDataset")
    }
};
export var kernelsClient = {
    kernelsService: {
        acceptKernelCompetitionRules: createClient(Kaggle.Sdk.Kernels.AcceptKernelCompetitionRulesRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/AcceptKernelCompetitionRules"),
        addKernelCategory: createClient(Kaggle.Sdk.Kernels.AddKernelCategoryRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/AddKernelCategory"),
        batchAutoTagKernels: createClient(Kaggle.Sdk.Kernels.BatchAutoTagKernelsRequestWireFormat3, Kaggle.Sdk.Kernels.BatchAutoTagKernelsResponseWireFormat3, "kernels.KernelsService/BatchAutoTagKernels"),
        cancelKernelSession: createClient(Kaggle.Sdk.Kernels.CancelKernelSessionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/CancelKernelSession"),
        clearPinnedKernelSession: createClient(Kaggle.Sdk.Kernels.ClearPinnedKernelSessionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/ClearPinnedKernelSession"),
        commitAndRun: createClient(Kaggle.Sdk.Kernels.CommitAndRunRequestWireFormat3, Kaggle.Sdk.Kernels.CommitAndRunResponseWireFormat3, "kernels.KernelsService/CommitAndRun"),
        completeQuickSession: createClient(Kaggle.Sdk.Kernels.CompleteQuickSessionRequestWireFormat3, Kaggle.Sdk.Kernels.CompleteQuickSessionResponseWireFormat3, "kernels.KernelsService/CompleteQuickSession"),
        computeKernelDiff: createClient(Kaggle.Sdk.Kernels.ComputeKernelDiffRequestWireFormat3, Kaggle.Sdk.Kernels.ComputeKernelDiffResponseWireFormat3, "kernels.KernelsService/ComputeKernelDiff"),
        createKernelSession: createClient(Kaggle.Sdk.Kernels.CreateKernelSessionRequestWireFormat3, Kaggle.Sdk.Kernels.CreateKernelSessionResponseWireFormat3, "kernels.KernelsService/CreateKernelSession"),
        createKernelUpvote: createClient(Kaggle.Sdk.Kernels.CreateKernelUpvoteRequestWireFormat3, Kaggle.Sdk.Kernels.CreateKernelUpvoteResponseWireFormat3, "kernels.KernelsService/CreateKernelUpvote"),
        createKernelWithSettings: createClient(Kaggle.Sdk.Kernels.CreateKernelWithSettingsRequestWireFormat3, Kaggle.Sdk.Kernels.CreateKernelWithSettingsResponseWireFormat3, "kernels.KernelsService/CreateKernelWithSettings"),
        createSnippet: createClient(Kaggle.Sdk.Kernels.CreateSnippetRequestWireFormat3, Kaggle.Sdk.Kernels.CreateSnippetResponseWireFormat3, "kernels.KernelsService/CreateSnippet"),
        deleteKernel: createClient(Kaggle.Sdk.Kernels.DeleteKernelRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/DeleteKernel"),
        deleteKernelUpvote: createClient(Kaggle.Sdk.Kernels.DeleteKernelUpvoteRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/DeleteKernelUpvote"),
        deleteScheduledKernelSession: createClient(Kaggle.Sdk.Kernels.DeleteScheduledKernelSessionRequestWireFormat3, Kaggle.Sdk.Kernels.DeleteScheduledKernelSessionResponseWireFormat3, "kernels.KernelsService/DeleteScheduledKernelSession"),
        deleteSnippet: createClient(Kaggle.Sdk.Kernels.DeleteSnippetRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/DeleteSnippet"),
        exportKernelRunForCaip: createClient(Kaggle.Sdk.Kernels.ExportKernelRunForCaipRequestWireFormat3, Kaggle.Sdk.Kernels.ExportKernelRunForCaipResponseWireFormat3, "kernels.KernelsService/ExportKernelRunForCaip"),
        fetchExternalKernelContent: createClient(Kaggle.Sdk.Kernels.FetchExternalKernelContentRequestWireFormat3, Kaggle.Sdk.Kernels.FetchExternalKernelContentResponseWireFormat3, "kernels.KernelsService/FetchExternalKernelContent"),
        fetchGitHubContent: createClient(Kaggle.Sdk.Kernels.FetchGitHubContentRequestWireFormat3, Kaggle.Sdk.Kernels.FetchGitHubContentResponseWireFormat3, "kernels.KernelsService/FetchGitHubContent"),
        getAcceleratorQuotaStatistics: createClient(Kaggle.Sdk.Kernels.GetAcceleratorQuotaStatisticsRequestWireFormat3, Kaggle.Sdk.Kernels.GetAcceleratorQuotaStatisticsResponseWireFormat3, "kernels.KernelsService/GetAcceleratorQuotaStatistics"),
        getCompetitionsPaneInfo: createClient(Kaggle.Sdk.Kernels.GetCompetitionsPaneInfoRequestWireFormat3, Kaggle.Sdk.Kernels.GetCompetitionsPaneInfoResponseWireFormat3, "kernels.KernelsService/GetCompetitionsPaneInfo"),
        getDefaultSessionSettings: createClient(Kaggle.Sdk.Kernels.GetDefaultSessionSettingsRequestWireFormat3, Kaggle.Sdk.Kernels.DefaultSessionSettingsWireFormat3, "kernels.KernelsService/GetDefaultSessionSettings"),
        getDeletedKernel: createClient(Kaggle.Sdk.Kernels.GetDeletedKernelRequestWireFormat3, Kaggle.Sdk.Kernels.GetDeletedKernelResponseWireFormat3, "kernels.KernelsService/GetDeletedKernel"),
        getFirebaseAuthToken: createClient(Kaggle.Sdk.Kernels.GetFirebaseAuthTokenRequestWireFormat3, Kaggle.Sdk.Kernels.GetFirebaseAuthTokenResponseWireFormat3, "kernels.KernelsService/GetFirebaseAuthToken"),
        getFirebaseConfig: createClient(Kaggle.Sdk.Kernels.GetFirebaseConfigRequestWireFormat3, Kaggle.Sdk.Kernels.GetFirebaseConfigResponseWireFormat3, "kernels.KernelsService/GetFirebaseConfig"),
        getKernel: createClient(Kaggle.Sdk.Kernels.GetKernelRequestWireFormat3, Kaggle.Sdk.Kernels.KernelWireFormat3, "kernels.KernelsService/GetKernel"),
        getKernelCategoryIds: createClient(Kaggle.Sdk.Kernels.GetKernelCategoryIdsRequestWireFormat3, Kaggle.Sdk.Kernels.KernelCategoryIdListWireFormat3, "kernels.KernelsService/GetKernelCategoryIds"),
        getKernelCollaboratorList: createClient(Kaggle.Sdk.Kernels.GetKernelCollaboratorListRequestWireFormat3, Kaggle.Sdk.Kernels.GetKernelCollaboratorListResponseWireFormat3, "kernels.KernelsService/GetKernelCollaboratorList"),
        getKernelGitHubSettings: createClient(Kaggle.Sdk.Kernels.GetKernelGitHubSettingsRequestWireFormat3, Kaggle.Sdk.Kernels.GetKernelGitHubSettingsResponseWireFormat3, "kernels.KernelsService/GetKernelGitHubSettings"),
        getKernelLandingPage: createClient(Kaggle.Sdk.Kernels.GetKernelLandingPageRequestWireFormat3, Kaggle.Sdk.Kernels.GetKernelLandingPageResponseWireFormat3, "kernels.KernelsService/GetKernelLandingPage"),
        getKernelListDetails: createClient(Kaggle.Sdk.Kernels.GetKernelListDetailsRequestWireFormat3, Kaggle.Sdk.Kernels.KernelListWireFormat3, "kernels.KernelsService/GetKernelListDetails"),
        getKernelRunSource: createClient(Kaggle.Sdk.Kernels.GetKernelRunSourceRequestWireFormat3, Kaggle.Sdk.Kernels.GetKernelRunSourceResponseWireFormat3, "kernels.KernelsService/GetKernelRunSource"),
        getKernelSessionDataSources: createClient(Kaggle.Sdk.Kernels.GetKernelSessionDataSourcesRequestWireFormat3, Kaggle.Sdk.Kernels.GetKernelSessionDataSourcesResponseWireFormat3, "kernels.KernelsService/GetKernelSessionDataSources"),
        getKernelStatus: createClient(Kaggle.Sdk.Kernels.GetKernelStatusRequestWireFormat3, Kaggle.Sdk.Kernels.GetKernelStatusResponseWireFormat3, "kernels.KernelsService/GetKernelStatus"),
        getKernelVersion: createClient(Kaggle.Sdk.Kernels.GetKernelVersionRequestWireFormat3, Kaggle.Sdk.Kernels.GetKernelVersionResponseWireFormat3, "kernels.KernelsService/GetKernelVersion"),
        getOrCreateKernelSession: createClient(Kaggle.Sdk.Kernels.GetOrCreateKernelSessionRequestWireFormat3, Kaggle.Sdk.Kernels.GetOrCreateKernelSessionResponseWireFormat3, "kernels.KernelsService/GetOrCreateKernelSession"),
        getScheduledKernelSession: createClient(Kaggle.Sdk.Kernels.GetScheduledKernelSessionRequestWireFormat3, Kaggle.Sdk.Kernels.GetScheduledKernelSessionResponseWireFormat3, "kernels.KernelsService/GetScheduledKernelSession"),
        getSourceIndexData: createClient(Kaggle.Sdk.Kernels.GetSourceIndexDataRequestWireFormat3, Kaggle.Sdk.Kernels.GetSourceIndexDataResponseWireFormat3, "kernels.KernelsService/GetSourceIndexData"),
        getUserKernelAchievements: createClient(Kaggle.Sdk.Kernels.GetUserKernelAchievementsRequestWireFormat3, Kaggle.Sdk.Kernels.GetUserKernelAchievementsResponseWireFormat3, "kernels.KernelsService/GetUserKernelAchievements"),
        hasAcceptedKernelCompetitionRules: createClient(Kaggle.Sdk.Kernels.HasAcceptedKernelCompetitionRulesRequestWireFormat3, Kaggle.Sdk.Kernels.HasAcceptedKernelCompetitionRulesResponseWireFormat3, "kernels.KernelsService/HasAcceptedKernelCompetitionRules"),
        indexAllSnippets: createClient(Kaggle.Sdk.Kernels.IndexAllSnippetsRequestWireFormat3, Kaggle.Sdk.Kernels.IndexAllSnippetsResponseWireFormat3, "kernels.KernelsService/IndexAllSnippets"),
        listDockerImages: createClient(Kaggle.Sdk.Kernels.ListDockerImagesRequestWireFormat3, Kaggle.Sdk.Kernels.DockerImageVersionDetailsListWireFormat3, "kernels.KernelsService/ListDockerImages"),
        listGithubRepositories: createClient(Kaggle.Sdk.Kernels.ListGithubRepositoriesRequestWireFormat3, Kaggle.Sdk.Kernels.ListGithubRepositoriesResponseWireFormat3, "kernels.KernelsService/ListGithubRepositories"),
        listGithubRepositoryBranches: createClient(Kaggle.Sdk.Kernels.ListGithubRepositoryBranchesRequestWireFormat3, Kaggle.Sdk.Kernels.ListGithubRepositoryBranchesResponseWireFormat3, "kernels.KernelsService/ListGithubRepositoryBranches"),
        listGithubRepositoryFiles: createClient(Kaggle.Sdk.Kernels.ListGithubRepositoryFilesRequestWireFormat3, Kaggle.Sdk.Kernels.ListGithubRepositoryFilesResponseWireFormat3, "kernels.KernelsService/ListGithubRepositoryFiles"),
        listKernelIds: createClient(Kaggle.Sdk.Kernels.ListKernelIdsRequestWireFormat3, Kaggle.Sdk.Kernels.ListKernelIdsResponseWireFormat3, "kernels.KernelsService/ListKernelIds"),
        listKernelRunLogs: createClient(Kaggle.Sdk.Kernels.ListKernelRunLogsRequestWireFormat3, Kaggle.Sdk.Kernels.ListKernelRunLogsResponseWireFormat3, "kernels.KernelsService/ListKernelRunLogs"),
        listKernels: createClient(Kaggle.Sdk.Kernels.ListKernelsRequestWireFormat3, Kaggle.Sdk.Kernels.KernelListWireFormat3, "kernels.KernelsService/ListKernels"),
        listKernelSessionOutput: createClient(Kaggle.Sdk.Kernels.ListKernelSessionOutputRequestWireFormat3, Kaggle.Sdk.Kernels.ListKernelSessionOutputResponseWireFormat3, "kernels.KernelsService/ListKernelSessionOutput"),
        listKernelSessionOutputFilesHierarchical: createClient(Kaggle.Sdk.Kernels.ListKernelSessionOutputFilesHierarchicalRequestWireFormat3, Kaggle.Sdk.Kernels.ListKernelSessionOutputFilesHierarchicalResponseWireFormat3, "kernels.KernelsService/ListKernelSessionOutputFilesHierarchical"),
        listKernelSessions: createClient(Kaggle.Sdk.Kernels.ListKernelSessionsRequestWireFormat3, Kaggle.Sdk.Kernels.KernelSessionListWireFormat3, "kernels.KernelsService/ListKernelSessions"),
        listKernelVersions: createClient(Kaggle.Sdk.Kernels.ListKernelVersionsRequestWireFormat3, Kaggle.Sdk.Kernels.KernelVersionListWireFormat3, "kernels.KernelsService/ListKernelVersions"),
        listSnippets: createClient(Kaggle.Sdk.Kernels.ListSnippetsRequestWireFormat3, Kaggle.Sdk.Kernels.ListSnippetsResponseWireFormat3, "kernels.KernelsService/ListSnippets"),
        removeKernelCategory: createClient(Kaggle.Sdk.Kernels.RemoveKernelCategoryRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/RemoveKernelCategory"),
        runEpisode: createClient(Kaggle.Sdk.Kernels.RunEpisodeRequestWireFormat3, Kaggle.Sdk.Kernels.RunEpisodeResponseWireFormat3, "kernels.KernelsService/RunEpisode"),
        scheduleKernelSession: createClient(Kaggle.Sdk.Kernels.ScheduleKernelSessionRequestWireFormat3, Kaggle.Sdk.Kernels.ScheduledKernelSessionWireFormat3, "kernels.KernelsService/ScheduleKernelSession"),
        searchKernelIds: createClient(Kaggle.Sdk.Kernels.SearchKernelIdsRequestWireFormat3, Kaggle.Sdk.Kernels.SearchKernelIdsResponseWireFormat3, "kernels.KernelsService/SearchKernelIds"),
        updateDefaultSessionSettings: createClient(Kaggle.Sdk.Kernels.UpdateDefaultSessionSettingsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateDefaultSessionSettings"),
        updateDockerImageVersion: createClient(Kaggle.Sdk.Kernels.UpdateDockerImageVersionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateDockerImageVersion"),
        updateDockerPinningType: createClient(Kaggle.Sdk.Kernels.UpdateDockerPinningTypeRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateDockerPinningType"),
        updateKernelCollaborators: createClient(Kaggle.Sdk.Kernels.UpdateKernelCollaboratorsRequestWireFormat3, Kaggle.Sdk.Kernels.UpdateKernelCollaboratorsResponseWireFormat3, "kernels.KernelsService/UpdateKernelCollaborators"),
        updateKernelDraft: createClient(Kaggle.Sdk.Kernels.UpdateKernelDraftRequestWireFormat3, Kaggle.Sdk.Kernels.UpdateKernelDraftResponseWireFormat3, "kernels.KernelsService/UpdateKernelDraft"),
        updateKernelOutputToDataset: createClient(Kaggle.Sdk.Kernels.UpdateKernelOutputToDatasetRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateKernelOutputToDataset"),
        updateKernelPrivacy: createClient(Kaggle.Sdk.Kernels.UpdateKernelPrivacyRequestWireFormat3, Kaggle.Sdk.Kernels.UpdateKernelPrivacyResponseWireFormat3, "kernels.KernelsService/UpdateKernelPrivacy"),
        updateKernelRunDataSources: createClient(Kaggle.Sdk.Kernels.UpdateKernelRunDataSourcesRequestWireFormat3, Kaggle.Sdk.Kernels.UpdateKernelRunDataSourcesResponseWireFormat3, "kernels.KernelsService/UpdateKernelRunDataSources"),
        updateKernelSession: createClient(Kaggle.Sdk.Kernels.UpdateKernelSessionRequestWireFormat3, Kaggle.Sdk.Kernels.UpdateKernelSessionResponseWireFormat3, "kernels.KernelsService/UpdateKernelSession"),
        updateKernelSessionKeepalive: createClient(Kaggle.Sdk.Kernels.UpdateKernelSessionKeepaliveRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateKernelSessionKeepalive"),
        updateKernelTitle: createClient(Kaggle.Sdk.Kernels.UpdateKernelTitleRequestWireFormat3, Kaggle.Sdk.Kernels.UpdateKernelTitleResponseWireFormat3, "kernels.KernelsService/UpdateKernelTitle"),
        updateKernelVersionName: createClient(Kaggle.Sdk.Kernels.UpdateKernelVersionNameRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateKernelVersionName"),
        updatePinnedKernelSession: createClient(Kaggle.Sdk.Kernels.UpdatePinnedKernelSessionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdatePinnedKernelSession"),
        updateSnippet: createClient(Kaggle.Sdk.Kernels.UpdateSnippetRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateSnippet"),
        updateUserKernelFirestoreAuth: createClient(Kaggle.Sdk.Kernels.UpdateUserKernelFirestoreAuthRequestWireFormat3, Kaggle.Sdk.Kernels.UpdateUserKernelFirestoreAuthResponseWireFormat3, "kernels.KernelsService/UpdateUserKernelFirestoreAuth"),
        uploadKernelSessionOutput: createClient(Kaggle.Sdk.Kernels.UploadKernelSessionOutputRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UploadKernelSessionOutput")
    }
};
export var searchClient = {
    searchWebService: {
        fullSearchWeb: createClient(Kaggle.Sdk.Search.Protos.FullSearchWebRequestWireFormat3, Kaggle.Sdk.Search.Protos.FullSearchResponseWireFormat3, "search.SearchWebService/FullSearchWeb"),
        getAutoCompleteSuggestions: createClient(Kaggle.Sdk.Search.Protos.GetAutoCompleteSuggestionsRequestWireFormat3, Kaggle.Sdk.Search.Protos.GetAutoCompleteSuggestionsResponseWireFormat3, "search.SearchWebService/GetAutoCompleteSuggestions"),
        getPopularTags: createClient(Kaggle.Sdk.Search.Protos.GetPopularTagsRequestWireFormat3, Kaggle.Sdk.Search.Protos.GetPopularTagsResponseWireFormat3, "search.SearchWebService/GetPopularTags"),
        getRecentSearches: createClient(Kaggle.Sdk.Search.Protos.GetRecentSearchesRequestWireFormat3, Kaggle.Sdk.Search.Protos.GetRecentSearchesResponseWireFormat3, "search.SearchWebService/GetRecentSearches"),
        getTrendingSearches: createClient(Kaggle.Sdk.Search.Protos.GetTrendingSearchesRequestWireFormat3, Kaggle.Sdk.Search.Protos.GetTrendingSearchesResponseWireFormat3, "search.SearchWebService/GetTrendingSearches"),
        logSearch: createClient(Kaggle.Sdk.Search.Protos.LogSearchRequestWireFormat3, google.protobuf.EmptyWireFormat3, "search.SearchWebService/LogSearch"),
        suggestedSearchWeb: createClient(Kaggle.Sdk.Search.Protos.SuggestedSearchWebRequestWireFormat3, Kaggle.Sdk.Search.Protos.SuggestedSearchResponseWireFormat3, "search.SearchWebService/SuggestedSearchWeb"),
        timeSpentOnClickedResult: createClient(Kaggle.Sdk.Search.Protos.TimeSpentOnClickedResultRequestWireFormat3, google.protobuf.EmptyWireFormat3, "search.SearchWebService/TimeSpentOnClickedResult")
    }
};
export var tagsClient = {
    tagService: {
        // Tag a given competition with one or many tags
        createCompetitionTags: createClient(Kaggle.Sdk.Tags.CreateCompetitionTagsRequestWireFormat3, Kaggle.Sdk.Tags.CreateCompetitionTagsResponseWireFormat3, "tags.TagService/CreateCompetitionTags"),
        // Tag a given learn track with one or many tags
        createLearnTrackTags: createClient(Kaggle.Sdk.Tags.CreateLearnTrackTagsRequestWireFormat3, Kaggle.Sdk.Tags.CreateLearnTrackTagsResponseWireFormat3, "tags.TagService/CreateLearnTrackTags"),
        createTag: createClient(Kaggle.Sdk.Tags.CreateTagRequestWireFormat3, google.protobuf.EmptyWireFormat3, "tags.TagService/CreateTag"),
        // Untag a given competition, removing one or many tags
        deleteCompetitionTags: createClient(Kaggle.Sdk.Tags.DeleteCompetitionTagsRequestWireFormat3, Kaggle.Sdk.Tags.DeleteCompetitionTagsResponseWireFormat3, "tags.TagService/DeleteCompetitionTags"),
        // Untag a given learn track, removing one or many tags
        deleteLearnTrackTags: createClient(Kaggle.Sdk.Tags.DeleteLearnTrackTagsRequestWireFormat3, Kaggle.Sdk.Tags.DeleteLearnTrackTagsResponseWireFormat3, "tags.TagService/DeleteLearnTrackTags"),
        // Fetch the hierarchical structure of all tags
        getTagHierarchy: createClient(Kaggle.Sdk.Tags.GetTagHierarchyRequestWireFormat3, Kaggle.Sdk.Tags.GetTagHierarchyResponseWireFormat3, "tags.TagService/GetTagHierarchy"),
        getTagsById: createClient(Kaggle.Sdk.Tags.GetTagsByIdRequestWireFormat3, Kaggle.Sdk.Tags.TagListWireFormat3, "tags.TagService/GetTagsById"),
        listTags: createClient(Kaggle.Sdk.Tags.ListTagsRequestWireFormat3, Kaggle.Sdk.Tags.ListTagsResponseWireFormat3, "tags.TagService/ListTags"),
        searchTags: createClient(Kaggle.Sdk.Tags.SearchTagsRequestWireFormat3, Kaggle.Sdk.Tags.TagListWireFormat3, "tags.TagService/SearchTags"),
        searchTagsLegacy: createClient(Kaggle.Sdk.Tags.SearchTagsLegacyRequestWireFormat3, Kaggle.Sdk.Tags.SearchTagsLegacyResponseWireFormat3, "tags.TagService/SearchTagsLegacy"),
        // Tag a given forum topic with one or many tags, removing any tags not specified in the request
        updateForumTopicTags: createClient(Kaggle.Sdk.Tags.UpdateForumTopicTagsRequestWireFormat3, Kaggle.Sdk.Tags.UpdateForumTopicTagsResponseWireFormat3, "tags.TagService/UpdateForumTopicTags")
    }
};
export var userSecretsClient = {
    userSecretsService: {
        addSecretKernelAttachment: createClient(Kaggle.Sdk.UserSecrets.AddSecretKernelAttachmentRequestWireFormat3, Kaggle.Sdk.UserSecrets.UserSecretKernelAttachmentMetadataWireFormat3, "user_secrets.UserSecretsService/AddSecretKernelAttachment"),
        deleteSecretKernelAttachment: createClient(Kaggle.Sdk.UserSecrets.DeleteSecretKernelAttachmentRequestWireFormat3, google.protobuf.EmptyWireFormat3, "user_secrets.UserSecretsService/DeleteSecretKernelAttachment"),
        deleteUserSecret: createClient(Kaggle.Sdk.UserSecrets.DeleteUserSecretRequestWireFormat3, Kaggle.Sdk.UserSecrets.DeleteUserSecretResponseWireFormat3, "user_secrets.UserSecretsService/DeleteUserSecret"),
        exchangeGcloudAuthorizationCode: createClient(Kaggle.Sdk.UserSecrets.ExchangeGcloudAuthorizationCodeRequestWireFormat3, Kaggle.Sdk.UserSecrets.UserSecretMetadataWireFormat3, "user_secrets.UserSecretsService/ExchangeGcloudAuthorizationCode"),
        getGitHubAccessInfo: createClient(Kaggle.Sdk.UserSecrets.GetGitHubAccessInfoRequestWireFormat3, Kaggle.Sdk.UserSecrets.GetGitHubAccessInfoResponseWireFormat3, "user_secrets.UserSecretsService/GetGitHubAccessInfo"),
        getUserSecretByLabel: createClient(Kaggle.Sdk.UserSecrets.GetUserSecretByLabelRequestWireFormat3, Kaggle.Sdk.UserSecrets.GetUserSecretResponseWireFormat3, "user_secrets.UserSecretsService/GetUserSecretByLabel"),
        listKernelSecretsMetadata: createClient(Kaggle.Sdk.UserSecrets.ListKernelSecretsMetadataRequestWireFormat3, Kaggle.Sdk.UserSecrets.ListKernelSecretsMetadataResponseWireFormat3, "user_secrets.UserSecretsService/ListKernelSecretsMetadata"),
        listKernelsWithSecret: createClient(Kaggle.Sdk.UserSecrets.ListKernelsWithSecretRequestWireFormat3, Kaggle.Sdk.UserSecrets.ListKernelsWithSecretResponseWireFormat3, "user_secrets.UserSecretsService/ListKernelsWithSecret"),
        listUserSecretsMetadata: createClient(Kaggle.Sdk.UserSecrets.ListUserSecretsMetadataRequestWireFormat3, Kaggle.Sdk.UserSecrets.ListUserSecretsMetadataResponseWireFormat3, "user_secrets.UserSecretsService/ListUserSecretsMetadata"),
        upsertCustomUserSecret: createClient(Kaggle.Sdk.UserSecrets.UpsertCustomUserSecretRequestWireFormat3, Kaggle.Sdk.UserSecrets.UserSecretMetadataWireFormat3, "user_secrets.UserSecretsService/UpsertCustomUserSecret")
    }
};
